import { helpEn } from "./help.en";

export const languageEnglish = {
    cbsEditor: {
        logic: { OR: 'OR', AND: 'AND', NOT: 'NOT' },
        on: 'On', off: 'Off',
        variables: 'Variables',
        showVariables: 'Show variable sidebar',
        hideVariables: 'Hide variable sidebar',
        resizeVariables: 'Resize variable sidebar',
        variableHelp: 'Discover static CBS names in this text. Observed comparison/assignment values are suggestions, not declarations. Dynamic Lua/JavaScript variable names are not inferred.',
        target: 'Variable save target',
        targetHelp: 'Chat values override character defaults, then prompt defaults. Changes are saved only with the check button or Enter; the condition source is not changed.',
        currentChat: 'This chat',
        characterDefault: 'Character default',
        templateDefault: 'Prompt default',
        allVariables: 'All variables',
        searchVariables: 'Find variable',
        applyVariable: 'Apply value',
        saveFailed: 'Could not save. Default names/values cannot contain line breaks or =. The original owner must still be available.',
        observedValues: 'Values observed in the source; other values are also allowed.',
        noVariables: 'No variables found',
        origins: { chat: 'Saved in this chat', character: 'Character default', template: 'Prompt default', unset: 'Not set' },
        source: 'Source',
        view: 'Conditions',
        description: 'All branches are shown without running CBS. Edit the text below each condition; the original syntax is preserved.',
        condition: 'IF',
        otherwise: 'ELSE',
        end: 'End condition',
        body: 'Text block',
        showSource: 'Show original condition',
        editSource: 'Switch to Source to edit the condition itself.',
        cutCondition: 'Cut condition block',
        deleteCondition: 'Delete condition block',
        fallback: 'These blocks could not be safely separated. The complete source is shown without changes.',
        unsupportedExpression: 'This condition could not be fully rendered in readable form. Its source is preserved without changes.',
        extraArguments: '{name} has {actual} arguments, but the current engine only uses the first {expected}. The original has not been changed.',
    },
    formating: {
        main: "Main Prompt",
        jailbreak: "Jailbreak Prompt",
        chats: "Past Chats",
        lorebook: "Lorebook",
        globalNote: "Global Note",
        authorNote: "Author's Note",
        lastChat: "Last Chat",
        description: "Character Description",
        personaPrompt: "Persona Prompt",
        plain: "Plain Prompt",
        memory: "Supa/HypaMemory",
        postEverything: "End-Injected Prompts",
    },
    errors: {
        toomuchtoken: "Error: The minimum required token is greater than the Max Context Size.",
        unknownModel: "Error: Unknown model selected",
        httpError: "Error: error in request:",
        noData: "The file is invalid, or its data is corrupted.",
        onlyOneChat: "There must be least one chat",
        onlyOnePreset: "There must be at least one preset",
        noUserIcon: "You must set your icon first.",
        emptyText: "Text is empty.",
        wrongPassword: "Wrong Password",
        coldStorageWriteFailed: "Cold storage write failed. Your chat data has been preserved.",
        coldStorageVerifyFailed: "Cold storage verification failed. Your chat data has been preserved.",
        vertexAuthError: "Vertex AI authentication details are missing.",
        networkFetch: "This happens when the network is unstable or the server is down.",
        networkFetchWeb:
            "This can be a CORS error. this only happens when using web version due to limitations of the browser. try using desktop local version, or other version of RisuBard.",
        networkFetchPlain: "This can be a plain fetch error. try disabling force plain fetch option in settings.",
        requestLogRemoved: "This request log is removed.",
        requestLogRemovedDesc: "This request log removes when client is refreshed or reloaded.",
        persistFailureTitle: "Server save failed — changes are not being written to disk",
        persistFailureAttemptedSize: "attempted size",
        chatGuardTitle: "Chat data guard triggered — switched to safe save mode",
        chatGuardDesc: "Suspicious save patterns blocked. Your changes will be persisted via the safe full-write fallback. If this keeps happening, please report it with browser console logs.",
        chatGuardPersistTitle: "Save aborted to protect existing chat data",
        backgroundGenerationFailed: "Background generation failed ({char}): {error}",
        modelJobBusy: "This chat is still generating on the server. It will fill in automatically when it finishes — please wait a moment.",
        modelJobConnectionLost: "The connection dropped, but the server is still generating. It will resume automatically when you come back — no need to send again.",
        chatGuardPersistDesc: "Server detected corrupted chat structure mid-persist and refused to write to disk. Your latest changes may NOT be on disk yet — re-verify before refreshing. Existing data is safe.",
    },
    showHelp: "Show Help",
    help: helpEn,
    setup: {
        chooseProvider: "Choose AI Provider",
        openaikey: "OpenAI with API Key (Recommended)",
        openaiProxy: "OpenAI Reverse proxy",
        setupmodelself: "Others / I will setup myself",
        inputApiKey: "Input API Key Here",
        apiKeyhelp: "You can get api key from: ",
        setupSelfHelp: "Setup yourself in settings, after Welcome screen ends.",
        theme: "Select your theme",
        themeDescWifulike: "Not suitable for mobile",
        themeDescWifuCut: "Suitable for mobile",
        themeDescClassic: "Suitable for All devices",
        texttheme: "Select your text color",
        inputName: "Lastly, Input your Nickname.",
        welcome: "Welcome to RisuBard! I am Airisu, I am here guide you to setup RisuBard. First, What may I call you?",
        welcome2: "Hello {username}! before we start, I will ask you some questions. You can change these settings later in settings.\n\nFirst select the AI provider.",
        openRouterProvider: "OpenRouter has a lot of models, some of them unfiltered and some of them free, but it is not as good as OpenAI.",
        hordeProvider: "Horde is a free provider, but the response time is long and the quality is low.",
        setProviderLater: "There are other providers, but you can set it later in settings. select this if you want to set it later.",
        setupOpenAI:
            "To use OpenAI, you need to get an API key. \n1. go to https://beta.openai.com/ \n2. login with your account \n3. go to https://beta.openai.com/account/api-keys \n4. click 'Create New API Key' and name your key whatever you want. \n5. copy the key in the website.\n6. go back to RisuBard\n7. paste it, and click send button.",
        setupClaude: "To use Claude, you need to get an API key.",
        setupClaudeSteps: [
            "Go to this URL and Login as Google",
            "Input your information and click 'Continue'",
            "On organization page, just input any name only at the first box, and click 'Create Account'",
            "Press 'Buy Credits' button",
            "Press 'Complete Setup' button",
            "Input just like the image above, except the country section, which you need to input your country. then press 'Continue'",
            "Add your payment method and press 'Continue'",
            "After payment has been registered, press 'Add Funds' and add funds. you can add minimum 5$, or you can setup auto add reload.",
            "After adding funds, go to the dashboard page and press 'Get API Keys' button",
            'Press "Create API Key" button',
            "Input just like the image above, and press 'Add'",
            "Copy the key, and paste it in here and send it.",
        ],
        setupOpenRouter:
            "To use OpenRouter, you need to get an API key. \n1. go to https://openrouter.ai/keys\n2. click 'Create Key'\n3. set key name whatever you want.\n4. copy the key in the website\n5. go back to RisuBard\n6. paste it, and click send button.",
        allDone: "All Done! please wait a moment.",
        setupLaterMessage: "Welcome {username}! do you want me to guide you to setup or do it yourself?",
        setupMessageOption1: "Guide me to setup",
        setupMessageOption1Desc: "Recommended for new users",
        setupMessageOption2: "I will setup myself",
        claudeDesc: "Claude is a AI model made by Antropic, competitor to OpenAI. its better than GPT if you want to use it in other languages than English.",
        openAIDesc: "OpenAI GPT is a high quality AI model, but it is paid and filtered, and weak in other than English.",
        chooseChatType: "Great! Now select the chat language.",
        chooseChatTypeOption1: "Full English",
        chooseChatTypeOption1Desc: "This will make AI to use English and input/output in English. Recommended for English speakers.",
        chooseChatTypeOption2: "English Processing",
        chooseChatTypeOption2Desc: "This will make AI to use English internaly, but input/output will be in your language. Recommended for non-English speakers.",
        chooseChatTypeOption3: "No Language Focused",
        chooseChatTypeOption3Desc: "This will make AI to use your language internaly, but this could make quality lower.",
        chooseCheapOrMemory: "By the way, do you prefer memory or cheapness?",
        chooseCheapOrMemoryOption1: "Memory",
        chooseCheapOrMemoryOption1Desc: "This will make AI to remember more, but it will quite expensive.",
        chooseCheapOrMemoryOption2: "Cheap",
        chooseCheapOrMemoryOption2Desc: "This will make AI to remember less, but it will be cheaper.",
        chooseCheapOrMemoryOption3: "Balanced",
        chooseCheapOrMemoryOption3Desc: "This will make AI to remember more than cheap, but less than memory.",
        chooseCheapOrMemoryOption4: "Unlimited",
        chooseCheapOrMemoryOption4Desc: "This will make AI to remember almost everything, but it will be very expensive.",
        finally: "Finally, do you want to enable advanced tools?",
        finallyOption1: "Yes",
        finallyOption1Desc: "This will enable advanced tools, but it will make the UI more complex. Recommended for advanced users.",
        finallyOption2: "No",
        finallyOption2Desc: "This will disable advanced tools, and make the UI more simple. Recommended for new users.",
        igpPrompt:
            "if IGP Prompt is not a blank, it will be executed after the main model request, after main model execution, as a emotion model, adding the result after the main model response.",
    },
    triggerCategories: {
        Special: "Special",
        Control: "Control",
        Chat: "Chat",
        "Low Level": "Low Level",
        Alert: "Alert",
        "Lorebook V2": "Lorebook V2",
        String: "String",
        Data: "Data",
        Array: "Array",
        Others: "Others",
        Deprecated: "Deprecated",
    },
    triggerDesc: {
        v2Header: "Header",
        v2HeaderDesc: "Header",
        v2If: "If",
        v2IfDesc: "If {{source}} {{condition}} {{target}}",
        v2Else: "Else",
        v2ElseDesc: "Else",
        v2EndIndent: "End Indent",
        v2EndIndentDesc: "End Indent",
        v2SetVar: "Set Variable",
        v2SetVarDesc: "Set Variable {{var}} {{operator}} {{value}}",
        v2Loop: "Loop Forever",
        v2LoopDesc: "Loop Forever",
        v2BreakLoop: "Break Loop",
        v2BreakLoopDesc: "Break Loop",
        v2RunTrigger: "Run Trigger",
        v2RunTriggerDesc: "Run Trigger {{target}}",
        v2ConsoleLog: "Console Log",
        v2ConsoleLogDesc: "Console Log {{source}}",
        v2StopTrigger: "Stop Trigger",
        v2StopTriggerDesc: "Stop Trigger",
        v2CutChat: "Cut Chat",
        v2CutChatDesc: "Cut Chat from {{start}} to {{end}}",
        v2ModifyChat: "Modify Chat",
        v2ModifyChatDesc: "Modify Chat at index {{index}} with {{value}}",
        v2SystemPrompt: "Add System Prompt",
        v2SystemPromptDesc: "Add System Prompt at {{location}} with {{value}}",
        v2Impersonate: "Send Chat",
        v2ImpersonateDesc: "Send Chat as {{role}} with {{value}}",
        v2Command: "Run Command",
        v2CommandDesc: "Run command with {{value}}",
        v2SendAIprompt: "Send AI Prompt",
        v2SendAIpromptDesc: "Send AI Prompt",
        v2ImgGen: "Image Generation",
        v2ImgGenDesc: "Generate image from {{value}}, negative from {{negValue}} => {{outputVar}}",
        v2CheckSimilarity: "Check Similarity",
        v2CheckSimilarityDesc: "Check similarity between {{source}} and {{value}} => {{outputVar}}",
        v2RunLLM: "Run Model",
        v2RunLLMDesc: "Send request to model from {{value}} => {{outputVar}}",
        v2ShowAlert: "Show Alert",
        v2ShowAlertDesc: "Show alert with {{value}}",
        v2ExtractRegex: "Extract Regex",
        v2ExtractRegexDesc:
            "Extract text from {{value}} with regex {{regexType}} {{regex}} and flags {{flagsType}} {{flags}}, then store result as {{resultType}} {{result}} => {{outputVar}}",
        v2RegexTest: "Regex Test",
        v2RegexTestDesc: "Test {{value}} with regex {{regex}} and flags {{flags}} => {{outputVar}}",
        v2GetLastMessage: "Get Last Message",
        v2GetLastMessageDesc: "Get Last Message => {{outputVar}}",
        v2GetMessageAtIndex: "Get Message at Index",
        v2GetMessageAtIndexDesc: "Get Message at Index {{index}} => {{outputVar}}",
        v2GetMessageCount: "Get Message Count",
        v2GetMessageCountDesc: "Get Message Count => {{outputVar}}",
        v2GetLorebook: "Get Lorebook",
        v2GetLorebookDesc: "Get Lorebook named {{target}} => {{outputVar}}",
        v2GetLorebookCount: "Get Lorebook Count",
        v2GetLorebookCountDesc: "Get Lorebook Count => {{outputVar}}",
        v2GetLorebookEntry: "Get Lorebook with index",
        v2GetLorebookEntryDesc: "Get Lorebook with index {{index}} => {{outputVar}}",
        v2SetLorebookActivation: "Set Lorebook Activation",
        v2SetLorebookActivationDesc: "Set Lorebook with index {{index}}'s activation state to {{value}}",
        v2GetLorebookIndexViaName: "Get Lorebook Index via Name",
        v2GetLorebookIndexViaNameDesc: "Get Lorebook Index via Name {{name}} => {{outputVar}}",
        v2ModifyLorebook: "Modify Lorebook",
        v2ModifyLorebookDesc: "Modify Lorebook named {{target}} with {{value}}",
        v2LoopNTimes: "Loop N Times",
        v2LoopNTimesDesc: "Loop {{value}} Times",
        v2Random: "Random",
        v2RandomDesc: "Random from {{min}} to {{max}} => {{outputVar}}",
        v2GetCharAt: "Get Character at Index",
        v2GetCharAtDesc: "Get Character at Index {{index}} from {{source}} => {{outputVar}}",
        v2GetCharCount: "Get Character Count",
        v2GetCharCountDesc: "Get Character Count from {{source}} => {{outputVar}}",
        v2ToLowerCase: "Convert to Lower Case",
        v2ToLowerCaseDesc: "Convert {{source}} to Lower Case => {{outputVar}}",
        v2ToUpperCase: "Convert to Upper Case",
        v2ToUpperCaseDesc: "Convert {{source}} to Upper Case => {{outputVar}}",
        v2SetCharAt: "Set Character at Index",
        v2SetCharAtDesc: "Set Character at Index {{index}} in {{source}} to {{value}} => {{outputVar}}",
        v2SplitString: "Split String",
        v2SplitStringDesc: "Split {{source}} by {{delimiter}} => {{outputVar}}",
        v2GetCharacterDesc: "Get Character Description",
        v2GetCharacterDescDesc: "Get Character Description => {{outputVar}}",
        v2SetCharacterDesc: "Set Character Description",
        v2SetCharacterDescDesc: "Set Character Description to {{value}}",
        v2GetPersonaDesc: "Get Persona Prompt",
        v2GetPersonaDescDesc: "Get Persona Prompt => {{outputVar}}",
        v2SetPersonaDesc: "Set Persona Prompt",
        v2SetPersonaDescDesc: "Set Persona Prompt to {{value}}",
        v2GetReplaceGlobalNote: "Get Replace Global Note",
        v2GetReplaceGlobalNoteDesc: "Get Replace Global Note => {{outputVar}}",
        v2SetReplaceGlobalNote: "Set Replace Global Note",
        v2SetReplaceGlobalNoteDesc: "Set Replace Global Note to {{value}}",
        v2GetAuthorNote: "Get Author Note",
        v2GetAuthorNoteDesc: "Get Author Note => {{outputVar}}",
        v2SetAuthorNote: "Set Author Note",
        v2SetAuthorNoteDesc: "Set Author Note to {{value}}",
        v2Comment: "Add Comment",
        v2CommentDesc: "{{value}}",
        v2DeclareLocalVar: "Declare Local Variable",
        v2DeclareLocalVarDesc: "Declare local variable {{var}} with value {{value}}",
        v2MakeArrayVar: "Make Array Variable",
        v2MakeArrayVarDesc: "Make Array Variable {{var}}",
        v2GetArrayVarLength: "Get Array Variable Length",
        v2GetArrayVarLengthDesc: "Get Length of Array Variable {{var}} => {{outputVar}}",
        v2GetArrayVar: "Get Array Variable",
        v2GetArrayVarDesc: "Get Value at Index {{index}} from Array Variable {{var}} => {{outputVar}}",
        v2SetArrayVar: "Set Array Variable",
        v2SetArrayVarDesc: "Set Value at Index {{index}} in Array Variable {{var}} to {{value}}",
        v2PushArrayVar: "Add to Array Variable",
        v2PushArrayVarDesc: "Add {{value}} to Array Variable {{var}}",
        v2PopArrayVar: "Remove last value from Array Variable and get",
        v2PopArrayVarDesc: "Remove last value from Array Variable {{var}} => {{outputVar}}",
        v2ShiftArrayVar: "Remove first value from from Array Variable and get",
        v2ShiftArrayVarDesc: "Remove first value from Array Variable {{var}} => {{outputVar}}",
        v2UnshiftArrayVar: "Add to Array Variable as first value",
        v2UnshiftArrayVarDesc: "Add {{value}} as first value of Array Variable {{var}}",
        v2SpliceArrayVar: "Add to Array Variable in Index",
        v2SpliceArrayVarDesc: "Add {{value}} as {{start}} value of Array Variable {{var}}",
        v2SliceArrayVar: "Slice Array Variable",
        v2SliceArrayVarDesc: "Slice Array Variable {{var}} from {{start}} to {{end}} => {{outputVar}}",
        v2GetIndexOfValueInArrayVar: "Get Index of Value in Array Variable",
        v2GetIndexOfValueInArrayVarDesc: "Get Index of {{value}} in Array Variable {{var}} => {{outputVar}}",
        v2RemoveIndexFromArrayVar: "Remove Index from Array Variable",
        v2RemoveIndexFromArrayVarDesc: "Remove Value at Index {{index}} from Array Variable {{var}}",
        v2JoinArrayVar: "Join Array",
        v2JoinArrayVarDesc: "Join Array {{var}} with {{delimiter}} => {{outputVar}}",
        v2MakeDictVar: "Make Dictionary Variable",
        v2MakeDictVarDesc: "Make Dictionary Variable {{var}}",
        v2GetDictVar: "Get Dictionary Value",
        v2GetDictVarDesc: "Get Value for Key {{key}} from Dictionary {{var}} => {{outputVar}}",
        v2SetDictVar: "Set Dictionary Value",
        v2SetDictVarDesc: "Set Value for Key {{key}} in Dictionary {{var}} to {{value}}",
        v2DeleteDictKey: "Delete Dictionary Key",
        v2DeleteDictKeyDesc: "Delete Key {{key}} from Dictionary {{var}}",
        v2HasDictKey: "Has Dictionary Key",
        v2HasDictKeyDesc: "Check if Dictionary {{var}} has Key {{key}} => {{outputVar}}",
        v2ClearDict: "Clear Dictionary",
        v2ClearDictDesc: "Clear Dictionary {{var}}",
        v2GetDictSize: "Get Dictionary Size",
        v2GetDictSizeDesc: "Get Size of Dictionary {{var}} => {{outputVar}}",
        v2GetDictKeys: "Get Dictionary Keys",
        v2GetDictKeysDesc: "Get All Keys from Dictionary {{var}} => {{outputVar}}",
        v2GetDictValues: "Get Dictionary Values",
        v2GetDictValuesDesc: "Get All Values from Dictionary {{var}} => {{outputVar}}",
        v2ConcatString: "Concatenate Strings",
        v2ConcatStringDesc: "Concatenate {{source1}} and {{source2}} => {{outputVar}}",
        v2GetLastUserMessage: "Get Last User Message",
        v2GetLastUserMessageDesc: "Get Last User Message => {{outputVar}}",
        v2GetLastCharMessage: "Get Last Character Message",
        v2GetLastCharMessageDesc: "Get Last Character Message => {{outputVar}}",
        v2GetFirstMessage: "Get First Message",
        v2GetFirstMessageDesc: "Get First Message => {{outputVar}}",
        v2GetAlertInput: "Get Alert Input",
        v2GetAlertInputDesc: "Get Alert Input => {{outputVar}}",
        v2GetAlertSelect: "Get Alert Select",
        v2GetAlertSelectDesc: "Get Alert Select {{display}} options {{value}} => {{outputVar}}",
        v2UnsupportedTrigger: "Unsupported Trigger",
        v2UnsupportedTriggerDesc: "Unsupported Trigger",
        v2GetDisplayState: "Get Display State",
        v2GetDisplayStateDesc: "Get Display State => {{outputVar}}",
        v2SetDisplayState: "Set Display State",
        v2SetDisplayStateDesc: "Set Display State to {{value}}",
        v2UpdateGUI: "Update GUI",
        v2UpdateGUIDesc: "Update GUI",
        v2UpdateChatAt: "Update Chat At Index",
        v2UpdateChatAtDesc: "Redraw chat at {{index}}",
        v2Wait: "Wait",
        v2WaitDesc: "Wait {{value}} seconds",
        v2GetRequestState: "Get Request Data Content",
        v2GetRequestStateDesc: "Get Request Content at {{index}} => {{outputVar}}",
        v2SetRequestState: "Set Request Data Content",
        v2SetRequestStateDesc: "Set Request Content at {{index}} to {{value}}",
        v2GetRequestStateRole: "Get Request Data Role",
        v2GetRequestStateRoleDesc: "Get Request Data Role at {{index}} => {{outputVar}}",
        v2SetRequestStateRole: "Set Request Data Role",
        v2SetRequestStateRoleDesc: "Set Request Data Role at {{index}} to {{value}}",
        v2GetRequestStateLength: "Get Request Data Length",
        v2GetRequestStateLengthDesc: "Get Request Data Length => {{outputVar}}",
        v2IfAdvanced: "If",
        v2IfAdvancedDesc: "If {{source}} {{condition}} {{target}}",
        v2QuickSearchChat: "Quick Search Chat",
        v2QuickSearchChatDesc: "Quick search {{value}} in chat with {{condition}} condition in {{depth}} depth => {{outputVar}}",
        v2StopPromptSending: "Stop Prompt Sending",
        v2StopPromptSendingDesc: "Stop Prompt Sending",
        v2Tokenize: "Tokenize",
        v2TokenizeDesc: "Tokenize {{value}} => {{outputVar}}",
        v2GetAllLorebooks: "Get All Lorebooks",
        v2GetAllLorebooksDesc: "Get all lorebook prompts as array => {{outputVar}}",
        v2GetLorebookByName: "Get Lorebook Indices by Name",
        v2GetLorebookByNameDesc: "Get lorebook indices array by name {{name}} => {{outputVar}}",
        v2GetLorebookByIndex: "Get Lorebook",
        v2GetLorebookByIndexDesc: "Get lorebook prompt at index {{index}} => {{outputVar}}",
        v2CreateLorebook: "Create Lorebook",
        v2CreateLorebookDesc: "Create lorebook with name {{name}}, key {{key}}, content {{content}}",
        v2ModifyLorebookByIndex: "Modify Lorebook",
        v2ModifyLorebookByIndexDesc: "Modify lorebook at index {{index}} with name {{name}}, key {{key}}, content {{content}}",
        v2DeleteLorebookByIndex: "Delete Lorebook",
        v2DeleteLorebookByIndexDesc: "Delete lorebook at index {{index}}",
        v2GetLorebookCountNew: "Get Lorebook Count",
        v2GetLorebookCountNewDesc: "Get total lorebook count => {{outputVar}}",
        v2SetLorebookAlwaysActive: "Set Lorebook Always Active",
        v2SetLorebookAlwaysActiveDesc: "Set lorebook at index {{index}} always active to {{value}}",
        v2Calculate: "Calculate",
        v2CalculateDesc: "Calculate {{expression}} => {{outputVar}}",
        v2ReplaceString: "Replace String",
        v2ReplaceStringDesc: "Replace {{source}} with regex {{regex}} to {{replacement}} => {{outputVar}}",
    },
    triggerInputLabels: {
        value: "Value",
        var: "Variable",
        varName: "Variable Name",
        outputVar: "Output Variable",
        name: "Name",
        index: "Index",
        source: "Source",
        target: "Target",
        condition: "Condition",
        operator: "Operator",
        role: "Role",
        location: "Location",
        prompt: "Prompt",
        model: "Model",
        start: "Start",
        end: "End",
        min: "Min",
        max: "Max",
        delimiter: "Delimiter",
        depth: "Depth",
        key: "Key",
        alertContent: "Alert Content",
        options: "Options",
        cmd: "Command",
        regex: "Regex",
        replacement: "Replacement",
        flags: "Flags",
        negPrompt: "Negative Prompt",
        resultFormat: "Result Format",
        activationKeys: "Activation Keys",
        insertOrder: "Insert Order",
        sysStart: "System Start",
        sysHistoryEnd: "System History End",
        sysPromptEnd: "System Prompt End",
        addElse: "Add Else",
        alwaysActive: "Always Active",
        trigger: "Trigger",
        triggerOn: "Trigger On",
        valueTypeDesc: "Use directly input value",
        varTypeDesc: "Use value stored in variable",
        conditionEqual: "Equal (=)",
        conditionNotEqual: "Not Equal (≠)",
        conditionGreater: "Greater (>)",
        conditionLess: "Less (<)",
        conditionGreaterEqual: "Greater or Equal (≥)",
        conditionLessEqual: "Less or Equal (≤)",
        conditionSimilar: "Similar (≒)",
        conditionContains: "Contains (∋)",
        conditionIn: "In (∈)",
        conditionNotContains: "Not Contains (∌)",
        conditionNotIn: "Not In (∉)",
        conditionTruthy: "Truthy (≡)",
        operatorSet: "Set (=)",
        operatorAdd: "Add (+=)",
        operatorSubtract: "Subtract (-=)",
        operatorMultiply: "Multiply (*=)",
        operatorDivide: "Divide (/=)",
        operatorModulo: "Modulo (%=)",
        searchLoose: "Loose Search",
        searchStrict: "Strict Search",
        searchRegex: "Regex Search",
        modelMain: "Main Model",
        modelSub: "Sub Model",
        roleUser: "User",
        roleChar: "Character",
        roleSystem: "System",
        roleAssistant: "Assistant",
        boolTrue: "True",
        boolFalse: "False",
        boolNull: "Null",
        helpVarName: "Enter the name of the variable",
        helpOutputVar: "Enter the variable name to store the result",
        helpIndex: "Array or message index number",
        helpRegex: "Enter regex pattern",
        helpFlags: "Regex flags",
        helpDelimiter: "Delimiter to split the string",
        helpActivationKeys: "Comma-separated activation keywords",
        helpInsertOrder: "Insert order",
        helpDepth: "Depth of messages to search",
        helpMinMax: "Min and max value range",
        helpSlot: "Use {{slot}} to keep unchanged",
        expression: "Expression",
    },
    playground: {
        playground: "Playground",
        inlayDeleteSelected: "Delete Selected",
        inlayDeselectAll: "Deselect All",
        inlayEmpty: "No saved inlay assets",
        inlayEmptyDesc: "Images, audio, and videos attached or generated in chats will appear here",
        inlayExplorer: "Inlay Assets Explorer",
        inlayImageGallery: "Inlay Image Gallery",
        inlayImageGalleryEmptyDesc: "Images attached or generated in chats will appear here",
        inlayImageList: "Image List",
        inlaySelectAll: "Select All",
        inlayDeleteConfirm: "Are you sure you want to delete {name}?",
        inlayDeleteMultipleConfirm: "Are you sure you want to delete the selected {count} assets?",
        inlayTotalAssets: "Total {count} assets",
        inlayDelete: "Delete",
        inlayLoadingMore: "Loading...",
        inlayCreatedAt: "Created:",
        inlayUpdatedAt: "Updated:",
        inlaySort: "Sort",
        inlaySortUpdatedDesc: "Updated ↓",
        inlaySortUpdatedAsc: "Updated ↑",
        inlaySortCreatedDesc: "Created ↓",
        inlaySortCreatedAsc: "Created ↑",
        inlayFilter: "Filter",
        inlayFilterAll: "All",
        inlayFilterMetaMissing: "Meta Missing",
        inlayFilterOrphanCharacter: "Orphan Character",
        inlayFilterOrphanChat: "Orphan Chat",
        inlayOriginalLoadNeeded: "Original Load Needed",
        inlayAudioAsset: "Audio Asset",
        inlayVideoAsset: "Video Asset",
        inlaySignatureAsset: "Signature Asset",
        inlayInfo: "Info",
        inlayManualMapping: "Manual Mapping",
        inlayActions: "Actions",
        inlayLoadingOriginal: "Loading original image...",
        inlaySave: "Save",
        inlaySaved: "Saved!",
        inlayFilterOrphanMessage: "Not in Messages",
        inlayScanMessages: "Scan Messages",
        inlayScanning: "Scanning...",
        inlayScanDone: "Scanned {count} messages",
    },
    confirm: "Confirm",
    risubardConfirmCurrentMessage: "Confirm current message to memory",
    risubardMemoryConfirming: "Confirming memory...",
    risubardMemoryConfirmed: "Memory confirmed",
    risubardMemoryAlreadyConfirmed: "Memory already confirmed",
    risubardMemoryConfirmFailed: "Memory confirmation failed",
    risubardReanalyzeTurn: "Reanalyze this turn in BardWiki",
    risubardReanalyzingTurn: "Reanalyzing this turn...",
    risubardReanalyzedTurn: "Reanalyzed this turn's event and canon",
    risubardReanalyzeFailed: "Turn reanalysis failed",
    yes: "Yes",
    no: "No",
    goback: "Go Back",
    botSettings: "Bot Settings",
    model: "Model",
    apiKey: "API Key",
    providerURL: "Request URL",
    providerJSON: "Request Body JSON",
    mainPrompt: "Main Prompt",
    jailbreakPrompt: "Jailbreak Prompt",
    globalNote: "Global Note",
    autoSuggest: "Auto Suggest",
    tokens: "Tokens",
    maxContextSize: "Max Context Size",
    maxResponseSize: "Max Response Size",
    temperature: "Temperature",
    frequencyPenalty: "Frequency Penalty",
    presensePenalty: "Presense Penalty",
    advancedSettings: "Advanced Settings",
    advancedSettingsWarn: "Warn: If you don't know what the option does, don't change it!",
    formatingOrder: "Formating Order",
    authorNote: "Author's Note",
    firstMessage: "First Message",
    firstMessageStudio: "First Message Studio",
    description: "Description",
    note: "Note",
    jailbreakToggle: "Toggle Jailbreak",
    charIcon: "Character Icon",
    characterDisplay: "Character Display",
    viewScreen: "Additional Character Screen",
    none: "None",
    emotionImage: "Emotion Images",
    noImages: "No Images",
    noBias: "No Bias",
    image: "Image",
    name: "Name",
    characterName: "Character Name",
    characterInfo: "Character Info",
    folderName: "Folder Name",
    folderRemoveConfirm: "This folder contains lorebooks. Are you sure you want to delete it and all its contents?",
    emotion: "Emotion Name",
    value: "Value",
    reroll: "Regenerate",
    hideMessagePageCount: "Hide Message Page Counter",
    deleteRerollMessage: "Delete Regenerated Message",
    deleteRerollMessageConfirm: "Delete the currently selected regenerated message?",
    rerollConfirm: "Generate a new message and add it to the list?",
    noSwipesRerollConfirm: "There are no additional regenerated messages. Generate a new message and add it to the list?",
    chatList: "Chat List",
    currentChatLabel: "Current chat",
    sidebarChatListLabel: "Chat list",
    saveChatFileAction: "Save chat",
    loadChatFileAction: "Load chat",
    risuBardQuickSave: "Quicksave",
    risuBardQuickLoad: "Quickload",
    risuBardShowSaveLoadShortcuts: "Show save / load shortcut buttons",
    risuBardSaveLoadShortcutClose: "Close save/load shortcuts",
    risuBardSaveLoadShortcutHideConfirm: "Turn off the save/load buttons? You can turn them back on under BardWiki / Common options.",
    risuBardAutosaveInterval: "Autosave interval (turns)",
    risuBardAutosaveRetention: "Maximum autosaves retained",
    risuBardArcaChatExporter: "Arca Chat Extractor",
    risuBardArcaChatImageWidthPercent: "Exported image width (%)",
    risuBardArcaChatFontSizePx: "Font size (px)",
    risuBardArcaChatParagraphSpacingPercent: "Paragraph spacing (%)",
    risuBardArcaChatShowTitleImage: "Show title image",
    risuBardArcaChatTitleImageStyle: "Title image style",
    risuBardArcaChatTitleImageOval: "Large oval",
    risuBardArcaChatTitleImageSquare: "Square",
    risuBardArcaChatTitleImageThumbnailTitle: "Thumbnail + title",
    risuBardChatResponseSettings: "Chat responses",
    risuBardWikiAnalysisSettings: "BardWiki analysis",
    risuBardArcPlotter: "Archplotter",
    risuBardArcPlotterEnabled: "Update the Archplotter automatically",
    risuBardArcPlotterCheckpointSize: "Plot update interval (confirmed events)",
    risuBardArcPlotterMaxArcs: "Maximum chronological arcs",
    risuBardArcPlotterMaxTurningPoints: "Maximum major turning points",
    risuBardArcPlotterMaxOpenThreads: "Maximum open threads",
    risuBardArcPlotterMaxCharacters: "Maximum plot document characters",
    risuBardArcPlotterPreset: "Archplotter preset",
    risuBardArcPlotterPresetShort: "Short story",
    risuBardArcPlotterPresetNovella: "Novella",
    risuBardArcPlotterPresetEpic: "Epic",
    risuBardArcPlotterPresetCustom: "Custom (unsaved)",
    risuBardArcPlotterPresetBuiltInHint: "Built-in presets cannot be overwritten or deleted. Editing a value switches to Custom.",
    risuBardArcPlotterPresetUserHint: "The selected user preset can be overwritten or deleted with the buttons below.",
    risuBardArcPlotterPresetName: "New preset name",
    risuBardArcPlotterPresetNamePlaceholder: "Example: Three-volume novel",
    risuBardArcPlotterPresetSave: "Save as new preset",
    risuBardArcPlotterPresetOverwrite: "Overwrite selected preset",
    risuBardArcPlotterPresetDelete: "Delete selected preset",
    risuBardArcPlotterPresetNameRequired: "Enter a name for the new preset.",
    risuBardArcPlotterPresetDuplicate: "A preset with that name already exists, or the preset is invalid.",
    risuBardArcPlotterPresetSaved: "Archplotter preset saved.",
    risuBardArcPlotterPresetOverwritten: "Archplotter preset overwritten.",
    risuBardArcPlotterPresetDeleted: "Archplotter preset deleted.",
    risuBardArcPlotterPresetOverwriteConfirm: "Overwrite “{name}” with the current values?",
    risuBardArcPlotterPresetDeleteConfirm: "Delete “{name}”?",
    risuBardWikiWritingSettings: "BardWiki writing",
    risuBardSaveAndLoadSettings: "Save and load",
    removeChat: "Remove this message?",
    bardWikiDeleteWarning: "Choose what to delete. Linked event summaries are deleted together when BardWiki evidence is included. Other canonical documents are not rolled back to their past state. Run Wiki Reboot after deletion if you need an exact historical state.",
    loreBook: "Lorebook",
    lorebookWorkspace: {
        open: "Open lorebook workspace",
        editor: "Lorebook editor",
        legacyLore: "Legacy Lorebook",
        bardLore: "Grimoire",
        legacyLoreEditor: "Legacy Lorebook",
        bardLoreEditor: "Grimoire",
        openBardLore: "Grimoire editor",
        bardUseForGeneration: "Use for generation",
        bardLoreEnabled: "Grimoire is active",
        bardLoreDisabled: "Legacy retrieval is active",
        bardLoreEnabledDescription: "Character lore uses bounded Grimoire retrieval during generation.",
        bardLoreDisabledDescription: "You can edit and analyze the Grimoire without using it for generation.",
        upgradeToBardLore: "Upgrade to Grimoire",
        bardLoreDescription: "Grimoire edits the same lorebook entries and injects only those selected under a fixed budget.",
        bardPortableData: "Grimoire metadata",
        bardPortableDescription: "Transfer or remove the Grimoire metadata overlay without changing the original legacy lorebook.",
        bardPortableExport: "Export metadata",
        bardPortableImport: "Import metadata",
        bardPortableCleanse: "Cleanse Grimoire metadata",
        bardPortableExportSuccess: "Grimoire metadata was exported.",
        bardPortableImportSuccess: (applied: number, created: number, skipped: number, unresolvedLinks: number) => `Imported metadata for ${applied} entries · ${created} derived entries created · ${skipped} unmatched entries skipped · ${unresolvedLinks} unresolved links omitted.`,
        bardPortableImportFailed: "Could not import Grimoire metadata.",
        bardPortableCleanseConfirm: "Remove all Grimoire metadata, settings, analysis drafts, and derived entries from this character? The original legacy lorebook will remain unchanged.",
        bardPortableCleanseSuccess: "Grimoire metadata was removed. The legacy lorebook was preserved.",
        bardBudget: "Grimoire retrieval budget",
        bardBudgetDescription: "Runtime retrieval is local and deterministic; it does not call an AI model.",
        bardTargetTokens: "Target tokens",
        bardMaximumTokens: "Hard maximum tokens",
        bardMaxEntries: "Maximum entries",
        bardContextMessages: "Recent messages used as the query",
        bardAdvancedRetrieval: "Advanced retrieval tuning",
        bardMaxLinkDepth: "Maximum explicit-link depth",
        bardMinimumSparseScore: "Minimum sparse score",
        bardDirectMatchScore: "Direct match score",
        bardLinkScore: "Link score",
        bardLinkScoreDecay: "Link score decay per depth",
        bardMinimumTermLength: "Minimum term length",
        bardRouterDefaultCount: "Default routed result count",
        bardRouterAmbientCount: "Scene candidate count",
        bardRouterLexicon: "Query router lexicon",
        bardRouterFilterFacets: "Facet keys used as filters",
        bardRouterFacetVocabulary: "Facet value query vocabulary",
        bardCjkPartialMatching: "CJK partial matching",
        bardFieldWeights: "Search field weights",
        bardAnalysisSettings: "AI analysis settings",
        bardAnalysisBatchEntries: "Entries per batch",
        bardAnalysisInputTokens: "Maximum input tokens",
        bardAnalysisInputLimitExceeded: (name: string, required: number, limit: number) => `Analyzing “${name}” requires about ${required.toLocaleString()} input tokens, but the current limit is ${limit.toLocaleString()}. Increase Maximum input tokens in this window or select Recommended settings. This includes the entry text, instructions, output schema, and entry catalog.`,
        bardAnalysisOutputTokens: "Maximum output tokens",
        bardAnalysisLinkedDepth: "Connected analysis depth",
        bardAnalysisTemperature: "Analysis temperature",
        bardAnalysisSettingsNextRun: "Changing a value preserves completed drafts and replans failed or pending batches. Connected depth can be changed on a new run.",
        bardAnalysisSettingHelp: {
            analysisBatchEntries: "The maximum number of entries grouped into one model request. Larger batches reduce request count but can exceed the input limit when entries are long.",
            analysisInputTokens: "The per-request input-token allowance for instructions, output schema, entry catalog, and entry text. This is separate from global chat token settings. If a long entry exceeds it, increase this value or select Recommended settings.",
            analysisOutputTokens: "The most tokens the model may generate for one request. Normal batches often finish below this allowance unless they contain large composite lists.",
            analysisLinkedDepth: "How many explicit-link steps Connected entries follows. 0 means only the current entry, 1 includes direct links, and 2 includes links of links. 1 is recommended for most lorebooks.",
            analysisTemperature: "Controls randomness. 0 is most consistent; higher values diversify alias and tag suggestions but can increase format errors. Use 0–0.2 for structured analysis; Recommended settings uses 0.2.",
        },
        bardAnalysisSaveDefault: "Save as default",
        bardAnalysisSaveDefaultHelp: "Save these five analysis settings as the app default used when a new character Grimoire is created.",
        bardAnalysisDefaultSaved: "Saved the current AI analysis settings as the default.",
        bardAnalysisRecommend: "Recommended settings",
        bardAnalysisRecommendHelp: "Calculate batch size and token allowances from the selected entry count and current local input-token estimate.",
        bardAnalysisRecommendedApplied: "Applied settings recommended for the selected analysis targets.",
        bardAnalysisRequestPlan: "Request plan",
        bardAnalysisRunStatus: "Analysis progress",
        bardAnalysisSelectTargetNotice: "Select at least one entry from the list on the right.",
        bardAnalysisKindFilter: "Type filter",
        bardAnalysisAllKinds: "All types",
        bardAnalysisSelectAll: "Select all",
        bardAnalysisSelectNone: "Select none",
        bardAnalysisColumnSelect: "Select",
        bardAnalysisColumnName: "Entry name",
        bardAnalysisColumnKind: "Type",
        bardAnalysisColumnStatus: "Status",
        bardAnalysisSelectEntry: (name: string) => `Select ${name} for analysis`,
        bardAnalysisNoFilteredTargets: "No analysis targets match this type.",
        bardAnalysisKindLabels: {
            system: "System", character: "Character", location: "Location", faction: "Faction",
            item: "Item", event: "Event", concept: "Concept", other: "Other",
        },
        bardAnalysisStatusLabels: {
            excluded: "Excluded", pending: "Pending", running: "Running", complete: "Complete", failed: "Failed",
        },
        bardActivation: "Lore activation rule",
        bardActivationHelp: "Choose whether this entry is always required, selected only by a direct key or alias, selected by key plus relevance, or excluded from automatic injection.",
        bardRequired: "Required",
        bardKeyed: "Key or alias match",
        bardRetrieve: "Key + relevance",
        bardNever: "Never inject",
        bardGuideTitle: "Grimoire help",
        bardGuideOpen: "Open Grimoire help",
        bardGuideIntro: "Grimoire adds retrieval metadata to the same lorebook entries and selects only useful lore under a fixed budget. Retrieval runs locally and does not call an AI model during generation.",
        bardGuideContents: "Contents",
        bardGuideGenerationTitle: "Editing and generation",
        bardGuideGenerationBody: "Opening Grimoire does not activate it for generation. Use ‘Use for generation’ in the character lore settings to switch between legacy lorebook matching and Grimoire retrieval.",
        bardGuideActivationTitle: "Activation rules",
        bardGuideRequiredBody: "Included in every request through the reserved required lane. Use this only for system contracts that must always be present.",
        bardGuideKeyedBody: "Selected only when a primary key, secondary key, or alias appears directly in the current input or configured recent messages.",
        bardGuideRetrieveBody: "Selected first on a direct key or alias match, and otherwise when relevance search across the entry metadata and body clears the configured score threshold.",
        bardGuideNeverBody: "Kept for editing and manual reference, but excluded from automatic prompt injection. This is also useful for folders and intentionally dormant lore.",
        bardGuideSearchTitle: "Search metadata",
        bardGuideSearchBody: "Names, keys, aliases, tags, summaries, facets, and lore text can contribute to retrieval. Lore kind and facets narrow list or description requests; sharing a tag or kind never creates a relationship by itself.",
        bardGuidePromptTitle: "Prompt role",
        bardGuidePromptBody: "‘Inject selected lore’ sends a selected entry’s body to the model. ‘Routing index only’ lets the entry guide search and link traversal without sending its body.",
        bardGuideLinksTitle: "Explicit links",
        bardGuideLinksBody: "Links are user-approved relationships. Supporting retrieval expands forward, reverse discovery can find the source from its target, scene candidate participates in scene routing, and do not expand stores the relationship without using it at runtime.",
        bardGuideBudgetTitle: "Budget and preview",
        bardGuideBudgetBody: "Target tokens and maximum entries limit ordinary retrieval. Required lore uses a separate reserved lane, while the absolute maximum applies to the combined result. If required lore alone exceeds it, generation reports an error instead of silently dropping required content. Use Retrieval preview to inspect selections and exclusions.",
        bardGuideAnalysisTitle: "AI metadata analysis",
        bardGuideAnalysisBody: "Optional analysis proposes kinds, aliases, tags, summaries, facets, links, and routing-only candidates without rewriting the original lore text. Results remain drafts until approved, and completed drafts survive a paused or partially failed run.",
        bardGuideCompatibilityTitle: "Compatibility and transfer",
        bardGuideCompatibilityBody: "The legacy and Grimoire editors show the same title, keys, body, and folder for each ordinary entry; edits in either view appear in the other immediately. Kind, aliases, tags, summary, facets, and links live only in Grimoire, as do AI-derived entries split from source text. Metadata transfer and cleanse never rewrite the ordinary lorebook body.",
        bardGuideWritingTitle: "Writing lorebook entries",
        bardGuideWritingIntro: "Retrieval controls what the model knows for this request; the entry text controls how that knowledge may affect narration. A secret that should shape behavior must be available when the character is active, then constrained by explicit knowledge and disclosure rules.",
        bardGuideWritingIdentityTitle: "Keep one identity",
        bardGuideWritingIdentityBody: "Do not turn a public persona and a secret persona into unrelated character entries. Keep a small identity core that names every persona as the same individual and shares memory, injuries, motives, and relationships. Split only large supporting details such as hideouts, evidence, or past incidents.",
        bardGuideWritingActivationTitle: "Choose the narrowest useful activation",
        bardGuideWritingActivationBody: "Use Required only for universal system contracts. Use Key or alias match for named entities and tightly gated secrets. Use Key + relevance for ordinary world lore that should also be found from related wording. Use Never inject for reference material the model must not use automatically.",
        bardGuideWritingSecretTitle: "Secrets, hints, and disclosure",
        bardGuideWritingSecretBody: "State the private fact, who knows it, what each observer can currently infer, and the conditions for confirmation. Allow observable hints such as injuries, absences, habits, or momentary reactions, while forbidding explanatory narration, convenient confession, and knowledge without evidence. Suspicion is not confirmation.",
        bardGuideWritingKeysTitle: "Primary and secondary keys are alternatives",
        bardGuideWritingKeysBody: "In Grimoire, a direct match in either primary keys, secondary keys, or aliases is a strong seed; the two key fields are not an AND lock. Matching also examines the configured recent-message window. Avoid broad keys such as secret, past, wound, or truth when accidental activation would matter, and verify representative queries in Retrieval preview.",
        bardGuideWritingExampleTitle: "Compact secret-identity pattern",
        bardGuideWritingExampleBody: "Example: one ‘Bruce Wayne / Batman’ character entry can use Bruce Wayne, Bruce, and Batman as keys. Its private identity section says both personas are one person; its disclosure section prevents early confirmation; its hint section permits matching injuries and unexplained absences. Separate entries hold Batcave security or discovery evidence only when those details become relevant.",
        bardGuideWritingTemplateTitle: "Entry checklist",
        bardGuideWritingTemplateBody: "Identity: who or what this entry describes.\nPrivate fact: the truth the acting character knows.\nKnowledge boundary: who knows, suspects, or does not know.\nBehavior: how the fact changes choices even while hidden.\nHints: observable effects that may appear before revelation.\nDisclosure: evidence or scene conditions required for confirmation.\nNever: premature explanation, confession, or unsupported knowledge.",
        bardKind: "Lore kind",
        bardKindHelp: "Classifies the entry as a character, location, event, and so on. It guides query routing but never creates links by itself.",
        bardInjection: "Prompt role",
        bardInjectionHelp: "Inject the selected body into the prompt, or use the entry only as an index for retrieval and link traversal.",
        bardInjectionFull: "Inject selected lore",
        bardInjectionIndexOnly: "Routing index only",
        bardAliases: "Aliases",
        bardAliasesHelp: "Alternative spellings or names. A direct mention in the current input is treated as a strong retrieval signal.",
        bardTags: "Tags",
        bardTagsHelp: "Short topic, role, or time labels used for search. Sharing a tag does not automatically link entries.",
        bardBatchSelectionHelp: "Multiple Grimoire entries are selected. Visibility and the metadata changes below apply to every selected entry.",
        bardBatchMixed: "Mixed — select a value to apply",
        bardBatchValues: "Batch aliases and tags",
        bardBatchValuesPlaceholder: "values, separated, by commas",
        bardAddAliases: "+ Aliases",
        bardRemoveAliases: "− Aliases",
        bardAddTags: "+ Tags",
        bardRemoveTags: "− Tags",
        bardSummary: "Search summary",
        bardSummaryHelp: "A short retrieval-only description that does not alter the source lore text.",
        bardFacets: "Structured facets",
        bardFacetsHelp: "Key/value search facts such as work, gender, affiliation, place, or time. They narrow typed and counted queries.",
        bardFacetKey: "Facet key",
        bardFacetValue: "Canonical value",
        bardFacetAliases: "Query aliases",
        bardAddFacet: "Add facet",
        bardRemoveFacet: "Remove facet",
        bardLinks: "Explicit links",
        bardLinksCount: (count: number) => `${count} explicit links`,
        bardLinksDescription: "Only relationships explicitly approved from this entry are shown. Each card contains a target, relationship, and retrieval behavior.",
        bardLinksEmpty: "No explicit links yet.",
        bardLinkTarget: "Link target",
        bardLinkRelation: "Relationship",
        bardLinkRetrieval: "Retrieval behavior",
        bardLinkNone: "Do not expand",
        bardLinkSupporting: "Supporting retrieval",
        bardLinkDiscoverable: "Reverse discovery",
        bardLinkAmbient: "Scene candidate",
        bardAddLink: "Add link",
        bardRemoveLink: "Remove link",
        bardSearchPreview: "Retrieval preview",
        bardSearchPlaceholder: "Enter a scene or request",
        bardRunSearch: "Preview",
        bardSearching: "Searching…",
        bardSearchTotal: (count: number, tokens: number) => `${count} entries · ${tokens} tokens`,
        bardExcludedTotal: (count: number) => `${count} excluded entries`,
        bardExcludedIneligible: "disabled by entry policy",
        bardExcludedRoutingOnly: "routing index; body is never injected",
        bardExcludedNoMatch: "no contextual match",
        bardExcludedKindMismatch: "does not match the requested lore kind",
        bardExcludedConstraintMismatch: "does not match the requested facet constraints",
        bardExcludedEntryLimit: "entry budget reached",
        bardExcludedRequestedCount: "requested result count reached",
        bardExcludedTargetReached: "target token budget reached",
        bardExcludedTokenLimit: "maximum token budget exceeded",
        bardAiAnalysis: "AI metadata analysis",
        bardAnalysisScope: "Analysis scope",
        bardAnalyzeEntry: "Current entry",
        bardAnalyzeConnected: "Current and connected",
        bardAnalyzeCharacters: "Character entries only",
        bardAnalyzeAll: "Complete Grimoire",
        bardAnalyze: "Analyze",
        bardAnalyzing: "Analyzing…",
        bardAnalysisNoTargets: "No entries are available for this scope.",
        bardAnalysisRequestFailed: "The metadata analysis request failed.",
        bardOverwriteMetadata: "Replace existing manual metadata",
        bardApproveAnalysis: "Approve draft",
        bardDiscardAnalysis: "Discard draft",
        bardAnalysisConflicts: (count: number) => `${count} entries changed after analysis and were not applied.`,
        bardAnalysisDescription: "Create search metadata without changing lore text. Results stay as a draft until you approve them.",
        bardAnalysisDialogDescription: "Review the local token estimate before sending requests. Every completed batch is saved immediately.",
        bardAnalysisEntries: "Grimoire entries",
        bardAnalysisUntyped: "Unclassified",
        bardAnalysisNoSummary: "No summary",
        bardAnalysisNoTags: "No tags",
        bardAnalysisQualityPassed: "Deterministic metadata checks passed",
        bardAnalysisQualityNeedsWork: (entries: number, issues: number) => `Needs quality work · ${entries} entries, ${issues} issues`,
        bardAnalysisQualityDescription: "Checks summaries, tags, structured roster and timeline injection policy, and supporting links that exceed the retrieval budget without AI. Facets are optional search constraints and are used only when supported by evidence.",
        bardAnalysisQualityShowIssues: "Show items to improve",
        bardAnalysisQualityMissingSummary: "Search summary is missing.",
        bardAnalysisQualityMissingTags: "Search tags are missing.",
        bardAnalysisQualityCompositeInjection: "A structured roster or timeline must use index-only injection.",
        bardAnalysisQualityCompositeAtoms: "The structured roster or timeline has no atomic entry drafts.",
        bardAnalysisQualitySupportingLinks: (counts: string) => `Supporting links exceed the entry budget (${counts}). Their retrieval directions need review.`,
        bardAnalysisQualityRepair: (count: number) => `Prepare AI repair for ${count} problem entries`,
        bardAnalysisOpen: "Analyze metadata",
        bardAnalysisResumeReview: "Resume or review analysis",
        bardAnalysisDraftSaved: (count: number) => `${count} saved drafts`,
        bardAnalysisPlanning: "Calculating the real batch prompts locally…",
        bardAnalysisTargetCount: "Target entries",
        bardAnalysisRequestCount: "Model requests",
        bardAnalysisEstimatedInput: "Estimated input tokens",
        bardAnalysisMaximumOutput: "Maximum output tokens",
        bardAnalysisStart: (count: number) => `Start ${count} requests`,
        bardAnalysisProgress: "Completed batches",
        bardAnalysisProcessedEntries: "Drafted entries",
        bardAnalysisFailedBatches: "Failed batches",
        bardAnalysisRunningBatch: (current: number, total: number) => `Running batch ${Math.min(current, total)} of ${total}. Completed drafts are already saved.`,
        bardAnalysisCancelKeep: "Stop and keep completed drafts",
        bardAnalysisResume: "Resume pending batches",
        bardAnalysisRetryFailed: (count: number) => `Retry ${count} failed batches`,
        bardAnalysisReview: "Review drafts",
        bardAnalysisReviewCount: (count: number) => `${count} entries are waiting for approval.`,
        bardAnalysisAtoms: (count: number) => `${count} derived atomic entries`,
        bardAnalysisEmptySummary: "No summary proposed",
        bardAnalysisMissingEntry: "An entry in this batch no longer exists.",
        bardAnalysisTargetPreview: "Analysis targets",
        bardAnalysisTargetPreviewDescription: "Expand an entry to inspect the original lore content that will be sent to the model.",
        bardAnalysisBatchLabel: (index: number) => `Batch ${index}`,
        bardAnalysisKeys: "Keys",
        bardAnalysisNoContent: "No content",
        bardAnalysisFailureDetails: "Failure details",
        bardAnalysisFailureTargets: "Targets",
        bardAnalysisErrorUnknown: "Unknown analysis error",
        bardAnalysisErrorLegacyInvalid: "The response failed schema validation. This older run did not retain the exact validation stage.",
        bardAnalysisErrorInvalidJson: "The model response is not valid JSON.",
        bardAnalysisDiagnostics: {
            outputLimit: "The provider reported an output token limit. Increase the output allowance or reduce entries per batch. Thinking tokens may also consume the output budget.",
            inputLimit: "The request error reports that the model context limit was exceeded. Reduce entries or input size and check the reserved output budget. Increasing the analysis input allowance does not increase the model's own limit.",
            blocked: "The provider returned a safety, content policy or refusal signal. Check the finish reason and original error. Token or batch settings may not resolve this.",
            empty: "The response contains no text for analysis. Without a finish reason, token exhaustion or refusal cannot be confirmed.",
            invalidJson: "The response did not meet the JSON format. Token exhaustion or filtering is not confirmed by the finish reason. Inspect the response excerpt; for a large batch, try fewer entries.",
            validation: "Response content or required-entry validation failed. Inspect the original error for missing entries, field types or quality checks.",
            requestFailed: "The request or processing failed. Inspect the original error for authentication, rate limits, network, plugin or provider errors.",
            details: "Diagnostic details and response excerpt",
            evidenceHelp: "entryCount is the requested entry count; attempt is the attempt within this batch; estimatedInputTokens is the original batch estimate. inputTokenLimit/outputTokenLimit are analysis settings, which can differ from provider limits. usage is provider-reported usage; finishReason is the stop reason. null means unavailable, not zero. Long errors and responses show the beginning and end. Full requests and responses can be inspected in Request Logs if recording was enabled.",
        },
        bardAnalysisErrorMissingEntries: "The response does not contain an entries array.",
        bardAnalysisErrorUnknownTarget: "The response references an entry outside the analysis targets.",
        bardAnalysisErrorEntryShape: "An entry kind, aliases, tags, or summary does not match the schema.",
        bardAnalysisErrorLinkShape: "A link target, relation, or retrieval mode does not match the schema.",
        bardAnalysisErrorSourceChanged: "The source entry changed after the request started.",
        bardAnalysisErrorMissingTargets: "The response omitted one or more analysis targets.",
        bardAnalysisErrorQuality: "The response passed JSON Schema validation but failed the local metadata quality checks.",
        bardAnalysisCloseBehavior: "Closing this window stops the active request and keeps completed drafts on the character. Open this panel again at any time to review them.",
        close: "Close lorebook workspace",
        back: "Back to list",
        search: "Search lorebook",
        searchName: "Name",
        searchKeys: "Keys",
        searchAll: "All",
        searchTarget: "Search target",
        showAll: "All states",
        showEnabled: "Visible",
        showDisabled: "Hidden",
        enabledFilter: "Visibility filter",
        batchEdit: "Batch edit",
        batchSelectionHelp: "Multiple entries are selected. State and key changes below apply to the whole selection.",
        dragSelectionHelp: "Drag any selected entry to move the entire selection together while preserving source order.",
        clearSelection: "Clear selection",
        enabled: "Enabled",
        disabled: "Disabled",
        hidden: "Hidden",
        enable: "Enable",
        disable: "Disable",
        alwaysActive: "Always active",
        activeInCurrentChat: "Active in current chat",
        alwaysOn: "Always on",
        keyActive: "Key active",
        selective: "Multiple keys",
        unreachable: "No activation path",
        anyKey: "Any key",
        useRegex: "Use regex",
        regexKeys: "Regex keys",
        plainKeys: "Plain keys",
        addPrimaryKeys: "+ Primary",
        removePrimaryKeys: "− Primary",
        addSecondaryKeys: "+ Secondary",
        removeSecondaryKeys: "− Secondary",
        moveUp: "Move up",
        moveDown: "Move down",
        moveToFolder: "Move to folder",
        moveToRoot: "Move to root",
        duplicateLore: "Duplicate lore",
        entryActions: "Move, duplicate, and delete",
        importLoremaster: "Restore Loremaster",
        importLoremasterResult: (count: number) => `Restored ${count} Loremaster ${count === 1 ? 'entry' : 'entries'}.`,
        workspaceLabel: (scope: string) => `${scope} lorebook workspace`,
        openScope: (scope: string) => `Open ${scope} lorebook workspace`,
        entriesCount: (count: number) => `${count} ${count === 1 ? 'entry' : 'entries'}`,
        selectedCount: (count: number) => `${count} selected`,
        addLore: "New lore",
        addFolder: "New folder",
        import: "Import",
        export: "Export",
        newLore: "New lore",
        newFolder: "New folder",
        untitledLore: "Untitled lore",
        untitledFolder: "Untitled folder",
        deleteEntryConfirm: (name: string) => `Delete “${name}”? This cannot be undone.`,
        deleteFolderConfirm: (name: string, count: number) => `Delete “${name}” and ${count} child ${count === 1 ? 'entry' : 'entries'}? This cannot be undone.`,
        deactivateLinkConfirm: (name: string) => `Deactivate link to “${name}”? This removes only the link record.`,
        dragEntry: (name: string) => `Drag ${name}`,
        dragEnabledHelp: "Drag to reorder. Open the editor for explicit move actions.",
        dragDisabledHelp: "Drag is disabled. Open the editor and use Move up, Move down, Move to folder, or Move to root.",
        toggleFolder: (name: string) => `Toggle ${name} folder`,
        selectEntry: (name: string) => `Select ${name}`,
        globalLoreLink: "Global lore link",
        noKeys: "No keys",
        noMatches: "No lore matches this view.",
        batchKeys: "Batch keys",
        batchKeysPlaceholder: "keys, separated, by commas",
        resizeList: "Resize lorebook list",
        resizeSettings: "Resize lorebook settings",
        resizeWindow: "Resize lorebook editor window",
        resizeHint: "Drag or use arrow keys to resize. Double-click or Home to reset.",
        expandKeys: "Expand full-width multiline editor",
        collapseKeys: "Collapse multiline editor",
        compatibilityLinkDescription: "This compatibility entry points to global lore and is read-only in this workspace.",
        linkedLore: "Linked lore",
        name: "Name",
        referenceKey: "Reference key",
        deactivateLink: "Deactivate link",
        order: "Order",
        primaryKeys: "Primary keys",
        secondaryKeys: "Secondary keys",
        content: "Content",
        loreState: "Lore state",
        activationPercent: "Activation %",
        moveTargetFolder: "Move target folder",
        chooseFolder: "Choose folder",
        deleteEntry: "Delete entry",
        archiveFolder: "Archive folder",
        deleteFolderAndEntries: "Delete folder and entries",
        selectLoreEntry: "Select a lore entry",
        emptyEditorDescription: "The editor stays open beside the archive list on desktop.",
        loreBuilder: {
            launch: "Lore Builder",
            title: "Lore Builder",
            description: (name: string) => `Draft and refine the body of “${name}” with AI. The original stays unchanged until you apply the draft.`,
            close: "Close lore builder",
            taskPrompt: "Task instruction prompt",
            stylePrompt: "Lorebook style prompt",
            taskPromptPlaceholder: "Describe the lorebook editing task and required output format.",
            stylePromptPlaceholder: "Add structure, style, disclosure, and banned-expression rules.",
            presetSelect: "Select preset",
            presetSave: "Save new",
            presetOverwrite: "Overwrite",
            presetDelete: "Delete preset",
            presetNamePrompt: "Enter a name for the new lorebook preset.",
            presetOverwriteConfirm: (name: string) => `Overwrite “${name}” with the current content?`,
            presetDeleteConfirm: (name: string) => `Delete the “${name}” preset?`,
            presetSaved: "Preset saved.",
            presetOverwritten: "Preset overwritten.",
            presetDeleted: "Preset deleted.",
            presetNameExists: "A preset with this name already exists for this prompt type.",
            presetInvalid: "Enter both a preset name and prompt content.",
            builtinPresetHint: "Built-in presets are protected. Use Save new to keep your edited version as a separate preset.",
            contextTitle: "Context to inject",
            contextHint: "Only checked sources are sent. The current entry is injected as the draft and excluded from related lore.",
            systemPrompt: "System prompt",
            characterDescription: "Character description",
            characterLorebook: "Related character lore",
            moduleLorebook: "Module lorebook",
            messages: "Messages",
            messageRangeLabel: "Assistant turns to reference",
            messageRangeHint: "Use 5, -3, or 10-13. User messages are excluded.",
            contextUnavailable: "No source available",
            noCharacterContext: "No character is selected, so character description and related lore are unavailable.",
            instructionLabel: "Tell the AI what to do",
            instructionPlaceholder: "For example: Keep this structure, but separate private facts from their disclosure conditions.",
            draftTitle: "Draft before applying",
            originalDraft: "Original",
            revisedDraft: "Revision",
            draftPlaceholder: "The generated result appears here. Manual edits become the draft for the next request.",
            send: "Generate",
            stop: "Stop generation",
            reset: "Reset to an empty draft",
            undo: "Previous draft",
            applyDraft: "Apply",
            applyFailed: "Could not apply the draft to the current lore entry.",
            targetMissing: "The target lore entry no longer exists.",
            taskRequired: "Enter a task instruction prompt.",
            instructionRequired: "Enter an instruction for the AI.",
            emptyResponse: "The model returned an empty result.",
            requestFailed: "Failed to generate a lorebook draft.",
        },
    },
    character: "Character",
    Chat: "Chat",
    globalLoreInfo: "Character Lorebook applys to all chats in the character.",
    group: "Group",
    localLoreInfo: "Chat Lorebook only applies to the current chat.",
    removeConfirm: "Do you really want to remove: ",
    removeConfirm2: "Do you REALLY want to remove: ",
    exportConfirm: "Do you want to export this?",
    insertOrder: "Insertion Order",
    activationKeys: "Activation keys",
    activationKeysInfo: "Comma seperated",
    prompt: "Prompt",
    loreBookDepth: "Recent Chat Scan Range",
    loreBookToken: "Lorebook Max Tokens",
    chatLoadInitialPages: "Initial Chat Load Count",
    chatLoadAdditionalPages: "Additional Chat Load Count",
    chatPageSize: "Messages Per Chat Page",
    chatPageNavigation: "Chat page navigation",
    chatPagePrevious: "Previous",
    chatPageNext: "Next",
    chatPageLatest: "Latest",
    chatPageTop: "Current page top",
    chatPageBottom: "Current page bottom",
    chatMessagePrevious: "Previous message",
    chatMessageNext: "Next message",
    chatPageJumpLabel: "Page",
    chatPageJumpAria: "Jump to page",
    chatTurnLabel: "Turn",
    chatTurnJumpAria: "Jump to turn",
    chatPageTurnJumpAria: "Jump to the selected page and turn",
    chatFirstMessageCollapse: "Collapse first message",
    chatFirstMessageExpand: "Expand first message",
    removeCharacter: "Remove Character",
    exportCharacter: "Export Character",
    characterPackage: "Character Package",
    characterPackageExport: "Export Package",
    convertToModule: "Convert to Module",
    convertToCharacter: "Convert to Character",
    successfullyConverted: "Successfully converted.",
    characterPackageImport: "Import Character Package (zip)",
    characterPackageCharacter: "Character",
    characterPackageChats: "Chats",
    characterPackageGallery: "Gallery",
    characterPackagePersona: "Persona",
    characterPackageInlays: "Inlay Images",
    characterPackageNone: "None",
    characterPackageChatCount: "",
    characterPackageGalleryCount: " memories",
    characterPackageInlayCount: "",
    characterPackageExportSuccess: "Character package exported successfully.",
    characterPackageImportSuccess: "Character package imported successfully.",
    characterPackageImportSummary: "Package Contents",
    characterPackageInvalidZip: "Invalid character package file.",
    characterPackageProgressCharacter: "Building character...",
    characterPackageProgressChats: "Writing chats...",
    characterPackageProgressGallery: "Writing gallery...",
    characterPackageProgressPersona: "Writing personas...",
    characterPackageProgressInlays: "Writing inlays",
    characterPackageProgressFinalizing: "Finalizing...",
    characterPackageProgressReading: "Reading package...",
    characterPackageProgressImportChar: "Importing character...",
    characterPackageProgressImportPersona: "Importing personas...",
    characterPackageProgressImportChats: "Importing chats...",
    characterPackageProgressImportGallery: "Importing gallery...",
    characterPackageProgressImportInlays: "Importing inlays",
    characterImportReading: "Reading character file...",
    characterImportReadingBytes: (completed: string, total: string) =>
        `Reading character file... (${completed} / ${total})`,
    characterImportScanning: (count: number) =>
        `Scanning archive entries... (${count.toLocaleString()} found)`,
    characterImportExtracting: (completed: number, total: number) =>
        `Extracting archive... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportPreparingAssets: (completed: number, total: number) =>
        `Preparing assets... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportSavingAssets: (completed: number, total: number) =>
        `Saving assets... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportReadingMetadata: "Reading character metadata...",
    characterImportReadingModule: "Reading embedded module...",
    characterImportApplying: "Applying character data...",
    characterImportEmotions: (completed: number, total: number) =>
        `Importing emotion images... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportAssets: (completed: number, total: number) =>
        `Linking character assets... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportVoiceFiles: (completed: number, total: number) =>
        `Importing voice files... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
    characterImportDownloading: "Downloading character file...",
    characterImportFailed: "Could not import the character file.",
    characterImportMissingAsset: (key: string) => `Character asset not found: ${key}`,
    characterImportDataUriTooLarge: "A data URI asset in the card is too large.",
    characterPackageEmpty: "empty shell",
    characterPackageEmptyWarning: "Character data is empty. Import anyway?",
    characterPackageNameMismatch: "Character names do not match. Import anyway?",
    characterPackageImportToChar: "Import Package to Character",
    characterPackageLicenseWarning: "Character export is restricted by license policy",
    characterPackageCheckCount: "Check",
    userSetting: "User Settings",
    username: "Your Name",
    userIcon: "Your Icon",
    successExport: "Successfuly exported and downloaded to your download directory",
    successImport: "Successfuly imported",
    fileDropImport: {
        moduleLoading: (fileName: string) => `Importing module... (${fileName})`,
        presetLoading: (fileName: string) => `Importing prompt preset... (${fileName})`,
        pluginLoading: (fileName: string) => `Importing plugin... (${fileName})`,
        moduleAssets: (completed: number, total: number) =>
            `Importing module assets... (${completed.toLocaleString()} / ${total.toLocaleString()})`,
        moduleSuccess: "Imported into the module list.",
        presetSuccess: "Imported into the prompt preset list.",
        pluginSuccess: "Imported into the plugin list.",
        failed: (fileName: string, reason: string) =>
            `Could not import ${fileName}.${reason ? ` ${reason}` : ''}`,
    },
    moduleCreated: "Module created.",
    moduleUpdated: "Module updated.",
    moduleDeleted: "Module deleted.",
    importedCharacter: "Imported Character",
    alwaysActive: "Always Active",
    additionalPrompt: "Additional Prompt",
    descriptionPrefix: "Description Prefix",
    forceReplaceUrl: "Reverse Proxy",
    emotionWarn: "Auxiliary model is used.",
    plugin: "Plugin",
    language: "Language",
    UiLanguage: "UI Language",
    createfromScratch: "Create from Scratch",
    importCharacter: "Import Character",
    translator: "Translator",
    disabled: "Disabled",
    noPluginSelected: "Model selected as plugin, but no plugin selected.",
    text: "Text",
    UISize: "Chat Text Size",
    newVersion: "Update found, do you want to install?",
    updateAvailable: "v{{version}} update available",
    updateRequired: "v{{version}} required update available",
    updateOutdated: "v{{version}} — your version is too old",
    updatePopupTitle: "Update Available",
    updatePopupTitleRequired: "Required Update",
    updatePopupTitleOutdated: "Version Too Old",
    updatePopupDesc: "A new version <b>v{{latest}}</b> is available. (current: v{{current}})",
    updatePopupViewRelease: "View Release",
    updatePopupLater: "Later",
    selfUpdateNow: "Update Now",
    selfUpdateInProgress: "Updating...",
    selfUpdateDone: "Update Complete",
    selfUpdateFailed: "Update Failed",
    selfUpdateReloadHint: "Please reload the page to use the new version.",
    selfUpdateReload: "Reload",
    close: "Close",
    remindLaterQuestion: "When should I remind you?",
    remindIgnore: "Ignore",
    remindLater1Day: "Remind in 1 day",
    remindLater3Days: "Remind in 3 days",
    remindLater5Days: "Remind in 5 days",
    remindLater1Week: "Remind in 1 week",
    display: "Display",
    useCustomBackground: "Custom Background",
    translateInput: "Translate Input",
    autoTranslation: "Auto Translation",
    fullscreen: "Fullscreen (Not recommended)",
    playMessage: "Play Message Audio",
    iconSize: "Icon Size",
    single: "Single",
    multiple: "Multiple",
    useCharLorebook: "Use Lores in Characters",
    selectChar: "Select Character",
    askLoadFirstMsg: "Shall we load the first message?",
    theme: "Theme",
    editOrder: "Edit Order",
    submodel: "Auxiliary Model",
    timeOutinSec: "Timeout (in seconds)",
    emotionPrompt: "Emotion Prompt",
    singleView: "Single View",
    SpacedView: "Multiple Character View",
    emphasizedView: "Double Character View",
    pluginWarn: "Installing malicious plugins can cause problems.",
    pluginConfirm: "Do you really want to import this plugin? Only import plugins from trusted sources.",
    pluginContainsExternalMedia: "This plugin contains external media.",
    pluginContainsExternalJS: "This plugin contains external Javascript.",
    waifuWidth: "Waifu Chat Width",
    files: "Files",
    backupConfirm: "Do you really want to save backup?",
    backupLoadConfirm: "Do you really want to load backup? All datas will be lost!",
    backupLoadConfirm2: "Do you really, really want to load backup? All datas will be lost!",
    others: "Others",
    sectionInterface: "Interface",
    sectionHomeList: "Home & Chat List",
    sectionChatView: "Chat View",
    sectionBubble: "Message Bubble",
    sectionQuotes: "Quotes",
    sectionAdvanced: "Advanced",
    accTabEditing: "Editing",
    accTabScroll: "Scroll",
    accTabSidebar: "Sidebar",
    presets: "Presets",
    themePresets: "Theme Presets",
    imageGeneration: "Image Generation",
    provider: "Provider",
    key: "Key",
    noData: "No Data",
    currentImageGeneration: "Current Image Generation Data",
    promptPreprocess: "Use Prompt Preprocess",
    SwipeRegenerate: "Use Swipe for Regeneration",
    removeMessageOnly: "Remove this message only ({} message)",
    removeMessageAndAfter: "Remove this and following messages ({})",
    messageRemoved: "Message removed",
    messagesRemoved: "{} messages removed",
    confirmReroll: "Confirm on Message Regeneration",
    textColor: "Text Color",
    classicRisu: "Classic Risu",
    highcontrast: "High-Contrast",
    requestretrys: "Request Retrys when Fail",
    utilityBot: "Utility Bot",
    waifuWidth2: "Waifu Character Size",
    nodeOnlyStandardChatWidth: "Chat Width",
    chatWidthStandard: "Standard",
    chatWidthWide: "Wide",
    chatWidthFull: "No Limit",
    customCSSWarning: "RisuBard's UI structure (HTML/CSS) differs from upstream RisuAI, so existing custom CSS may break the layout or behave unexpectedly. Use only when you know what you are overriding.",
    customHTMLWarning: "RisuBard's UI structure (HTML/CSS) differs from upstream RisuAI, so existing custom Chat HTML may not render correctly. Use only when you know what you are overriding.",
    sayNothing: "Input 'say nothing' when no string inputed",
    regexScript: "Regex Script",
    type: "Type",
    editInput: "Modify Input",
    editOutput: "Modify Output",
    editProcess: "Modify Request Data",
    loadLatest: "Load Latest Backup",
    loadOthers: "Load Other Backups",
    exampleMessage: "Example Message",
    creatorNotes: "Creator's Comment",
    systemPrompt: "System Prompt",
    characterNotes: "Character Notes",
    personality: "Personality",
    scenario: "Scenario",
    alternateGreetings: "Alternate Greetings",
    unrecommended: "Not Recommended",
    chatNotes: "Chat Notes",
    showUnrecommended: "Show Unrecommended Settings",
    streamingDisplayOptimizationMode: "Streaming Display Optimization",
    streamingDisplayOptimizationOff: "Off (every token)",
    streamingDisplayOptimizationOffDesc: "Redraw and run scripts on every incoming token",
    streamingDisplayOptimizationBalanced: "Update every 0.1s",
    streamingDisplayOptimizationBalancedDesc: "Batch redraws into 0.1s intervals to lower the load",
    streamingDisplayOptimizationStrong: "Apply after finish",
    streamingDisplayOptimizationStrongDesc: "Show raw text while streaming, then run scripts once at the end",
    allowV2Plugin: "Allow Deprecated V2.0 Plugins",
    altGreet: "Alternative First Messages",
    scripts: "Scripts",
    settings: "Settings",
    settingsWorkspace: {
        backToApp: "Back to app",
        close: "Close settings",
        aiWorkspace: {
            eyebrow: "Generation workspace",
            title: "AI & generation",
            description: "Choose how RisuBard generates, structures, and supports text. Existing settings remain intact, now organized by purpose in one workspace.",
            sectionNavigation: "AI settings sections",
            currentSection: "Current section",
            recommended: "Recommended",
            legacy: "Legacy",
            sections: {
                "model-presets": {
                    title: "Model presets",
                    description: "Models, providers, credentials, and generation parameters",
                },
                "chat-prompt-presets": {
                    title: "Chat prompt presets",
                    description: "Select and edit the shared prompt preset used by chat generation.",
                },
                "legacy-model": {
                    title: "Legacy model settings",
                    description: "Compatibility settings for the former chat model flow",
                },
                "auxiliary-ai": {
                    title: "Auxiliary AI",
                    description: "Memory, speech, emotion, and image generation helpers",
                },
            },
        },
        experienceWorkspace: {
            description: "Display, language, and accessibility share one focused workspace with a clear section for each task.",
            sectionNavigation: "Environment sections",
            currentSection: "Current section",
            sections: {
                display: "Theme, layout, typography, and visual behavior.",
                language: "Interface language and translation preferences.",
                accessibility: "Editing, scrolling, navigation, and assistive interaction options.",
            },
        },
        hotkeyWorkspace: {
            description: "Review shortcuts by action and edit modifiers or the assigned key in a structured grid.",
            columns: {
                action: "Action",
                modifiers: "Modifiers",
                key: "Key",
            },
            captureHint: "Focus a key field, then press the key you want to assign. Modifier-only presses are ignored.",
        },
        advancedWorkspace: {
            description: "Fine-tune context assembly, request behavior, optional features, and compatibility controls. Change only the settings you understand.",
            tabs: {
                context: "Context & prompts",
                request: "Request & output",
                features: "Features & interface",
                experimental: "Experimental & compatibility",
            },
            sections: {
                context: { title: "Context budget", description: "Control recent-message lookup, lorebook limits, and continuation thresholds." },
                prompts: { title: "Prompt overrides", description: "Edit global prompt fragments in full-width multiline fields." },
                request: { title: "Request execution", description: "Configure retries, generation count, media quality, caching, and connection behavior." },
                response: { title: "Response handling", description: "Choose how generated responses continue, recover, and expose prompt information." },
                interface: { title: "Interface behavior", description: "Adjust advanced display, scrolling, image, and bookmark behavior." },
                features: { title: "Optional features", description: "Manage assets, file handling, sync, and other optional capabilities." },
                utilities: { title: "Maintenance tools", description: "Inspect character exclusions and export the active settings." },
                experimental: { title: "Experimental features", description: "Enable preview features and reveal their dependent controls." },
                compatibility: { title: "Compatibility & diagnostics", description: "Use legacy, provider compatibility, and developer controls when troubleshooting." },
            },
        },
        personaManager: {
            close: "Close persona manager",
            help: "A persona defines who you are in the story. Its name replaces the {{user}} tag, and its description is injected into the story prompt.",
            globalTab: "Global",
            characterTab: "Character",
            create: "Create a new persona",
            resizeList: "Resize the persona list",
            resizeWindow: "Resize the persona manager",
            changeImage: "Change persona image",
            openDescriptionEditor: "Open description in the popup editor",
            resizeDescription: "Resize the description editor",
            usePortraitImage: "Switch to portrait image",
            useSquareImage: "Switch to square image",
            duplicate: "Duplicate",
            cloneToCharacter: "Clone to character",
            cloneToGlobal: "Clone to global",
            export: "Export persona",
            import: "Import persona",
            remove: "Delete persona",
            noCharacter: "Select a character to manage its personas.",
            noCharacterPersonas: "This character has no personas yet.",
            globalGroup: "Global personas",
            characterGroup: "Character personas",
            builder: {
                launch: "Persona Builder",
                title: "Persona Builder",
                description: (name: string) => `Draft and refine the description for ${name} with AI.`,
                close: "Close persona builder",
                taskPrompt: "Task Instruction Prompt",
                stylePrompt: "Style Instruction Prompt",
                taskPromptPlaceholder: "Describe the task and required output format.",
                stylePromptPlaceholder: "Add style, wording, translation, and banned-expression rules.",
                presetSelect: "Select preset",
                presetSave: "Save new",
                presetOverwrite: "Overwrite",
                presetDelete: "Delete preset",
                presetNamePrompt: "Enter a name for the new preset.",
                presetOverwriteConfirm: (name: string) => `Overwrite “${name}” with the current content?`,
                presetDeleteConfirm: (name: string) => `Delete the “${name}” preset?`,
                presetSaved: "Preset saved.",
                presetOverwritten: "Preset overwritten.",
                presetDeleted: "Preset deleted.",
                presetNameExists: "A preset with this name already exists for this prompt type.",
                presetInvalid: "Enter both a preset name and prompt content.",
                builtinPresetHint: "Built-in presets are protected. Use Save new to keep your edited version as a separate preset.",
                contextTitle: "Context to inject",
                systemPrompt: "System prompt",
                characterDescription: "Character description",
                characterLorebook: "Character lorebook",
                moduleLorebook: "Module lorebook",
                contextUnavailable: "No source available",
                noCharacterContext: "No character is selected, so character description and lorebook context are unavailable.",
                instructionLabel: "Tell the AI what to do",
                instructionPlaceholder: "Describe the persona you want, or enter a revision such as “Make the draft more concise.”",
                draftTitle: "Draft",
                originalDraft: "Original",
                revisedDraft: "Revision",
                draftPlaceholder: "The generated result appears here. Manual edits are injected as the draft in the next request.",
                send: "Send",
                stop: "Stop",
                reset: "Reset",
                undo: "Undo",
                previousOriginal: "Go to previous original",
                nextOriginal: "Go to next original",
                copyDraft: "Copy result to persona",
                copyConfirm: "Replace the current persona description with this draft?",
                copied: "Draft copied to the persona description.",
                copyFailed: "Could not copy the draft to the persona description.",
                taskRequired: "Enter a task instruction prompt.",
                instructionRequired: "Enter an instruction for the AI.",
                emptyResponse: "The model returned an empty result.",
                requestFailed: "Failed to generate a persona draft.",
            },
        },
        sections: {
            ai: "AI & generation",
            risubard: "RisuBard",
            experience: "Experience",
            extensions: "Extensions",
            system: "Data & system",
        },
    },
    selective: "Multiple keys",
    SecondaryKeys: "Secondary keys",
    useGlobalSettings: "Use Global Settings",
    recursiveScanning: "Recursive Scanning",
    maxRecursionSteps: "Maximum Recursion Steps (0 = Unlimited)",
    creator: "Creator",
    CharVersion: "Character Version",
    Speech: "Speech",
    useExperimental: "Able Experimental Features",
    showMemoryLimit: "Show Memory Limit",
    showFirstMessagePages: "Show First Message Pages",
    roundIcons: "Round Icons",
    streaming: "Streaming",
    chatBot: "Chat Bot",
    modelPresetMenu: "Model Preset",
    promptPresetMenu: "Prompt",
    botSettingsLegacyTitle: "[Chat Bot] is a legacy feature",
    botSettingsLegacyDesc: "Model updates may be delayed and new features may not apply here. Use [Model Preset] for up-to-date models and features.",
    botSettingsPresetMovedDesc: "Presets have moved to the [Prompt] menu.",
    botSettingsParamScopeDesc: "Parameters on this page only apply to the model selected in [Chat Bot]. If you use a Model Preset, edit parameters inside that preset.",
    currentThemePreset: "Current Theme Preset",
    currentPromptPreset: "Current Prompt Preset",
    promptPresetDescription: "Prompt Description",
    promptPresetDescriptionPlaceholder: "Briefly describe this prompt preset.",
    promptPresetDescriptionLinkHint: "Shift-click a web address to open it.",
    presetDuplicate: "Duplicate",
    presetExport: "Export",
    presetImport: "Import",
    presetDelete: "Delete",
    presetDuplicated: "Preset duplicated",
    presetExported: "Preset exported",
    presetImported: "Preset imported",
    presetDeleted: "Preset deleted",
    presetDeleteConfirm: "Delete this preset?",
    iconRemove: "Remove Icon",
    otherBots: "Other Bots",
    user: "User",
    additionalAssets: "Additional Assets",
    viewInAssetViewer: "View in Asset Viewer",
    editDisplay: "Modify Display",
    textBackgrounds: "Custom Text Screen Color",
    textBorder: "Text Outlines",
    textScreenRound: "Round Text Screen",
    textScreenBorder: "Text Screen Borders",
    ttsReadOnlyQuoted: "Read Only Quoted",
    ttsStop: "Stop TTS",
    replaceGlobalNote: "Global Note Replacement",
    charLoreBook: "Character Lorebook",
    globalLoreBook: "Global Lorebook",
    globalRegexScript: "Global Regex",
    accessibility: "Accessibility",
    sendWithEnter: "Send with Enter Key",
    sendKeyPC: "Send Key (PC)",
    sendKeyMobile: "Send Key (Mobile)",
    chatInputExpandTitle: "Message input",
    resendLastMessage: "Resend the last message",
    enterMessagePlaceholder: "Enter a message...",
    enterMessageToPersona: (name: string) => `Message ${name}...`,
    sendKeyEnter: "Enter (Shift+Enter for newline)",
    sendKeyCtrlEnter: "Ctrl+Enter (Enter for newline)",
    sendKeyShiftEnter: "Shift+Enter (Enter for newline)",
    sendKeyButton: "Send button only (Enter for newline)",
    fixedChatTextarea: "Fix chat input to bottom",
    clickToEdit: "Click Text to Edit",
    enableBlockPartialEdit: "Enable Block Partial Edit (Hover to edit individual blocks)",
    enableDragPartialEdit: "Enable Drag Partial Edit (Select text to edit)",
    setNodePassword: "Set your password to security",
    inputNodePassword: "Input your password. if you can't remember, remove save/__password.txt in your server files and restart the server.",
    simple: "Simple",
    advanced: "Advanced",
    askReRollAutoSuggestions: "Re-Roll Auto Suggestions",
    creatingSuggestions: "Creating Suggestions...",
    active: "Active",
    loreRandomActivation: "Use Probability Condition",
    activationProbability: "Probability",
    hub: "RisuRealm",
    tags: "Tags",
    backgroundHTML: "Background Embedding",
    copied: "Copied",
    copyForArca: "Arca Chat Saver",
    copyForArcaDone: "Arca Chat Saver message copied",
    copyForArcaFailed: "Could not create an Arca Chat Saver copy",
    arcaChatLog: {
        menu: "Create Arca chat log",
        title: "Arca chat log",
        messages: " messages",
        stepOne: "Step 1",
        rangeHeading: "Choose messages",
        rangeHelp: "Copy the whole chat or only the part you need.",
        wholeChat: "Whole chat",
        range: "Message range",
        rangeShortHelp: "Choose start and end",
        pageRange: "Page range",
        turnRange: "Turn range",
        pages: " pages",
        turns: " turns",
        pageUnit: "page",
        turnUnit: "turn",
        wholeChatSelected: "The whole chat is selected.",
        includeUserMessages: "Include user",
        excludeUserMessages: "Exclude user",
        userMessages: "User messages",
        from: "From",
        to: "To",
        selected: "Selected",
        total: "Total",
        charactersUnit: " chars",
        imagesLabel: "images",
        countUnit: "",
        exclusionNote: "Disabled messages and comments are left out automatically.",
        outputSettings: "Output settings",
        appearance: "Log appearance",
        settingsHelp: "Adjust the values, then apply to rebuild the preview.",
        fontSize: "Font size (px)",
        paragraphSpacing: "Paragraph spacing (%)",
        imageWidth: "Regular image width (%)",
        profileImages: "Profile images",
        complexLayoutHelp: "Special backgrounds and status cards are preserved as images; FAB side panels are exported as separate images.",
        applySettings: "Apply",
        cancelSettings: "Cancel",
        collapseSidebar: "Close message selection panel",
        openSidebar: "Open message selection panel",
        stepTwo: "Step 2",
        preview: "Paste preview",
        ready: "Ready to copy",
        generating: "Building preview…",
        failed: "Could not build the log",
        emptyPreview: "Your finished log will appear here.",
        createPreview: "Build preview",
        copy: "Copy for Arca",
        copied: "Arca chat log copied.",
        copiedShort: "Copied",
        copyFailed: "Could not copy the Arca chat log.",
        clipboardUnsupported: "Rich clipboard copy is not available in this browser.",
        renderFailed: "A chat message could not be rendered.",
    },
    useChatCopy: "Use Chat Message Copy",
    useChatSticker: "Use Chat Sticker",
    useAdditionalAssetsPreview: "Use Additional Assets Preview",
    autoTranslateInput: "Auto Translate Input",
    enterMessageForTranslateToEnglish: "Enter Message for Translate to English",
    recent: "Recent",
    downloads: "Downloads",
    trending: "Trending",
    imageCompression: "Image Compression",
    inlayImageLossless: "Save Inlay Images as Lossless",
    inlayImagePriority: "Prioritize Inlay Image Rendering",
    inlayCompressAll: "Compress All Inlay Images",
    inlayCompressing: "Compressing...",
    inlayCompressConfirm: "All inlay images will be compressed to WebP. This cannot be undone. Continue?",
    inlayCompressDone: "Compression complete",
    inlayCompressCount: " images compressed",
    saved: "saved",
    notLoggedIn: "Not Logged in to Risu Account",
    SaveDataInAccount: "Save Data in Account",
    dataSavingInAccount: "Saving Data in Account",
    logout: "Logout",
    loadDataFromAccount: "Load Data from Account",
    saveCurrentDataToAccount: "Save Current Data to Account",
    chatAssumed: "",
    proxyAPIKey: "Key/Password",
    proxyRequestModel: "Request Model",
    officialWiki: "Official Wiki",
    officialWikiDesc: "Official Wiki for RisuBard. feel free to see.",
    officialDiscord: "Official Discord",
    officialDiscordDesc: "Official Discord to talk about RisuBard",
    persona: "Persona",
    icon: "Icon",
    account: "Account",
    remove: "Remove",
    able: "Able",
    assetWidth: "Asset Images Max Width",
    animationSpeed: "Animation Speed",
    screenshot: "Screenshot",
    screenshotSaved: "Screenshot Saved",
    createBotwithAI: "Create Bot from AI",
    changeFolderName: "Input the new folder name (blank to cancel)",
    cancel: "Cancel",
    renameFolder: "Rename Folder",
    changeFolderColor: "Change Folder Color",
    changeFolderImage: "Change Folder Image",
    fullWordMatching: "Space-delimited Exact Matching",
    lorebookMatchingMode: "Keyword Matching Mode",
    partialMatching: "Partial Matching",
    wordBoundaryMatching: "Unicode Word Boundary Matching",
    botSettingAtStart: "Bot Menu when Launch",
    triggerStart: "On chat Send",
    triggerInput: "On user's output",
    triggerOutput: "On character's output",
    triggerManual: "Manual trigger only",
    triggerCondVar: "If Variable",
    triggerCondExists: "If Text Exists on Chat",
    triggerScript: "Trigger Script",
    triggerMatchRegex: "Match with Regex",
    triggerMatchLoose: "Match Loosely",
    triggerMatchStrict: "Match Strictly",
    searchDepth: "Search Depth",
    equal: "Equal to",
    notEqual: "Not Equal to",
    greater: "Greater than",
    less: "Less than",
    greaterEqual: "Greater or Equal to",
    lessEqual: "Less or Equal to",
    triggerEffSysPrompt: "Add System Prompt",
    triggerEffSetVar: "Modify Variable",
    triggerEffImperson: "Send Chat",
    triggerEffCommand: "Run Command",
    triggerEffRunTrigger: "Run Trigger",
    triggerEffStop: "Stop Sending Prompt",
    triggerEffCall: "Call Trigger",
    varableName: "Variable Name",
    role: "Role",
    location: "Location",
    promptstart: "Start of Prompt",
    promptend: "End of Prompt",
    historyend: "End of History",
    always: "Always",
    noEffect: "No Effect",
    invaildTriggerEffect: "This effect doesn't works for this trigger type.",
    operator: "Operator",
    TriggerSetToVar: "Set to Variable",
    TriggerAddToVar: "Add to Variable",
    TriggerSubToVar: "Subtract from Variable",
    TriggerMulToVar: "Multiply to Variable",
    TriggerDivToVar: "Divide from Variable",
    isNull: "is not set",
    ifChatIndex: "If chat index",
    ifRandom: "If random",
    ifValue: "If Value",
    hideRealm: "Start RisuRealm Collapsed",
    hideAllImages: "Hide All Images",
    popularityLevel: "{} Popularity",
    colorScheme: "Color Scheme",
    colorSchemeDefault: "Default",
    showLegacyColorSchemes: "Show legacy palettes",
    rangeStart: "Range Start",
    rangeEnd: "Range End",
    untilChatEnd: "Until Chat End",
    usePromptTemplate: "Use Prompt Template",
    specialType: "Special Type",
    noSpecialType: "No Special Type",
    forceProxyAsOpenAI: "Force Proxy Format as OpenAI",
    promptTemplate: "Prompt Template",
    customInnerFormat: "Custom Inner Format",
    innerFormat: "Inner Format",
    HypaMemory: "HypaMemory",
    ToggleHypaMemory: "Toggle HypaMemory",
    resetPromptTemplateConfirm: "Do you really want to reset prompt template?",
    emotionMethod: "Emotion Method",
    continueResponse: "Continue Response",
    showMenuChatList: "Show Menu Chat List",
    translatorLanguage: "Translator Language",
    translatorType: "Translator Type",
    htmlTranslation: "HTML Translate",
    deeplKey: "deepL API Key",
    deeplFreeKey: "deepL Free API Key",
    deeplXUrl: "deepLX URL",
    deeplXToken: "deepLX Token",
    exportPersona: "Export Persona",
    importPersona: "Import Persona",
    export: "Export",
    import: "Import",
    useNamePrefix: "Use Name Prefix",
    textAdventureNAI: "Run as Text Adventure",
    appendNameNAI: "Append Name on NAI",
    customStopWords: "Custom Stop Words",
    defaultPrompt: "Default Prompt",
    additionalText: "Additional Description",
    seed: "Seed",
    charjs: "CharacterJS",
    depthPrompt: "Depth Prompt",
    largePortrait: "Portrait",
    reverseProxyOobaMode: "Ooba Mode",
    exactTokens: "Exact Tokens",
    fixedTokens: "Approximate Tokens",
    inlayViewScreen: "Inlay Screen",
    imgGenPrompt: "Image Generation Prompt",
    imgGenNegatives: "Image Generation Negative Prompt",
    imgGenInstructions: "Image Generation Instructions",
    usePlainFetchWarn: "Please disable this option when using NovelAI, as it can cause CORS errors when using NovelAI.",
    translationPrompt: "Translation Prompt",
    translationResponseSize: "Translation Response Size",
    webdeeplwarn: "This option is not recommended for use with web version, as it can cause CORS errors.",
    saveBackupLocal: "Save Backup Locally",
    saveBackupForUpstream: "Export Original RisuAI-Compatible Backup",
    saveBackupForUpstreamConfirm: "This backup is intended for moving your data to the original RisuAI (web/Tauri). Inlay images and RisuBard-only files such as BardWiki and manuscripts are excluded. Other data (database, character assets, cold storage) is included.\n\nFor PocketRisu or another RisuBard installation, use the regular full backup instead.\n\nProceed?",
    loadBackupLocal: "Load Backup Locally",
    topP: "Top P",
    genTimes: "Generation Choices",
    cot: "Chain of Thoughts",
    forcePlainFetch: "Force Plain Fetch",
    autoFillRequestURL: "Autofill Request URL",
    newOAIHandle: "New OpenAI Handling",
    inlayImage: "Inlay Image Feature",
    nativeAutomark: "Experimental Native Automark",
    assistantPrefill: "Assistant Prefill",
    postEndInnerFormat: "Post End",
    sendChatAsSystem: "Send Chat as System",
    sendName: "Send Name on Non-group Chat",
    utilOverride: "Utility Override",
    template: "Template",
    chatAsOriginalOnSystem: "Send as original role",
    exportAsDataset: "Export Save as Dataset",
    editTranslationDisplay: "Edit Translation Display",
    selectModel: "Select Model",
    autoRemoveThoughtTag: "Remove Thought Tag",
    customChainOfThought: "Custom Chain of Thoughts",
    maxThoughtTagDepth: "Max Thought Tag Depth",
    openRouterFallback: "Use Fallback",
    openRouterMiddleOut: "Use Middle Out",
    openRouterProviderOrder: "Provider Preference Order",
    openRouterProviderOnly: "Allowed Providers",
    openRouterProviderIgnore: "Ignored Providers",
    openRouterSearchModel: "Search models...",
    openRouterSortByName: "Name",
    openRouterSortByPrice: "Price",
    openRouterSortByProvider: "Provider",
    openRouterSortAsc: "Asc",
    openRouterSortDesc: "Desc",
    geminiApiKey: "Gemini API Key",
    memoryLimitThickness: "Memory Limit Thickness",
    inputCardPassword: "Input Card Password",
    ccv2Desc: "Character Card V2 is a format widely used in chatbot programs.",
    ccv3Desc: "Character Card V3 is a next generation format that is used in chatbot programs.",
    rccDesc: "Risu Refined Character Card is a format with additional features like password, integrity check and etc.",
    password: "Password",
    license: "License",
    licenseDesc: "You can choose license for the downloaders to limit the usages of your card's prompt.",
    passwordDesc: "You can set a password to protect your card from unauthorized access.",
    largePersonaPortrait: "Persona Portrait",
    module: "Module",
    modules: "Modules",
    noModules: "No modules has been installed.",
    createModule: "Create Module",
    basicInfo: "Basic Info",
    promptV2: {
        tab: "Prompt V2",
        promptsMode: "Prompt blocks",
        togglesMode: "Toggle setup",
        blockList: "Prompt list",
        editor: "Block editor",
        searchBlocks: "Search blocks...",
        jumpToMatch: "Go to next match in the selected block (Enter)",
        replaceWith: "Replace with...",
        replaceOne: "Replace one",
        replaceAll: "Replace all",
        replaceOneHint: "Replace the first match in the selected block",
        replaceAllHint: "Replace every match across all prompt blocks",
        matchCount: (count: number) => `${count} ${count === 1 ? 'match' : 'matches'}`,
        addBlock: "Add block",
        newBlock: "New block",
        duplicateBlock: "Duplicate block",
        noBlocks: "No prompt blocks yet.",
        active: "Active",
        inactive: "Inactive",
        always: "Always",
        manual: "Manual",
        activation: "Activation",
        activationAlways: "Always include this block",
        activationConditional: "Include when conditions match",
        matchAll: "All conditions (AND)",
        matchAny: "Any condition (OR)",
        is: "is",
        isNot: "is not",
        on: "On",
        off: "Off",
        addCondition: "Add condition",
        variableLibrary: "Toggle variables",
        searchVariables: "Search variables...",
        noToggleVariables: "No custom toggles are defined.",
        noSearchResults: "No matching items.",
        copyKey: "Copy variable key",
        insertCondition: "Use as condition",
        copied: "Copied",
        sidebarPreview: "Sidebar preview",
        previewHint: "Preview values are saved per preset on this device and do not change the current chat.",
        resetPreview: "Reset preview",
        toggleSource: "Custom toggle source",
        toggleSourceHint: "This remains the canonical, portable toggle format. Changes render in the preview immediately.",
        toggleSourcePlaceholder: "key=Label\nmode=Mode=select=Off,On",
        promptBody: "Prompt",
        editorMode: "Body editor mode",
        sourceMode: "Source",
        visualMode: "Visual",
        syntaxPalette: "Condition syntax",
        conditionDesigner: "Condition designer",
        syntaxPaletteHint: "Place the caret or select text in the body, then insert a condition block.",
        conditionJoin: "Condition join",
        conditionOperator: "Comparison operator",
        insertAtCursor: "Insert condition at caret",
        wrapSelection: "Wrap selection in condition",
        innerFormat: "Inner format",
        unsupportedActivation: "Chat and cache blocks are structural and cannot be conditionally hidden.",
        manualConditionTitle: "Hand-written condition detected",
        manualConditionDescription: "This block uses condition syntax the visual editor cannot safely rewrite. Its source is preserved exactly; use the legacy Prompt tab to edit it.",
        listPane: "List pane",
        previewPane: "Preview pane",
        workspaceHelp: "Select a block, define when it is active, then test the result with the sidebar preview.",
        selectBlock: "Select a prompt block",
        deleteBlock: "Delete block",
        moveUp: "Move up",
        moveDown: "Move down",
        conditionValue: "Value",
        rawVariableKey: "Global variable key",
        lineNumber: (line: number) => `Line ${line}`,
        toggleCount: (count: number) => `${count} variables`,
        blockCount: (count: number) => `${count} blocks`,
    },
    moduleContent: "Module Content",
    confirmRemoveModuleFeature: "Do you really want to remove this feature? This action cannot be undone.",
    editModule: "Edit Module",
    importModule: "Import Module",
    download: "Download",
    edit: "Edit",
    enableGlobal: "Enable Globally",
    chatModuleActivation: {
        global: "All chats", chat: "Chat", on: "On", off: "Off",
        description: "All chats applies everywhere; Chat keeps a separate setting for the current chat. Either scope can enable a module. Turning off All chats preserves individual chat settings.",
        selectDescription: "Find a module in its folder and select it.",
        globalHint: "Enable for all chats. Individual chat settings are preserved.",
        chatHint: "Enable for this chat. To use it only here, turn off All chats.",
        noChat: "Open a chat to use this setting.",
        characterEnabled: "Also enabled by this character's existing settings.",
        personaEnabled: "Also enabled by the active persona.",
        presetEnabled: "Automatically enabled by the current preset. Clicking only toggles manual global activation; preset activation remains enabled.",
        selectModule: "Select {0}",
    },
    managePersonaModules: "Assign to personas",
    personaModuleAssignments: "Persona module assignments",
    personaModuleAssignmentsDescription: "Enable this module whenever one of the selected personas is active.",
    searchPersonas: "Search personas",
    noPersonasFound: "No personas found.",
    globalPersonaScope: "Global persona",
    chatModulesInfo: "You can enable or disable modules for this chat. You can also enable for this character by right clicking or long pressing the enable button.",
    sideMenuRerollButton: "Side Menu Reroll Button",
    persistentStorage: "Persistent Storage",
    persistentStorageSuccess: "Storage is successfully persisted",
    persistentStorageFail: "Storage is not persisted. Did you deny the request?, or is the browser not supported?",
    persistentStorageRecommended: "Persistent Storage Recommended",
    unsupportedFileType: "Unsupported file type",
    persistentStorageDesc: "Your browser supports persistent storage. this is recommended for better performance and user experience.",
    enable: "Enable",
    postFile: "Post File",
    requestInfoInsideChat: "Show Request Info Inside Chat",
    inputTokens: "Input Tokens",
    outputTokens: "Output Tokens",
    tokenWarning: "Token caculation can be inaccurate. it is recommended to use it as a reference.",
    log: "Log",
    popularityLevelDesc: "Popularity increases with downloads, etc. to estimate, 3.7 popularity is about 1 downloads.",
    additionalParams: "Additional Parameters",
    additionalParamsHelp: "One per line. Supports `key=value`, `key=json::{...}`, `header::Name=value`, `key={{none}}`.",
    tokenizerOverride: "Tokenizer Override",
    tokenizerOverrideHelp: "Used for token counting. Leave Auto to use the profile recommendation.",
    tokenizerAuto: "Auto",
    heightMode: "Height Mode",
    useAdvancedEditor: "Use Advanced Editor",
    noWaitForTranslate: "No Wait for Translate",
    antiClaudeOverload: "Anti-Claude Overload",
    activeTabChange: "Current tab is inactivated since other tab is active. to activate this tab, click OK",
    sessionHandoffReload: "Refreshed to the latest state because another device was in use.",
    canonicalFilesChangedReload: "External file edits were detected. RisuBard kept the newer files and refreshed them.",
    canonicalSaveConflictTitle: "External files changed while you were editing",
    canonicalSaveConflictKeep: "Save my current edits first",
    canonicalSaveConflictDownload: "Download unsaved edits as JSON",
    canonicalSaveConflictDetail: "Your edits are still in this window. Saving your edits gives priority to this window's settings and edited items over the same data in the external files. Other items are loaded from the latest files. You can download your unsaved edits first; this file is not a complete backup. Cancel keeps your edits here and asks again on the next save. No automatic refresh will occur.",
    canonicalSaveConflictPaused: "Changes are not saved yet. Resolve the external-file conflict to resume saving.",
    externalEditModeStart: "Start external file editing",
    externalEditModeFinish: "Finish external editing and reload",
    externalEditModeStartConfirm: "RisuBard will save current changes, then pause browser saving. Do not edit or generate content in RisuBard until external editing is finished.\n\nStart external file editing?",
    externalEditModeFinishConfirm: "RisuBard will validate the externally edited files and reload them. Invalid files will keep saving paused so they can be corrected.\n\nFinish external editing and reload?",
    externalEditModeStarted: "Browser saving is paused. Finish external editing with the hourglass button.",
    externalEditModeReloaded: "External file editing finished and the latest files were loaded.",
    externalEditModeFailed: "Could not change external editing mode.",
    externalEditModeSavePaused: "Browser saving is paused for external file editing.",
    addCharacter: "Add Character",
    importFromRealm: "Choose from RisuRealm",
    importFromRealmDesc: "Choose over 1000 characters in RisuRealm",
    random: "Random",
    metaData: "Meta Data",
    autoContinueMinTokens: "Target Tokens (Auto Continue)",
    autoContinueChat: "Anti-Incomplete Response (Auto Continue)",
    removeIncompleteResponse: "Remove Incomplete Sentences",
    tokenizer: "Tokenizer",
    chatFormating: "Chat Formating",
    useInstructPrompt: "Use Instruction Prompt",
    textAreaSize: "Input box size",
    textAreaTextSize: "Input text size",
    sideBarSize: "Sidebar Size",
    embedding: "Embedding",
    syntax: "Syntax",
    run: "Run",
    noMessage: "Type something to start the chat.",
    combineTranslation: "Combine Translation",
    dynamicAssets: "Dynamic Assets",
    dynamicAssetsEditDisplay: "Use Dynamic Assets in Display",
    longTermMemory: "Long Term Memory",
    grid: "Grid",
    list: "List",
    trash: "Trash",
    trashDesc: "Deleted characters are moved to trash. you can restore or delete them permanently. deleted characters are automatically purged after 3 days.",
    share: "Share",
    manageCharacter: "Manage",
    shareExport: "Share/Export",
    risupresetDesc: "Risupreset format is a format specifically designed for RisuBard presets.",
    risuMDesc: "RisuM format is a format that is specifically designed for RisuBard modules.",
    jsonDesc: "JSON format is a format that is easy to read and write for both humans and machines.",
    nickname: "Nickname",
    useRegexLorebook: "Use Regex",
    customPromptTemplateToggle: "Custom Toggles",
    defaultVariables: "Default Variables",
    lowLevelAccess: "Low Level Access",
    resultStoredVar: "Variable to Store Result",
    triggerEffRunLLM: "Run Main Model",
    triggerEffectSendAI: "Resend AI",
    triggerEffCheckSim: "Check Similarity",
    triggerEffShowAlert: "Show Alert",
    normal: "Normal",
    error: "Error",
    input: "Input",
    select: "Select",
    options: "Options",
    alertContent: "Alert Content",
    lowLevelAccessConfirm:
        "This content uses Low Level Access. which means this content can access the AI model and your storage directly. do you really want to import this content?",
    triggerLowLevelOnly: "This trigger only works with Low Level Access. to enable this trigger, enable Low Level Access in advanced settings in the character or module.",
    truthy: "Truthy",
    extractRegex: "Extract Text with Regex",
    runImgGen: "Run Image Generation",
    cutChat: "Cut Chat",
    modifyChat: "Modify Chat",
    regex: "Regex",
    flags: "Flags",
    resultFormat: "Result Format",
    negPrompt: "Negative Prompt",
    start: "Start",
    end: "End",
    index: "Index",
    search: "Search",
    goCharacterOnImport: "Go to Character on Realm Import",
    format: "Format",
    v2Warning: "Warning: V2 card is no longer supported. it may not contain all the data.",
    applyModule: "Apply Module",
    successApplyModule: "Module is successfully applied",
    font: "Font",
    lineHeight: "Line Height",
    loadAutoServerBackup: "Load Auto Server Backup",
    notCharxWarn: "This character uses multiple assets. it is recommended to export this character as a CharX format for better compatibility.",
    noPlugins: "No Plugins Installed",
    legacyTranslation: "Legacy Translation",
    clipboardSuccess: "Copied to Clipboard",
    translateContent: "Translate Content",
    doNotTranslate: "Do Not Translate",
    includePersonaName: "Include Persona Name",
    hidePersonaName: "Hide Persona Name",
    triggerSwitchWarn: "If you change the trigger type, current triggers will be lost. do you want to continue?",
    codeMode: "Code",
    blockMode: "Block",
    helpBlock: "Help",
    hideChatIcon: "Hide Icon UI",
    loadInternalBackup: "Load Internal Backup",
    createCopy: "Create a Copy",
    copyChatConfirm: "Create a copy of: ",
    copyChatSuccess: "Chat copied",
    bindPersona: "Bind Persona",
    chatOptions: "Chat Options",
    doYouWantToBindCurrentPersona: "Do you want to bind the current persona to this chat?",
    doYouWantToUnbindCurrentPersona: "Do you want to unbind the persona from this chat?",
    personaBindingLabel: "Persona Binding",
    pinPersonaOnNewChat: "Pin persona when creating a new chat",
    personaBindedSuccess: "Persona is successfully binded",
    personaUnbindedSuccess: "Persona is successfully unbinded",
    personaBindChange: "Change Persona",
    personaBindUnbind: "Unbind",
    personaBindCurrent: "Bind Current Persona",
    personaSelectOther: "Select Other Persona",
    promptBindingLabel: "Prompt Binding",
    promptPresetParamsUse: "Use Prompt Parameters",
    promptPresetParamScopeDesc: "These parameters are stored in this prompt preset. In classic model mode they always apply. With a Model Preset, sampling parameters apply only to chats where \"Use Prompt Parameters\" is enabled in the sidebar's Prompt Binding. Capacity settings (Max Context/Response) are properties of the model, so the model preset always decides them.",
    promptBindedSuccess: "Prompt preset is successfully binded",
    promptUnbindedSuccess: "Prompt preset is successfully unbinded",
    promptBindChange: "Change Prompt Preset",
    promptBindUnbind: "Unbind",
    promptBindCurrent: "Bind Current Prompt",
    presetSelectOther: "Select Other Prompt Preset",
    promptPresets: "Prompt Presets",
    collectionOrganizer: {
        resizeWindow: "Resize manager window",
        resizePanes: "Resize folders and items",
        resizeHint: "Drag or use arrow keys to resize. Shift: larger steps. Double-click or Home: reset.",
        title: "Organize {}",
        description: "Group and reorder items without changing their runtime data.",
        close: "Close organizer",
        all: "All",
        uncategorized: "Uncategorized",
        folders: "Folders",
        items: "Items",
        createFolder: "Create folder",
        newFolderPlaceholder: "New folder",
        renameFolder: "Rename folder",
        renameFolderPrompt: "Enter a folder name",
        deleteFolder: "Delete folder",
        deleteFolderConfirm: "Delete the folder \"{}\"? Its items will become uncategorized.",
        moveFolderUp: "Move folder up",
        moveFolderDown: "Move folder down",
        searchPlaceholder: "Search names and details",
        filterStatus: "Filter by status",
        allStatuses: "All statuses",
        enabledStatus: "Enabled",
        disabledStatus: "Disabled",
        enableItem: "Enable {}",
        disableItem: "Disable {}",
        selectVisible: "Select visible",
        clearSelection: "Clear",
        selectedCount: "{} selected",
        moveTarget: "Destination folder",
        chooseFolder: "Choose a folder",
        moveSelected: "Move selected",
        deleteSelected: "Delete selected",
        deleteSelectedConfirm: "Delete {} selected items? This cannot be undone.",
        deleteSelectedDone: "Deleted {} items",
        noItems: "No matching items",
        selectItem: "Select {}",
        dragItem: "Drag to move item",
        dragItemKeyboardHint: "Drag to move. Press Alt+Up or Alt+Down to reorder with the keyboard.",
        moveItemUp: "Move item up",
        moveItemDown: "Move item down",
        open: "Organize folders",
    },
    presetEdit: "Edit",
    modelPresets: "Model Presets",
    modelPresetEmpty: "No model presets registered",
    modelPresetCreate: "Create new model preset",
    basicSettings: "Basic Settings",
    backToList: "Back to list",
    selectProfile: "Select Profile",
    searchProfiles: "Search profiles",
    noProfileMatch: "No matching profile",
    modelPresetCreated: "Model preset created",
    profileStatusCurrent: "Current",
    profileStatusOutdated: "Outdated",
    profileStatusDeprecated: "Deprecated",
    profileTabOfficial: "Official",
    profileTabCustom: "Custom",
    profileImport: "Import profile",
    profileExport: "Export",
    profileDelete: "Delete",
    profileExportNoBase: "Cannot export: base provider not found.",
    profileImportParseError: "Failed to parse JSON.",
    profileImportInvalid: "Invalid profile fragment:",
    profileOverwriteConfirm: "A custom profile with the same id already exists. Overwrite?",
    profileImported: "Profile imported.",
    customProfileEmpty: "No custom profiles. Import one to add.",
    profileReplace: "Replace profile",
    profileReplaced: "Profile replaced.",
    profileDataIncomplete: "This profile's data is incomplete. Reopen the Model Preset menu to refresh the registry, then try again.",
    profileUpdateAvailable: "Update available",
    profileSourceMissing: "Source profile not found",
    profileSectionTitle: "Profile",
    profileUpdatedAtLabel: "Current version",
    profileLatestVersionLabel: "Latest",
    profileUpdateConfirm: "Update to this profile?",
    profileReplaceWarn: "Settings not defined by this profile will be lost. Continue?",
    profileUpdateLossWarn: "Some settings may be lost. Continue?",
    registryNoticeBanner: "{n} model profiles updated",
    registryNoticeMore: "Details",
    registryNoticeTitle: "Model profile updates",
    registryNoticeNewSection: "New models",
    registryNoticeUpdatedSection: "Updated models",
    registryNoticeDismiss: "Don't show this update again",
    registryNoticeConfirm: "OK",
    apiKeyManagerMenu: "Manage API keys",
    apiKeyManagerDesc: "Save API keys to reuse across multiple presets.",
    apiKeyAdd: "Add key",
    apiKeyName: "Name",
    apiKeyProvider: "Provider",
    apiKeyProviderUnset: "Unspecified",
    apiKeyValue: "API key",
    apiKeyPoolEmpty: "No saved keys.",
    apiKeyModePool: "Saved key",
    apiKeyModeDirect: "Direct input",
    apiKeySelectNone: "Not selected",
    apiKeyDeletedOption: "Deleted key",
    apiKeyShowAll: "Show all keys",
    apiKeySave: "Save this key",
    apiKeyFormSave: "Save",
    apiKeyNamePrompt: "Enter a name for this key",
    parameters: "Parameters",
    sizeAndSpeed: "Size and Speed",
    useLegacyGUI: "Use Legacy GUI",
    claudeCachingExperimental: "Claude Caching",
    openClose: "Open/Close",
    hideApiKeys: "Hide API Keys",
    unformatQuotes: "Disable Quote Formatting",
    enableDevTools: "Enable Dev Tools",
    selectFile: "Select File",
    namespace: "Namespace",
    moduleIntergration: "Module Integration",
    previewInfo: "This preview shows prompt before model-specific processing.",
    miscTools: "Misc Tools",
    promptConvertion: "Prompt Convertion",
    convertionStep1: "Select all file related to the prompt (Context, Instruct and Sampler JSON is supported)",
    customCSS: "Custom CSS",
    betaMobileGUI: "Mobile GUI (Not recommended)",
    enableScrollToActiveChar: "Enable Scroll to Active Character",
    menu: "Menu",
    jsonSchema: "JSON Schema",
    enableJsonSchema: "Enable Schema",
    strictJsonSchema: "Strict Schema",
    extractJson: "Extract JSON",
    reloadSession: "Newer version of save data is found. reloading the session...",
    fixMarkdownNewline: "Fix Markdown Newline",
    customQuotes: "Custom Quotes",
    leadingSingleQuote: "Leading Single Quote",
    leadingDoubleQuote: "Leading Double Quote",
    trailingSingleQuote: "Trailing Single Quote",
    trailingDoubleQuote: "Trailing Double Quote",
    translatorNote: "Translator's Note",
    formatGroupInSingle: "Format Group in Single",
    groupInnerFormat: "Non-Speaker Inner Format",
    chatHTML: "Chat HTML",
    logShare: "Show Share Log Button",
    preview: "Preview",
    recommended: "Recommended",
    newChat: "New Chat",
    predictedOutput: "Predicted Output",
    systemContentReplacement: "System Content Replacement",
    systemRoleReplacement: "System Role Replacement",
    seperateParameters: "Separate Parameters",
    seperateParametersEnabled: "Enable Separate Parameters",
    summarizationPrompt: "Summarization Prompt",
    reSummarizationPrompt: "Re-Summarizaion Prompt",
    translatorPrompt: "Translation Prompt",
    translateBeforeHTMLFormatting: "Translate Before HTML Formatting",
    retranslate: "Retranslate",
    editTranslation: "Edit Translation",
    editTranslationSave: "Save Translation",
    exportTranslationCache: "Export Translation Cache",
    exportTranslationCacheSuccess: "Translation cache exported successfully.",
    importTranslationCache: "Import Translation Cache",
    importTranslationCacheConfirm: "This will merge entries into your translation cache. Existing keys will be overwritten. Continue?",
    importTranslationCacheSuccess: "Imported {0} translation cache entries.",
    importTranslationCacheFailed: "Imported {0} entries, but {1} entries failed to save. Storage may be full.",
    exportTranslationCacheEmpty: "Translation cache is empty.",
    clearTranslationCache: "Clear Translation Cache",
    clearTranslationCacheSuccess: "Translation cache cleared successfully.",
    clearTranslationCacheConfirm: "This will delete all translation cache entries. This cannot be undone. Continue?",
    translationCacheManager: "Translation Cache Manager",
    translationCacheManagerDescription: "Review and correct saved LLM translations without showing the entire cache at once.",
    translationCacheEntries: "{0} entries",
    translationCacheSearch: "Search",
    translationCacheSearchPlaceholder: "Search keys or translations",
    translationCacheRefresh: "Refresh",
    translationCacheEmpty: "The translation cache is empty.",
    translationCacheNoResults: "No cache entries match this search.",
    translationCacheKey: "Source key",
    translationCacheValue: "Translation",
    translationCacheCopyKey: "Copy source key",
    translationCacheCopyValue: "Copy translation",
    translationCacheDeleteConfirm: "Delete this translation cache entry?\n{0}",
    translationCacheDeleted: "Translation cache entry deleted.",
    translationCacheInvalidFile: "Invalid translation cache file.",
    translationCachePreviousPage: "Previous page",
    translationCacheNextPage: "Next page",
    translationCachePage: "Page {0} / {1}",
    loading: "Loading",
    loadingFeedback: { failed: 'Loading failed', timeout: 'Loading timed out' },
    moduleBackToList: "Back to module list",
    startupLoading: {
        title: "Loading...",
        starting: "Loading RisuBard...",
        localSave: "Loading local save file...",
        decodingLocalSave: "Decoding local save file...",
        readingBackup: "Reading backup file {0}...",
        plugins: "Loading plugins...",
        checkingFormat: "Checking for format updates...",
        updatingState: "Updating app state...",
    },
    autoTranslateCachedOnly: "Auto-translate Cached Messages Only",
    notification: "Notification",
    permissionDenied: "Permission Denied by Your Browser or OS",
    customFlags: "Custom Flags",
    enableCustomFlags: "Enable Custom Flags",
    googleCloudTokenization: "Google Cloud Tokenization",
    presetChain: "Preset Chain",
    legacyMediaFindings: "Legacy Media Findings",
    staticsDisclaimer: "The statistics are based on the data from after July 2024. the data may not be accurate.",
    subtitles: "Subtitles",
    subtitlesWarning1: "You must use model with audio/video input to use this feature.",
    subtitlesWarning2: "You must use model with streaming feature to use this feature.",
    reset: "Reset",
    clearInputConfirm: "Clear all the text in this field?",
    assetMaxDifference: "Asset Max Difference",
    sourceLanguage: "Source Language",
    destinationLanguage: "Destination Language",
    noWebGPU: "Your Browser or OS doesn't support WebGPU. this will slow down the performance significantly.",
    menuSideBar: "Menu Side Bar (Not recommended)",
    home: "Home",
    showSavingIcon: "Show Saving Icon",
    pluginVersionWarn:
        "This is {{plugin_version}} version of the plugin. which is not compatible with this version of RisuBard. please update the plugin to {{required_version}} version.",
    imageTranslation: "Image Translation",
    banCharacterset: "Auto Regenerate On Characterset",
    realmDirectOpen: "Directly open character in RisuRealm",
    showPromptComparison: "Show Prompt Comparison",
    inlayErrorResponse: "Inlay Error Response",
    triggerOn: "Trigger On",
    noConfig: "No Config",
    varName: "Variable Name",
    var: "Variable",
    condition: "Condition",
    trigger: "Trigger",
    outputVar: "Output Variable",
    source: "Source",
    cmd: "Command",
    sysStart: "System Start",
    sysHistoryEnd: "System History End",
    sysPromptEnd: "System Prompt End",
    target: "Target",
    addElse: "Add Else",
    min: "Min",
    max: "Max",
    delimiter: "Delimiter",
    deleteCount: "Delete Count",
    triggerEffRunAxLLM: "Run Auxiliary Model",
    hypaV3Settings: {
        descriptionLabel: "HypaMemory V3 is a long-term memory system that uses both summarization and vector search.",
        supaMemoryPromptPlaceHolder: "Leave it blank to use default",
        maxMemoryTokensRatioLabel: "Max Memory Tokens Ratio (Estimated)",
        maxMemoryTokensRatioError: "Unable to calculate Max Memory Tokens Ratio",
        memoryTokensRatioLabel: "Memory Tokens Ratio",
        extraSummarizationRatioLabel: "Extra Summarization Ratio",
        maxChatsPerSummaryLabel: "Max Messages Per Summary",
        queryChatCountLabel: "Query Chat Count",
        summaryChunkSeparatorLabel: "Chunk Separator Regex",
        recentMemoryRatioLabel: "Recent Memory Ratio",
        similarMemoryRatioLabel: "Similar Memory Ratio",
        randomMemoryRatioLabel: "Random Memory Ratio",
        enableSimilarityCorrectionLabel: "Enable Similarity Correction",
        preserveOrphanedMemoryLabel: "Preserve Orphaned Memory",
        applyRegexScriptWhenRerollingLabel: "Apply Regex Script When Rerolling",
        doNotSummarizeUserMessageLabel: "Do Not Summarize User Message",
    },
    hypaV3Modal: {
        titleLabel: "HypaV3",
        resetConfirmMessage: "This action cannot be undone. Do you want to reset HypaV3 data?",
        resetConfirmSecondMessage: "This action is irreversible. Do you really, really want to reset HypaV3 data?",
        convertLabel: "No summaries yet, but you may convert HypaV2 data to V3.",
        convertButton: "Convert to V3",
        convertSuccessMessage: "Successfully converted HypaV2 data to V3",
        convertErrorMessage: "Failed to convert HypaV2 data to V3: {0}",
        noSummariesLabel: "No summaries yet",
        searchPlaceholder: "Enter #N, ID, or query",
        summaryNumberLabel: "Summary #{0}",
        deleteThisConfirmMessage: "Delete this summary?",
        deleteAfterConfirmMessage: "Delete all summaries after this one?",
        deleteAfterConfirmSecondMessage: "This action cannot be undone. Are you really sure?",
        translationLabel: "Translation",
        rerolledSummaryLabel: "Rerolled Summary",
        rerolledTranslationLabel: "Rerolled Summary Translation",
        connectedMessageCountLabel: "Connected Messages ({0})",
        connectedFirstMessageLabel: "First Message",
        connectedMessageRoleLabel: "{0}'s Message",
        connectedMessageNotFoundLabel: "Message not found",
        connectedMessageLoadingError: "Error loading connected message: {0}",
        connectedMessageTranslationLabel: "Translation",
        nextSummarizationFirstMessageLabel: "First Message",
        nextSummarizationNoMessageIdLabel: "No Message ID",
        nextSummarizationLabel: "HypaV3 will summarize [{0}]",
        nextSummarizationNoMessagesFoundLabel: "WARN: No messages found",
        nextSummarizationLoadingError: "Error loading next summarization target: {0}",
        summarizationConditionLabel: "Tip: HypaV3 begins summarization when input tokens exceed the maximum context size.",
        emptySelectedFirstMessageLabel: "WARN: Selected first message is empty",
        unclassified: "Unclassified",
        reSummarize: "Re-summarize",
        reSummarizing: "Re-summarizing...",
        reSummarizeResult: "Re-summarization result",
        retry: "Retry",
        translate: "Translate",
        tag: "Tag",
        tagManager: "Tag Manager",
        tagManagerTitle: "Tag Manager - Summary #{0}",
        newTagName: "New tag name",
        noTagsYet: "No tags yet.",
        addNewTagHint: "Add a new tag above.",
        categoryManager: "Categories",
        allCategories: "All",
        categoryName: "Category name",
        noCategoriesYet: "No categories yet.",
        addNewCategoryHint: "Click the + button above to add one.",
    },
    bulkEnabling: "Lorebook Bulk Enabling",
    showTranslationLoading: "Show Translation Loading",
    showDeprecatedTriggerV1: "Show Deprecated Trigger V1",
    showDeprecatedTriggerV2: "Show Deprecated Trigger V2",
    triggerV1Warning: "Trigger V1 is deprecated. it might be removed in the future.",
    copy: "Copy",
    paste: "Paste",
    depth: "Depth",
    returnCSSError: "Return CSS Error",
    alwaysActiveInChat: "Always Active (Current Chat)",
    childLoreDesc: "This is a copy of Character lore that remains 'Always Active' until removed or manually deactivated in the original.",
    thinkingTokens: "Thinking Tokens",
    thinkingType: "Thinking Mode",
    adaptiveThinkingEffort: "Adaptive Thinking Effort",
    antiServerOverload: "Anti-Server Overload",
    localActivationInGlobalLorebook: "Local Activation in Global Lorebook",
    cachePoint: "Cache Point",
    all: "All",
    showFolderNameInIcon: "Show Folder Name in Icon",
    claudeCachingRetrival: "Claude Caching Retrival",
    claudeCachingRetrivalDesc:
        "Extends the cache time for Claude Caching, by requesting every 4 minutes. this can reduce the cache miss rate, but it can increase the cost if its not used properly.",
    automaticCachePoint: "Automatic Cache Point",
    experimentalChatCompression: "Experimental Chat Data Handling",
    loadingChatData: "Loading Chat Data",
    selectChatToView: "Select a chat to view",
    outputImageModal: "Output Image Modal",
    playMessageOnTranslateEnd: "Play Audio on Translate Completion",
    soundAndNotification: "Sound & Notification",
    groupBrowserNotification: "Browser notification",
    groupMessageNotification: "Message-complete notification",
    groupTranslateNotification: "Translation-complete notification",
    notificationEnable: "Enabled",
    soundEffect: "Sound",
    soundEffectVolume: "Volume",
    selectNotificationSound: "Select notification sound",
    uploadSound: "Upload your own",
    uploadedSound: "Uploaded sound",
    soundDefault: "Default",
    descBrowserNotification: "Show a browser notification when a response completes.",
    descMessageSound: "Play a sound when a response completes.",
    descTranslateSound: "Play a sound when a translation completes.",
    auxModelUnderModelSettings: "Show Separate Aux Models in Model Settings",
    showModelInSidebar: "Show Model Selection in Sidebar",
    showPresetInSidebar: "Show Preset Selection in Sidebar",
    showPersonaInSidebar: "Show Persona Binding in Sidebar",
    disableMobileDragDrop: "Disable Character Drag & Drop on Mobile",
    disableToggleBinding: "Disable Chat Toggle Binding",
    seperateModelsForAxModels: "Separate Models for Auxiliary Models",
    axModelsDef: "Ax Models Definition",
    doNotChangeSeperateModels: "Do Not Change Seperate Models on Preset Change",
    useDefaultSubModel: "Use default submodel",
    modelPresetBindingMainUnset: "No main model preset is bound to this chat. Bind one to send.",
    modelPresetBindingSubUnset: "No submodel preset is bound to this chat. Bind one to send.",
    modelPresetBindingTitle: "Model/submodel preset binding",
    useModelPresetBindingToggle: "Use model preset binding",
    modelPresetConfigure: "Configure model presets",
    modelPresetSetDefaultConfirm: "Set the current model binding as the default for new chats?",
    modelPresetBindedSuccess: "Model preset is successfully binded",
    streamingOverride: "Response streaming",
    streamingOverrideHelp: "Whether this preset streams responses.",
    decoupledStreaming: "Decoupled streaming (show at once)",
    decoupledStreamingHelp: "Send the request over the streaming wire but display the full response at once after it completes. Bypasses some providers' non-streaming output limits and timeouts, and avoids token-by-token render cost.",
    modelPresetToolUse: "Tool use",
    modelPresetToolUseHelp: "Let this preset call your configured tools (MCP). Off by default. Tool runs are sent without streaming.",
    modelPresetAbilities: "Model abilities",
    modelPresetPickSuggestion: "Choose from suggestions…",
    modelPresetSnapshotEmpty: "This preset's profile data is empty. Re-download or replace the profile to restore its settings.",
    modelPresetImageInput: "Image input",
    modelPresetImageInputHelp: "Send images to the model. Off by default. Turn on only for models that accept images (e.g. Ollama gemma3, llava).",
    modelPresetFoldSystem: "Fold system prompt",
    modelPresetFoldSystemHelp: "Convert system messages into user turns before sending. Off by default. Turn on for models without a native system role (e.g. Ollama gemma3).",
    modelPresetKeepFirstSystem: "Keep first system prompt",
    modelPresetKeepFirstSystemHelp: "When folding, leave the leading system message as-is instead of converting it. For models that allow a single leading system message.",
    modelPresetAlternateRole: "Force alternating roles",
    modelPresetAlternateRoleHelp: "Merge consecutive same-role messages into one. Off by default. Turn on for models that require alternating user/assistant turns (e.g. gemma).",
    modelPresetStartWithUser: "Start with user input",
    modelPresetStartWithUserHelp: "Prepend an empty user turn when the conversation does not start with user. Off by default. For models that reject a non-user first turn.",
    modelPresetCacheSection: "Context caching",
    modelPresetCacheEnable: "Use context caching",
    modelPresetCacheEnableHelp: "Cache the repeated prompt prefix on Google's servers to cut input token cost. The cache boundary is set by the cache card in your prompt template (or Automatic Cache Point).",
    modelPresetCachePluginWarning: "Using this together with an external cache plugin causes conflicts and caching will not work correctly. Use only one of the two.",
    modelPresetCacheTtl: "Cache lifetime (seconds)",
    modelPresetCacheTtlHelp: "How long the server keeps the cache. Longer covers think time between turns, but storage cost accrues for the lifetime.",
    modelPresetCacheExtend: "Extend lifetime on hit",
    modelPresetCacheExtendHelp: "Renew the cache lifetime whenever a request hits the cache.",
    modelPresetCacheAdvanced: "Advanced",
    modelPresetCacheMinTokens: "Minimum prompt tokens",
    modelPresetCacheMinTokensHelp: "Do not create a cache while the prompt is below this size.",
    modelPresetCacheGrowth: "Recreate after growth (tokens)",
    modelPresetCacheGrowthHelp: "Recreate the cache once the prompt has grown by this many tokens since it was created.",
    maxContextHelp: "Input (prompt) token budget for this preset. Leave empty for the default (65000), capped at the model's context window. Not the response length (that is Max Tokens).",
    modelPresetTabPresets: "Presets",
    modelPresetTabOptions: "Settings",
    modelPresetTabTest: "Test",
    modelPresetTabModules: "Module Binding",
    moduleModelBindingEnable: "Per-Module Model Binding",
    moduleModelBindingUnset: "Not set",
    moduleModelBindingEmpty: "No installed module makes model calls.",
    moduleModelBindingDangling: "The assigned preset no longer exists. Pick another, or re-import the preset to reconnect.",
    modelPresetTestTitle: "Test request",
    modelPresetTestHelp: "Send a single message to this preset to check its credentials and endpoint respond. Not saved to any chat.",
    modelPresetTestSend: "Send test",
    modelPresetTestSending: "Sending…",
    modelPresetTestSuccess: "Success",
    modelPresetTestFail: "Failed",
    modelPresetTestDefault: "I want to wash my car. The car wash is 50 meters away. Should I walk or drive?",
    profileVisibilityLevel: "Profile visibility",
    profileVisibilityAll: "Show all",
    profileVisibilityHideDeprecated: "Hide deprecated",
    profileVisibilityCurrentOnly: "Current only",
    useCustomRegistry: "Custom registry",
    customRegistryUrl: "Registry URL",
    customRegistryWarning: "Only use a registry source you trust. A malicious registry could route requests — and your API keys — to an unintended server.",
    registryRefresh: "Sync registry",
    registryRefreshHelp: "Re-download the catalog from the current registry source.",
    registryRefreshNow: "Refresh now",
    registrySyncing: "Syncing…",
    registrySyncUpdated: "Updated to the latest catalog.",
    registrySyncUpToDate: "Already up to date.",
    registryRefreshed: "Refreshed.",
    registrySyncFailed: "Sync failed",
    modelPresetDeleted: "Deleted preset",
    modelPresetUnset: "Not set",
    modelPresetSetAsDefault: "Set current binding as default for new chats",
    modelPresetDefaultSaved: "Saved as default binding",
    modelPresetSaveAsDefaultButton: "Save as default",
    modelModeLabel: "Model mode",
    modelModeLegacy: "Legacy model",
    modelModePreset: "Model preset",
    modelModeSettingsTitle: "Open model mode settings",
    modelModeLockLabel: "Model mode setting",
    modelModeLockLegacy: "Lock to legacy model mode",
    modelModeLockLegacyDesc: "Use the original RisuAI model system",
    modelModeLockPreset: "Lock to model preset mode",
    modelModeLockPresetDesc: "Use RisuBard's model preset binding system",
    modelModeLockNone: "No lock",
    modelModeLockNoneDesc: "Choose the mode per chat",
    newChatModelModeLabel: "Default model mode for new chats",
    modelTabBuiltin: "Built-in",
    modelTabPlugin: "Plugin",
    axModelMemory: "Memory",
    axModelTranslate: "Translation",
    axModelEmotion: "Emotion",
    axModelOther: "Other",
    tools: "Tools",
    action: "Action",
    hotkey: "Hotkey",
    hotkeyDesc: {
        reroll: "Reroll",
        unreroll: "Undo Reroll",
        translate: "Translate",
        remove: "Remove",
        edit: "Edit",
        copy: "Copy",
        send: "Send",
        settings: "Settings",
        home: "Home",
        presets: "Quick Presets Select",
        persona: "Quick Persona Select",
        modelSelect: "Quick Model Select",
        toggleCSS: "Toggle CSS",
        prevChar: "Previous Character",
        nextChar: "Next Character",
        quickMenu: "Quick Menu",
        quickSettings: "Quick Settings",
        toggleVoice: "Toggle Voice",
        toggleLog: "Toggle Log",
        previewRequest: "Preview Request",
        import: "Import",
        export: "Export",
        webcam: "Toggle Webcam",
        focusInput: "Focus Input",
        scrollToActiveChar: "Scroll to Active Character",
        popupEditor: "Popup Editor",
    },
    screenTooSmall: "Screen is too small to show the interface.",
    advancedModelSettings: "Advanced Model Settings",
    fallbackModel: "Fallback Model",
    fallbackWhenBlankResponse: "Fallback When Blank Response",
    doNotChangeFallbackModels: "Do Not Change Fallback Models on Preset Change",
    customModels: "Custom Models",
    igpPrompt: "IGP Prompt",
    useTokenizerCaching: "Tokenizer Caching",
    hypaMemoryV3Modal: "Hypa V3 Modal",
    showMenuHypaMemoryModal: "Show Menu Hypa Modal",
    promptInfoInsideChat: "Add Prompt Info to Chat",
    promptTextInfoInsideChat: "Add Prompt Text to Chat",
    promptInfoEmptyMessage: "No prompt information is available for this message.",
    promptInfoEmptyToggle: "No custom toggles are currently active.",
    promptInfoEmptyText: "No prompt text has been saved.",
    escapeOutput: "Escape Output",
    claudeBatching: "Claude Batching",
    claude1HourCaching: "Claude 1 Hour Caching",
    folderNameInput: "Please input the new folder name",
    folderRemoveLengthError: "To remove a folder, it must not contain any entries.",
    personaNote: "Persona Note",
    mcpAccessPrompt: '{{tool}} is trying to "{{action}}". do you want to allow this?',
    rememberToolUsage: "Remember tool usage",
    simplifiedToolUse: "Simplified tool usage",
    toolCalled: "Tool '{{tool}}' Called",
    static: "Static",
    dynamic: "Dynamic",
    assetStyle: "Asset Style",
    insertAssetPrompt: "Insert Asset Prompt",
    requestLocation: "Request Location",
    newImageHandlingBeta: "New Image Handling (Beta)",
    settingsExported: "Settings for bug report exported and copied to clipboard.",
    bookmarks: "Bookmarks",
    noBookmarks: "No Bookmarks",
    gallery: "Gallery",
    galleryDescription: "Keep memorable scenes without keeping every source chat.",
    galleryDefaultTitle: (chatName: string) => `${chatName}'s Memories`,
    galleryEditTitle: "Edit gallery title",
    galleryEmpty: "No scenes saved yet",
    galleryEmptyDescription: "Copy a message range from the current chat into a new memory.",
    galleryNewMemory: "New memory",
    galleryNewCategory: "New category",
    galleryCategoryNamePrompt: "Enter a category name.",
    galleryUncategorized: "Uncategorized",
    gallerySelectedCount: (count: number) => `${count} selected`,
    galleryMoveTo: "Move to",
    galleryMove: "Move",
    galleryEditMemory: "Edit memory",
    galleryEditMode: "Edit",
    galleryPreviewMessage: "Preview message",
    galleryDone: "Done",
    galleryCategoryEmpty: "No memories in this category",
    gallerySlotWidth: "Slot width",
    gallerySlotHeight: "Slot height",
    galleryNewScene: "New gallery slot",
    galleryTitle: "Title",
    galleryTitlePlaceholder: "Name this scene",
    gallerySummary: "Summary",
    gallerySummaryPlaceholder: "A short reminder of what happens",
    galleryStartMessage: "First message",
    galleryEndMessage: "Last message",
    gallerySaveScene: "Save scene",
    galleryTitleRequired: "Enter a title for this scene.",
    galleryRangeInvalid: "Choose a valid message range.",
    galleryDeleteConfirm: "Delete this gallery slot?",
    galleryDeleteSlot: "Delete gallery slot",
    galleryMoveEarlier: "Move scene earlier",
    galleryMoveLater: "Move scene later",
    galleryMessages: " messages",
    galleryReplay: "Replay scene",
    galleryBack: "Back to gallery",
    galleryBackToChat: "Back to chat",
    galleryEditMessages: "Edit saved messages",
    galleryHideUserMessages: "Hide user messages",
    bookmarkAskNameOrDefault: "Enter bookmark name. If not entered, it will be automatically assigned.",
    bookmarkAskNameOrCancel: "Enter bookmark name. If not entered, rename will be canceled.",
    collapseAll: "Collapse All",
    expandAll: "Expand All",
    hideErrorDetails: "Hide Error Details",
    showErrorDetails: "Show Error Details",
    dynamicOutput: "Dynamic Output",
    autoAdjustSchema: "Auto Adjust Schema",
    dynamicMessages: "Dynamic Messages",
    dynamicMemory: "Dynamic Memory",
    dynamicResponseTiming: "Dynamic Response Timing",
    showTypingEffect: "Show Typing Effect",
    dynamicRequest: "Dynamic Request",
    dynamicOutputPrompt: "Dynamic Output Prompt",
    settingsCloseButtonSize: "Settings Close Button Size",
    translating: "Translating...",
    stackTraceTranslationFailed: "Stack trace translation failed. Showing original obfuscated stack trace below.",
    apply: "Apply",
    send: "Send",
    add: "Add",
    nightlyWarning:
        "## Nightly Builds\n\nYou are connecting to a nightly build of the software. This version is meant for testing and most likely contains bugs. **In this version, even if you encounter issues, we do not support resolving them directly.**",
    loginSionyw: "Login with Sionyw Account",
    pluginRiskDetectedAlert: "RisuBard detected code that may be harmful which can STOLE YOUR API KEY OR PERSONAL DATA. we recommend you to NOT INSTALL THIS PLUGIN.",
    doNotInstall: "Do Not Install",
    continueAnyway: "Continue Anyway",
    pluginNoRiskButAlert: "RisuBard did not detect harmful code, but please be aware that installing plugins from untrusted sources can pose security risks.",

    pluginRisksInuserFriendly: {
        eval: "Evaluating Code from Strings",
        globalAccess: "Accessing Global Variables",
        thisOutsideClass: "Using 'this' Outside of Class Context",
        errorInVerification: "Errors During Verification Process",
        storageAccess: "Accessing Storage",
    },
    pluginRisksInuserFriendlyDesc: {
        eval: "The plugin attempts to execute code from strings, strings can be obsucated to hide malicious code.",
        globalAccess: "The plugin tries to access global variables, which can lead to unintended side effects or security vulnerabilities.",
        thisOutsideClass: "The plugin uses 'this' keyword outside of class context, which can lead to unintended behavior or security issues.",
        errorInVerification: "There are errors during the verification process of the plugin, indicating potential issues with its functionality.",
        storageAccess: "The plugin attempts to access storage, which could lead to data leaks or unauthorized data manipulation.",
    },
    generatedByAIDisclaimer: "This content was generated by AI and may contain inaccuracies or biases.",
    aiGenerationWarning: "Contents will be AI generated and may contain inaccuracies or biases.",
    duplicatePluginFoundUpdateIt: "Duplicate plugin found. do you want to update the existing plugin?",
    pluginUpdateFoundInstallIt: "Plugin update found. do you want to install the update?",
    pluginUpdateSuccess: "Plugin updated successfully.",
    pluginUpdateFailed: "Plugin update failed. Check the update URL or plugin source and try again.",
    editPluginCode: "Edit plugin code",
    pluginCode: "Plugin code",
    pluginCodeApplied: "Plugin code applied.",
    goToChat: "Go to Chat",
    bookmark: "Bookmark",
    translate: "Translate",
    branch: "Branch",
    bardWikiHistoricalBranchCreated: "BardWiki cannot be rewound to the branch point. Run Wiki Reboot in the newly branched chat. Save/Load is strongly recommended when working with BardWiki.",
    risuBardChatImportWikiUnavailable: "The source BardWiki workspace was unavailable, so stale confirmation markers were cleared. For files from another installation, use a full backup or run Wiki Reboot.",
    branchedText: "This chat has been branched from {}.",
    loadMore: "Load More",
    disableMessage: "Disable Message",
    disableFirstMessageConfirm: "Disable the personal message? It will be excluded from the context.",
    disableAbove: "Cut Messages for AI",
    autoScrollToNewMessage: "Auto scroll to new message",
    alwaysScrollToNewMessage: "Always scroll to new message (ignore scroll position)",
    preserveChatScrollPosition: "Keep reading position during content updates",
    newMessage: "New Message",
    newMessageButtonStyle: "New Message Button Style",
    newMessageButtonBottomCenter: "Bottom Center (Default)",
    newMessageButtonBottomRight: "Bottom Right",
    newMessageButtonBottomLeft: "Bottom Left",
    newMessageButtonFloatingCircle: "Floating Circle (Bottom Right)",
    newMessageButtonRightCenter: "Right Center",
    newMessageButtonTopBar: "Top Bar",
    trimStartNewChat: "Trim 'Start New Chat' Messages",
    pluginDevelopMode: "Plugin Develop Mode",
    fetchLogConsent: "Plugin {} is requesting to fetch logs, which may expose sensitive information. Do you want to allow this?", 
    getFullDatabaseConsent: "Plugin {} is requesting to access the full database, which may expose sensitive information. Do you want to allow this?",
    mainDomAccessConsent: "Plugin {} is requesting to access the main Document, which may expose sensitive information. Do you want to allow this?",
    replacerPermissionConsent: "Plugin {} is requesting permission to replace content in the chat, which may be used to manipulate the conversation. Do you want to allow this?",
    inlayPermissionConsent: "Plugin {} is requesting permission to read inlay assets attached to chat messages. Do you want to allow this?",
    providerPermissionConsent: "Plugin {} is requesting permission to access the provider, which may allow it to make unauthorized API calls. Do you want to allow this?",
    sendChatConsent: "Plugin {} is requesting permission to send chat messages on your behalf, which will trigger AI responses. Do you want to allow this?",
    bardWikiWriteConsent: "Plugin {} is requesting permission to create, edit, or delete documents in the current chat's BardWiki. Do you want to allow this?",
    resetPluginPermission: "Reset permission responses",
    resetPluginPermissionConfirm: "Clear all saved permission responses (granted / denied history) for plugin \"{}\"?\n\nThe plugin will be asked again the next time it requests permission.",
    resetPluginPermissionDone: "Permission responses for \"{}\" have been reset",
    pluginV2Warning: "Plugin V2 and V2.1 is considered unsafe and will stop working in future versions. **Please do not use these versions of plugins.**. If you are the developer of this plugin, please update to V3 as soon as possible.",
    createFolderOnBranch: "Create Folder on Branch",
    hamburgerButtonBottom: "Move Menu Button to Bottom of Sidebar",
    hideLeftBarCollapseButton: "Hide Left Bar Collapse Button",
    partialBackupFirstConfirm: "⚠️ WARNING: Partial Local Backup ⚠️\n\nThis backup quickly saves only essential information.\n\nIncluded:\n- Database (chat history, characters, modules, plugins, prompts, settings, etc.)\n- Character profile icons (main images)\n- User icons and custom backgrounds\n- Persona icons\n- Folder images\n- Bot preset images\n\n⚠️ NOT Included:\n- Emotion images\n- Additional character assets\n- VITS voice files\n- All other additional media files\n\nThis backup file does NOT include all character assets!\nIf you need a complete backup, use the regular local backup.\n\nDo you want to continue?",
    partialBackupSecondConfirm: "⚠️⚠️ FINAL WARNING ⚠️⚠️\n\nThis backup saves only character profile images and does NOT save most other assets!\n\nWhat will be saved:\n- Database (chat history, characters, modules, plugins, prompts, settings, etc.)\n- Character profile icons (main images)\n- User icons and custom backgrounds\n- Persona icons\n- Folder images\n- Bot preset images\n\nWhat will NOT be saved:\n- Emotion images\n- Additional character assets\n- VITS voice files\n- All other media files\n\n⚠️ Proceed ONLY if you don't need character assets in your backup file! ⚠️\n\nAre you really sure you want to proceed with partial backup?",
    savePartialLocalBackup: "Save Partial Backup Locally (Excluding Character Assets)",
    serverBackupHeader: "RisuBard Server Backup",
    serverBackupDesc: "Save and restore backup files directly on the device (server) where RisuBard is installed, without downloading.",
    serverBackupSave: "Save Backup to Server",
    serverBackupManage: "Manage Server Backups",
    serverBackupSaving: "Saving backup to server...",
    serverBackupSaveSuccess: (filename: string, size: string) => `Backup saved: ${filename} (${size})`,
    serverBackupLoading: "Loading backup list...",
    serverBackupEmpty: "No server backups found.",
    serverBackupRestore: "Restore",
    serverBackupDownload: "Download",
    serverBackupDelete: "Delete",
    serverBackupRestoring: "Restoring backup from server...",
    serverBackupDownloading: "Downloading backup...",
    serverBackupDeleteConfirm: (filename: string) => `Delete backup "${filename}"? This cannot be undone.`,
    serverBackupDeleteSuccess: "Backup deleted.",
    pluginProviderNotFound: "Unknown Plugin detected. please change the model or enable the corresponding plugin.",
    bootstrap: {
        dataCorruptionDetected: (name: string, type: string) => `Data Corruption Detected\n\nModule "${name}" has corrupted lorebook format.\n\nCorrupted data type: ${type}`,
        reportErrorQuestion: "Would you like to report this error to the developer?\nThis helps prevent the same error from happening again.\n(Only includes Corrupted module info, no personal data)",
        diagnosticInformation: (reportData: string) => `# Diagnostic Information\n\nPlease copy the information below and report it to the developer via GitHub Issues, Discord, or community.\nDouble-check for any sensitive information before reporting.\n\n\`\`\`json\n${reportData}\n\`\`\``,
        resetLorebookQuestion: "Do you want to reset ONLY the lorebook data in this specific corrupted module?\n(Other modules and character data will NOT be affected)\n\nChoosing \"No\" will keep the data but errors may continue.",
    },
    partialEdit: {
        editButtonTooltip: "Edit",
        deleteButtonTooltip: "Delete",
        deleteModalTitle: "Delete Confirmation",
        deleteConfirmMessage: "Are you sure you want to delete this part?",
        deleteYes: "Yes",
        deleteNo: "No",
        editModalTitle: "Partial Edit",
        matchFound: (method: string) => `Match: ${method}`,
        matchFailedTitle: "Cannot Partial Edit",
        matchFailedMessage: "Unable to locate precisely in the original message. This may happen with very long sentences or duplicate content. Please use the full message edit feature instead.",
        selectMatch: "Select which block to edit",
        selectDeleteMatch: "Select which block to delete",
        matchesFound: "matches found",
        lineNumber: (line: number) => `Line ~${line}`,
        saveShortcut: "Save (Ctrl+Enter)",
        cancelShortcut: "Cancel (Esc)",
        save: "Save",
        cancel: "Cancel",
    },
    enableRemoteSaving: "Enable Remote Saving",
    blockquoteStyling: "Blockquote Styling",
    dynamicModelRegistry: "Dynamic Model Registry",
    confirmInstallPluginViaPlugin: "You are trying to install a plugin via another plugin. This can be dangerous if the source plugin is not trustworthy. Do you want to continue?",
    nodeOnlyScrollButtonType: "Scroll Button Type",
    pinChatScrollNavigator: "Pin Side Navigator",
    scrollButtonTypeFour: "4 Buttons",
    scrollButtonTypeTwo: "2 Buttons",
    scrollButtonTypeOff: "Off",
    nodeOnlyServerSideRequests: "Server-Side Requests",
    pendingSendNotice: "Unfinished send: {chars} — opening the chat will resume it.",
    seperateParametersByModel: "Separate Parameters by Model",
    disableSeperateParameterChangeOnPresetChange: "Disable Separate Parameter Change on Preset Change",
    keepSessionAlive: "Keep Session Alive",
    keepSessionAlivePip: "Via PIP",
    keepSessionAliveSound: "Via Sound",
    toggleBindingLabel: "Chat-specific toggles",
    togglePinToChat: "Pin the current toggle values to this chat only",
    togglePinLabel: "Pin to chat",
    togglePinSaved: "Toggle values pinned to this chat.",
    togglePinManage: "Overwrite pinned values with current settings or unpin",
    togglePinOverwrite: "Overwrite with current settings",
    togglePinUnpin: "Unpin and use global values",
    togglePinManualName: "Custom values",
    togglePinReset: "Reset to the pinned preset values",
    togglePinResetDone: "Toggle values reset to the pinned preset.",
    toggleSaveAsPreset: "Save as toggle preset",
    toggleLoadPreset: "Load toggle preset",
    togglePinUpdate: "Save toggles",
    togglePinUpdateLabel: "Save",

    togglePinRemove: "Unpin chat-specific toggles and return to global values?",
    togglePinUnbound: "Chat-specific toggles unpinned.",
    togglePresetNamePrompt: "Enter toggle preset name",
    togglePresetDelete: "── Delete ──",
    togglePresetDeleteConfirm: (name: string) => `Delete toggle preset "${name}"?`,
    togglePresetSelectTitle: "Toggle Presets",
    togglePresetEmpty: "No toggle presets saved.",
    togglePresetRename: "Rename toggle preset",
    togglePresetApplied: (name: string) => `"${name}" preset applied.`,
    togglePresetFilterShowAll: "Show all presets",
    togglePresetNoPromptPreset: "No preset",
    togglePresetEmptyFiltered: "No toggle presets for the current prompt preset.",
    togglePresetApplyConfirm: "Current toggle settings will be overwritten. Apply?",
    togglePresetMismatchConfirm: "This preset was saved for a different prompt preset. Toggles may not be compatible. Apply anyway?",
    togglePresetSaveNew: "Save New Preset",
    togglePresetOverwrite: "Overwrite",
    togglePresetOverwriteConfirm: (name: string) => `Overwrite "${name}" with current toggle values?`,
    togglePresetOverwritten: (name: string) => `Preset "${name}" overwritten.`,
    togglePresetList: "Toggle Presets",
    togglePresetMenuRename: "Rename",
    togglePresetMenuDuplicate: "Duplicate",
    togglePresetMenuDelete: "Delete",
    togglePresetMenuOverwrite: "Overwrite",
    togglePresetMenuExport: "Export",
    togglePresetImport: "Import from File",
    togglePresetImported: (name: string) => `Preset "${name}" imported.`,
    togglePresetImportError: "Invalid toggle preset file.",
    togglePresetSaved: (name: string) => `Preset "${name}" saved.`,
    togglePresetRenamed: (oldName: string, newName: string) => `Renamed "${oldName}" to "${newName}".`,
    togglePresetDuplicated: (name: string) => `Duplicated as "${name}".`,
    togglePresetDeleted: (name: string) => `Preset "${name}" deleted.`,
    togglePresetExported: (name: string) => `Preset "${name}" exported.`,
    longPressToPopupEditor: "Long press to open popup editor",
    showInputActionBar: "Show input action bar",
    importSaveFolderHeader: "Load Save into RisuBard",
    importSaveZip: "Load from Save Folder (Zip Upload)",
    importSaveZipDesc: "Compress your existing RisuAI project's save folder into a zip file and upload it here to import your data. Uploading may fail if the zip file is too large — in that case, copy the save folder directly into the server's save directory and restart to migrate automatically.",
    importSaveFolderScanning: "Scanning save folder...",
    importSaveFolderImporting: "Importing save folder...",
    importSaveFolderConfirmZip: (name: string, size: string) => `Upload "${name}" (${size}) and import? This will replace your current data.`,
    importSaveFolderNoDatabase: "The save folder does not contain a database file (database/database.bin). Import cannot proceed.",
    importSaveFolderSuccess: "Import complete.",
    cleanupMigratedFiles: "Clean Up Migrated Save Files",
    cleanupMigratedDesc: "If you manually copied save files into the server's save folder, this removes the leftover original files after migration to free up disk space.",
    cleanupMigratedConfirm: (count: number, size: string) => `Delete ${count} migrated hex files (${size})? These are already in the database.`,
    cleanupMigratedNoFiles: "No migrated files to clean up.",
    cleanupMigratedNotReady: "Migration has not been completed yet. Cannot clean up.",
    cleanupMigratedSuccess: (count: number, size: string) => `Removed ${count} files, freed ${size}.`,
    cleanupMigratedCleaning: "Cleaning up migrated files...",
    // NanoGPT Dashboard
    nanoGPTLoadingAccountInfo: "Loading account info…",
    nanoGPTCreditBalance: "Credit Balance:",
    nanoGPTSubscription: "Subscription",
    nanoGPTGraceUntil: (date: string) => `until ${date}`,
    nanoGPTNoActiveSubscription: "No active subscription.",
    nanoGPTCancelsAtPeriodEnd: (date: string) => `Cancels at period end (${date})`,
    nanoGPTWeeklyTokens: (pct: string) => `Weekly Included Input Tokens — ${pct} used`,
    nanoGPTDailyTokens: (pct: string) => `Daily Included Input Tokens — ${pct} used`,
    nanoGPTDailyImages: (pct: string) => `Daily Included Images — ${pct} used`,
    nanoGPTResets: (date: string) => `Resets ${date}`,
    nanoGPTUsed: (n: string) => `${n} used`,
    nanoGPTRemaining: (n: string) => `${n} remaining`,
    nanoGPTRenews: (date: string) => `Renews: ${date}`,
    nanoGPTCouldNotLoadAccountInfo: "Could not load account info.",
    nanoGPTWeeklyTokensLabel: "Weekly Included Input Tokens",
    nanoGPTDailyTokensLabel: "Daily Included Input Tokens",
    nanoGPTDailyImagesLabel: "Daily Included Images",
    nanoGPTUsedLabel: "used",
    nanoGPTRemainingLabel: "remaining",
    nanoGPTResetsLabel: "Resets",
    nanoGPTRenewsLabel: "Renews:",
    // NanoGPT Provider Picker
    nanoGPTProvider: "Provider",
    nanoGPTProviderPayAsYouGoOnly: "(only available in pay-as-you-go mode)",
    nanoGPTProviderAuto: "Auto",
    nanoGPTProviderFree: "Free",
    nanoGPTProviderInput: "Input",
    nanoGPTProviderOutput: "Output",
    nanoGPTProviderQuantization: "Quantization",
    nanoGPTProviderUndisclosed: "Undisclosed",
    nanoGPTProviderCache: "Cache",
    nanoGPTProviderCacheSupported: "Supported",
    nanoGPTProviderCacheNotSupported: "Not supported",
    nanoGPTProviderCacheRead: "Cache read",
    // NanoGPT Settings
    nanoGPTUseSubscriptionEndpoint: "Use subscription endpoint & models",
    // Model Grid
    modelGridCouldNotLoad: "Could not load model list. Check your API key.",
    modelGridNoModelsMatch: (q: string) => `No models match "${q}"`,
    modelGridContext: (n: string) => `Context: ${n}`,
    nanoGPTSelectFromList: "Select from List",
    nanoGPTManualInput: "Manual Input",
    nanoGPTManualModelSelect: "Manual Model Select",
    searchSettingsPlaceholder: "Search settings...",
    searchSettingsNoResults: "No matching settings found",
    searchSettingsHint: "Search by setting name or keyword",
    // Remote Access (Cloudflare Quick Tunnel)
    remoteAccess: "Remote Access",
    remoteAccessDesc: "Use a remote access link to connect to this RisuBard server from another device.",
    remoteAccessOpen: "Open Remote Access",
    remoteAccessClose: "Close Remote Access",
    remoteAccessCloseConfirm: "Close remote access? The link will expire.",
    remoteAccessDownloading: "Downloading cloudflared...",
    remoteAccessStarting: "Starting tunnel...",
    remoteAccessCopyUrl: "Copy URL",
    remoteAccessCopied: "Copied!",
    remoteAccessDisabled: "Remote access is disabled by server configuration.",
    remoteAccessError: "Tunnel error",
    remoteAccessRetry: "Retry",
    remoteAccessQrHint: "Scan QR code to connect",
    remoteAccessWarning: "Never share the QR code or link with others. Anyone with the link can freely access your server. If accidentally shared, close the connection and create a new one.",
    remoteAccessInfo: "The link expires when you close remote access or restart the server. A new link is generated each time. The connection stays active even if you close this page or browser.",
    remoteAccessDnsHelp: "If Firefox for Android says it can't find the server, open Firefox Settings > Privacy & Security > DNS over HTTPS, turn it off, and try again.",
    remoteAccessTermuxWarning: "Cloudflare Quick Tunnel does not work on Termux. Use Tailscale or another remote access tool instead.",

    // Insecure (HTTP) connection warning
    httpInsecureWarningTitle: "Connected over HTTP",
    httpInsecureWarningBody: "Some features such as plugins may not work. Use the Remote Access feature for an HTTPS connection.",
    httpInsecureOpenRemoteAccess: "Open settings",

    // System page
    system: "System",
    storageDiagnosticsTitle: "Developer",
    storageDiagnosticsDesc: "Review storage performance and create a privacy-safe diagnostic report for troubleshooting.",
    storageDiagnosticsPrivacy: "The report contains aggregate timing, result counts, and categorized error codes only. It excludes names, messages, paths, identifiers, hashes, database sizes, entity counts, and raw logs.",
    storageDiagnosticsGenerate: "Generate report",
    storageDiagnosticsGenerating: "Generating...",
    storageDiagnosticsDownload: "Download",
    storageDiagnosticsCopy: "Copy to clipboard",
    storageDiagnosticsCopied: "Diagnostic report copied to clipboard",
    storageDiagnosticsGenerated: "Diagnostic report updated",
    storageDiagnosticsFailed: "Could not generate the storage diagnostic report",
    storageDiagnosticsNoObservations: "No observations yet",
    storageDiagnosticsNoIssues: "No issues observed",
    storageDiagnosticsIssuesDetected: "Issues detected",
    storageDiagnosticsSaveSuccess: "Successful saves",
    storageDiagnosticsSaveP50: "Save p50",
    storageDiagnosticsSaveP90: "Save p90",
    storageDiagnosticsShadowMatch: "S1 shadow matches",
    storageDiagnosticsDirectWriteSuccess: "Direct writes",
    storageDiagnosticsMaterialization: "Compatibility database rebuilds",
    storageDiagnosticsMaterializationP90: "Compatibility rebuild p90",
    storageDiagnosticsDirectWriteFallback: "W1 fallbacks",
    storageDiagnosticsIssues: "Categorized issues",
    storageDiagnosticsNoIssueDesc: "No storage or S1 shadow errors were recorded in the retained observation window.",
    storageDiagnosticsNoDataDesc: "Use RisuBard normally and return here after some saves have been observed.",
    systemLogs: "System Logs",
    systemLogsDesc: "View errors, warnings, and info events captured across this server and connected browsers.",
    systemLogsEmpty: "No logs yet",
    systemLogsEmptyDesc: "Errors and warnings will appear here as they occur.",
    systemLogsEmptyButMore: "No entries loaded yet match your client-side filters. Load more to search further back.",
    systemLogsSearchPlaceholder: "Search message, source, platform, or client ID",
    systemLogsLoadMore: "Load more",
    systemLogsRefresh: "Refresh",
    systemLogsCopyAll: "Copy visible",
    systemLogsCopyEntry: "Copy",
    systemLogsClearAll: "Clear all",
    systemLogsClearConfirm: "Delete all log entries? This cannot be undone.",
    systemLogsCopied: "Copied to clipboard",
    systemLogsFiltered: (shown: number, total: number) => `${shown} of ${total} shown`,
    systemLogsLevelAll: "All levels",
    systemLogsLevelError: "Error",
    systemLogsLevelWarning: "Warning",
    systemLogsLevelInfo: "Info",
    systemLogsOriginAll: "All",
    systemLogsOriginClient: "Client",
    systemLogsOriginServer: "Server",
    systemLogsFailedLoad: "Failed to load logs",
    systemLogsLoading: "Loading...",
    pluginStorageTab: "Plugin Storage",
    pluginStorageDesc: "View, edit and delete data saved by plugins. Plugin data is shared in a single global namespace, not separated per plugin.",
    pluginStorageBackendSave: "Save File",
    pluginStorageBackendSaveDesc: "Stored in the save file · travels with your save",
    pluginStorageBackendLocal: "Local",
    pluginStorageBackendLocalDesc: "localStorage based · strings only · device-local",
    pluginStorageBackendIdb: "Device DB",
    pluginStorageBackendIdbDesc: "IndexedDB based · JSON · device-local",
    pluginStorageSearchKey: "Search key...",
    pluginStorageSearchValue: "Search value...",
    pluginStorageRefresh: "Refresh",
    pluginStorageEmpty: "No entries.",
    pluginStorageLoadError: "Failed to load storage.",
    pluginStorageSave: "Save",
    pluginStorageFormatJson: "Format JSON",
    pluginStorageMetaType: "Type",
    pluginStorageMetaSize: "Size",
    pluginStorageMetaChars: "Chars",
    pluginStorageOwner: "Origin",
    pluginStorageOwnerUnknown: "Unknown",
    pluginStorageDeleted: "Deleted",
    pluginStorageJsonError: (msg: string) => `JSON parse failed: ${msg}`,
    pluginStorageSaved: (key: string) => `Saved "${key}"`,
    pluginStorageDeleteConfirm: (key: string) => `Delete "${key}"?`,
    pluginStorageBulkDeleteShown: (n: number) => `Delete shown (${n})`,
    pluginStorageBulkDeleteAll: (n: number) => `Clear all (${n})`,
    pluginStorageBulkDeleteConfirm: (backend: string, n: number) => `Delete ${n} item(s) from the ${backend} backend? This cannot be undone.`,
    pluginStorageBulkDeleteAllConfirm: (backend: string, n: number) => `Delete ALL ${n} plugin storage item(s) from the ${backend} backend? This cannot be undone.`,
    pluginStorageBulkDeleted: (n: number) => `Deleted ${n} item(s)`,
    systemLogsFilters: "Filters",
    systemLogsFilterLevel: "Level",
    systemLogsFilterOrigin: "Origin",
    systemLogsFilterSource: "Source",
    systemLogsFilterDevice: "Device",
    systemLogsFilterClear: "Reset filters",
    systemLogsFilterActive: (count: number) => count === 0 ? '' : `${count} excluded`,
    systemLogsExplicitOnly: "Explicit logs only",
    systemLogsExplicitOnlyHint: "Excludes console, uncaught exceptions, framework captures",

    // Request logs / usage (system settings)
    requestLogsTab: "Request Logs",
    requestLogsDesc: "Records the body, response and timing of every request sent to a provider. The default filter shows LLM requests only.",
    requestLogsFilters: "Filters",
    requestLogsFilterClear: "Clear filters",
    requestLogsFilterActive: (count: number) => count === 0 ? "" : `${count} active`,
    requestLogsFilterCategory: "Type",
    requestLogsFilterSource: "Source",
    requestLogsFilterResult: "Result",
    requestLogsCategoryLlm: "LLM",
    requestLogsCategoryTts: "Speech",
    requestLogsCategoryImage: "Image",
    requestLogsCategoryTranslate: "Translate",
    requestLogsCategoryEmbedding: "Embedding",
    requestLogsCategoryOther: "Other",
    requestLogsSourceMain: "Chat",
    requestLogsSourceTranslate: "Translate",
    requestLogsSourceMemory: "Memory",
    requestLogsSourceWikiAdmin: "Wiki administrator",
    requestLogsSourceEmotion: "Emotion",
    requestLogsSourceSub: "Auxiliary",
    requestLogsSourcePreview: "Preview",
    requestLogsSourceTest: "Test",
    requestLogsSourceTts: "Speech",
    requestLogsSourceImage: "Image",
    requestLogsSourcePlugin: "Plugin",
    requestLogsSourceOther: "Other",
    requestLogsResultSuccess: "Success",
    requestLogsResultFailed: "Failed",
    requestLogsRouteDirect: "Direct",
    requestLogsRouteProxy: "Proxy",
    requestLogsRouteJob: "Backend call",
    requestLogsSearchPlaceholder: "Search by URL, model, or error message",
    requestLogsRefresh: "Refresh",
    requestLogsClearAll: "Clear all",
    requestLogsClearConfirm: "Delete all stored request logs? Usage statistics are kept.",
    requestLogsEmpty: "No logs yet",
    requestLogsEmptyDesc: "Requests you send will be recorded here.",
    requestLogsEmptyButMore: "Nothing matches the current filter. Try loading more.",
    requestLogsLoading: "Loading...",
    requestLogsFailedLoad: "Failed to load request logs",
    requestLogsLoadMore: "Load more",
    requestLogsCount: (shown: number, total: number) => shown === total ? `${total}` : `${shown} / ${total}`,
    requestLogsDuration: "Duration",
    requestLogsFirstToken: "First token",
    requestLogsTokens: "Tokens",
    requestLogsRequestHeaders: "Request headers",
    requestLogsRequestBody: "Request body",
    requestLogsResponse: "Response",
    requestLogsError: "Error",
    requestLogsCopied: "Copied to clipboard",
    requestLogsTruncated: "Truncated",
    requestLogsEnabled: "Record request logs",
    requestLogsEnabledDesc: "When off, new requests are not recorded. Usage statistics stop as well.",
    requestLogsStreamUsage: "Collect tokens on streamed requests",
    requestLogsStreamUsageDesc: "Asks the provider to report token usage for streamed responses. Some providers reject this with a 400 error — turn it off if that happens.",
    requestLogsStorage: (used: string, max: string) => `Storage ${used} / ${max}`,

    usageTab: "Usage",
    usageDesc: "Token usage for LLM requests. Requests without tokens (speech, images) are excluded.",
    usageRequests: "Requests",
    usageInputTokens: "Input tokens",
    usageOutputTokens: "Output tokens",
    usageCachedTokens: "Cached tokens",
    usageChartTitle: "Token usage",
    usageByModel: "By model",
    usageBySource: "By source",
    usageModel: "Model",
    usageAvgDuration: "Avg. latency",
    usageFailed: "Failed",
    usagePeriod7d: "7 days",
    usagePeriod30d: "30 days",
    usagePeriod90d: "90 days",
    usagePeriodAll: "All",
    usageEmpty: "No usage recorded yet",
    usageEmptyDesc: "Statistics build up as you send requests.",
    usageLoading: "Loading...",
    usageFailedLoad: "Failed to load usage",
    usageClearConfirm: "Delete all usage statistics? This cannot be undone.",
    usageClearAll: "Clear statistics",

    // Storage dashboard
    systemDashboard: "Dashboard",
    storageDashboardDesc: "Inspect storage usage, find large items, and reclaim space.",
    storageRefresh: "Refresh",
    storageLoading: "Loading...",
    storageFailedLoad: "Failed to load storage stats",

    // Disk usage section (macOS-style bar)
    storageDiskUsage: "Storage",
    storageDiskHeader: (used: number, total: number) =>
        `${(used / 1024 / 1024 / 1024).toFixed(2)} GB used of ${(total / 1024 / 1024 / 1024).toFixed(2)} GB`,
    storageDiskHeaderUnknown: "Disk size unavailable",
    storageDiskOther: "Other (system & apps)",
    storageDiskFree: "Free",
    storageDiskRisuTotal: (size: number) => `RisuBard total: ${(size / 1024 / 1024).toFixed(1)} MB`,

    // Per-row labels (shown in the breakdown list with ⓘ explanations)
    storageRowDbFile: "File data root",
    storageRowDbFileDesc: "Canonical JSON, JSONL, Markdown, and content-addressed object files.",
    storageRowFileBackups: "Disk backups (.bin)",
    storageRowFileBackupsDesc: "Manual export backups stored on disk under the backups/ folder.",
    storageRowKvDatabase: "Compatibility projection",
    storageRowKvDatabaseDesc: "A rebuildable database.bin projection for existing clients and exports. Canonical user data remains in separate files.",
    storageRowKvDbBackups: "Compatibility snapshots",
    storageRowKvDbBackupsDesc: "Rebuildable snapshots retained for older clients; not the user-data authority.",
    storageRowKvAssets: "Character assets",
    storageRowKvAssetsDesc: "Character cards, emotion images, additional assets, persona icons, and similar media.",
    storageRowKvInlay: "Inlay images",
    storageRowKvInlayDesc: "Images embedded inside chat messages (inlay + thumb + metadata).",
    storageRowKvRemotes: "Remote chat data",
    storageRowKvRemotesDesc: "Per-character remote sync cache (remotes/{chaId}.local.bin).",
    storageRowKvColdStorage: "Cold storage",
    storageRowKvColdStorageDesc: "Legacy/dormant storage tier. Usually empty.",
    storageRowKvUncategorized: "Other data",
    storageRowKvUncategorizedDesc: "Keys not matching any known category. Usually migration leftovers or temporary entries.",
    storageRowSqliteOverhead: "File metadata",
    storageRowSqliteOverheadDesc: "Small manifests, indexes, checksums, and transaction journals used by crash-safe file storage.",
    storageRowReclaimablePages: "Unreferenced objects",
    storageRowReclaimablePagesDesc: "Content-addressed objects no longer referenced by a manifest. Cleanup removes only these rebuildable or orphaned files.",
    storageRowReclaimable: (size: number) =>
        `${(size / 1024 / 1024).toFixed(1)} MB reclaimable — run Optimize to compact.`,
    storageInternalOnly: "Show with full disk",
    storageInternalOnlyHint: "Off shows only RisuBard items; on includes system & free space relative to the disk.",

    // 2 GB BLOB limit (separate section)
    storageBlobLimit: "Compatibility projection size",
    storageBlobLimitDesc: "The projection is retained for existing clients, while canonical chats and entities are split across files and are not constrained by one SQLite row.",
    storageBlobThreshold: (used: number, max: number, pct: number) =>
        `${pct.toFixed(1)}% of 2 GB (${(used / 1024 / 1024 / 1024).toFixed(2)} / ${(max / 1024 / 1024 / 1024).toFixed(2)} GB)`,
    storageBlobThresholdWarn: "Approaching the 2 GB single-blob limit. Reduce chats or assets.",
    storageBlobThresholdCrit: "Critical: very close to 2 GB blob limit. Saves may start failing.",

    storageOptimize: "Clean up now",
    storageOptimizing: "Cleaning up...",
    storageOptimizeHeader: (dbSize: number, reclaim: number) =>
        `${(reclaim / 1024 / 1024).toFixed(1)} MB reclaimable of ${(dbSize / 1024 / 1024 / 1024).toFixed(2)} GB`,
    storageOptimizeBarUsed: "In use",
    storageOptimizeBarReclaimable: "Reclaimable",
    storageOptimizeWhat: "Cleanup removes unreferenced content-addressed objects after validating the active manifest. Canonical user files are not modified.",
    storageOptimizeWhen: "Unreferenced objects older than one hour are cleaned automatically in the background. Run cleanup now to reclaim space immediately.",
    storageOptimizeConfirm: "Clean up now? Server saves will pause for a few seconds.",
    storageOptimizeNeedsSpace: (need: number, free: number) =>
        `Not enough disk space. Need ~${(need / 1024 / 1024).toFixed(0)} MB, free ${(free / 1024 / 1024).toFixed(0)} MB.`,
    storageOptimizeDone: (reclaimed: number, ms: number) =>
        `Reclaimed ${(reclaimed / 1024 / 1024).toFixed(1)} MB in ${(ms / 1000).toFixed(1)}s.`,
    storageOptimizeFailed: "Cleanup failed",

    storageCleanup: "Clean up unreferenced objects",

    storageOrphanCleanupTitle: "Orphan data cleanup",
    storageOrphanCleanupDesc: "Remove media unused by current characters, personas, modules, trash, or plugins, along with unused Hypa vector cache and unreferenced storage objects.",
    storageOrphanCleanupMedia: "Orphan media",
    storageOrphanCleanupHypa: "Hypa vectors to inspect",
    storageOrphanCleanupObjects: "Unreferenced objects",
    storageOrphanCleanupCountSize: (count: number, size: number) =>
        `${count.toLocaleString()} · ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageOrphanCleanupSize: (size: number) => `${(size / 1024 / 1024).toFixed(1)} MB`,
    storageOrphanCleanupUnavailable: "Unavailable",
    storageOrphanCleanupInlayNote: "To prevent false deletion, manage orphan inlay images separately with the orphan filter in the Inlay Gallery.",
    storageOrphanCleanupConfirm: (mediaCount: number, mediaSize: number, hypaCount: number, hypaSize: number, objectSize: number) =>
        `Inspect and clean ${mediaCount.toLocaleString()} orphan media files (${(mediaSize / 1024 / 1024).toFixed(1)} MB), up to ${hypaCount.toLocaleString()} Hypa vectors (${(hypaSize / 1024 / 1024).toFixed(1)} MB), and ${(objectSize / 1024 / 1024).toFixed(1)} MB of unreferenced objects?`,
    storageOrphanCleanupAll: "Clean up all orphan data",
    storageOrphanCleanuping: "Rechecking references and cleaning orphan data...",
    storageOrphanCleanupDone: (mediaCount: number, hypaCount: number, objectCount: number, reclaimed: number) =>
        `Removed ${mediaCount.toLocaleString()} orphan media files, ${hypaCount.toLocaleString()} Hypa vectors, and ${objectCount.toLocaleString()} unreferenced objects; reclaimed ${(reclaimed / 1024 / 1024).toFixed(1)} MB.`,
    storageOrphanCleanupFailed: "Orphan data cleanup failed",

    storageBackups: "Backups",
    storageBackupsManage: "Manage backups",
    storageBackupsAuto: "Compatibility snapshots",
    storageBackupsAutoDesc: "Periodic rebuildable projections for older clients. Full backups include the canonical file tree, assets, and BardWiki.",
    storageBackupsManual: "Server backup",
    storageBackupsManualDesc: "A full backup including character assets and inlay images. Stored directly on the server; the location can be changed.",
    storageBackupsCount: (count: number, size: number) =>
        `${count} · ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageBackupsRange: (oldest: string, newest: string) => `Latest ${newest} · oldest ${oldest}`,
    storageBackupsEmpty: "None",

    storageCharacters: "Per-character usage",
    storageCharactersDesc: "Approximate card, media, and chat bytes for each character.",
    storageCharactersMeasure: "Measure",
    storageCharactersMeasuring: "Measuring...",
    storageCharactersDone: (ms: number, count: number) =>
        `Measured ${count.toLocaleString()} character(s) in ${(ms / 1000).toFixed(1)}s. Chat sizes are approximate.`,
    storageCharactersCard: "card",
    storageCharactersImage: "media",
    storageCharactersChat: "chat",
    storageCharactersTrashed: "trashed",
    storageCharactersGoTo: "Go to this character",
    storageCharactersOrphan: (count: number, size: number) =>
        `Orphan media (not referenced by any character): ${count} item(s), ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageCharactersEmpty: "No characters",
    storageLoadMore: (remaining: number) => `Show more (${remaining.toLocaleString()} left)`,
    storageShowingOf: (shown: number, total: number) => `Showing ${shown.toLocaleString()} of ${total.toLocaleString()}`,

    storageModules: "Per-module usage",
    storageModulesDesc: "Body and asset bytes for each module.",
    storageModulesMeasure: "Measure",
    storageModulesMeasuring: "Measuring...",
    storageModulesDone: (ms: number, count: number) =>
        `Measured ${count.toLocaleString()} module(s) in ${(ms / 1000).toFixed(1)}s.`,
    storageModulesBody: "body",
    storageModulesAssets: "assets",
    storageModulesEmpty: "No modules",

    storageDebug: "Debug info",

    // Data migration (formerly "Account & Files")
    migration: "Data Migration",
    migrationDesc: "Move data between RisuAI (or compatible systems) and RisuBard: import from upstream, or export to upstream-compatible format.",
    migrationInfoBackupMoved: "Full backup export and settings backup have moved to [System → Backups].",
    migrationGotoBackupTab: "Open Backups tab",
    migrationLegacyAccordion: "RisuAI-style backup (legacy)",
    migrationLegacyDesc: "Helpers for backing up and exporting in upstream RisuAI-compatible formats. Use the Backups tab for everyday backup tasks.",
    migrationSaveFolderAccordion: "Import save folder from NodeRisu",
    migrationSaveFolderDesc: "Use this to bring data over from a NodeRisu / RisuAI save folder you used previously.",
    migrationLoadUpstreamBackup: "Load upstream RisuAI local backup",

    // System → Backups tab
    systemBackups: "Backups",
    backupTabDesc: "Export all user data as a full backup or restore it from a file.",

    backupSnapshot: "Snapshot (DB only)",
    backupSnapshotEmpty: "No snapshots.",
    backupSnapshotRestore: "Restore from this snapshot",
    backupSnapshotDelete: "Delete snapshot",
    backupSnapshotDeleteConfirm: (when: string) => `Delete the ${when} snapshot? This cannot be undone.`,
    backupSnapshotDeleted: "Snapshot deleted.",
    backupSnapshotDeleteFailed: "Failed to delete snapshot",
    backupSnapshotLimits: (count: number, bytes: number) =>
        `Up to ${count} · ${(bytes / 1024 / 1024).toFixed(0)} MB`,
    backupSnapshotLimitsCurrent: (count: number, bytes: number, logicalBytes?: number) => {
        const disk = (bytes / 1024 / 1024).toFixed(1)
        const saved = (logicalBytes ?? 0) - bytes
        // Only surface the dedup win when it's meaningful (chunked snapshots share
        // chunks); for tiny/un-chunked sets logical ≈ disk, so the plain line reads
        // cleaner without a "(0 MB saved)" tail.
        if (saved > 1024 * 1024) {
            const data = ((logicalBytes ?? 0) / 1024 / 1024).toFixed(0)
            const savedMB = (saved / 1024 / 1024).toFixed(0)
            return `Currently ${count} · ${disk} MB on disk (${data} MB of data, ${savedMB} MB saved by deduplication)`
        }
        return `Currently ${count} · ${disk} MB used`
    },
    backupSnapshotLimitsChange: "Configure limits",
    backupSnapshotLimitsDialog: "Snapshot retention limits",
    backupSnapshotLimitsDialogDesc: "Whichever limit is reached first applies. Snapshots are rotated as new ones are created; reducing a limit trims immediately (the most recent snapshot is always kept regardless).",
    backupSnapshotLimitsCount: "Max count",
    backupSnapshotLimitsBytes: "Max size (MB)",
    backupSnapshotLimitsSuccess: (removed: number) =>
        removed > 0 ? `Limits applied (${removed} removed)` : "Limits updated.",
    backupSnapshotLimitsFailed: "Failed to update limits",
    backupSnapshotLimitsCountRange: (min: number, max: number) =>
        `Integer between ${min} and ${max}`,
    backupSnapshotLimitsBytesRange: (minMB: number, maxMB: number) =>
        `Between ${minMB} and ${maxMB.toLocaleString()} MB`,

    backupServer: "Server backup",
    backupServerDesc: "A full backup including character assets and inlay images. Stored directly on the server; you can change the location below.",
    backupServerCreate: "Create backup",
    backupServerEmpty: "No backups saved.",
    backupBootReminder: "Boot-time backup reminder",
    backupBootReminderHint: "From the next boot, ask whether to back up before showing the app.",
    backupBootReminderToggledOn: "Boot-time backup reminder enabled.",
    backupBootReminderToggledOff: "Boot-time backup reminder disabled.",
    backupBootPromptTitle: "Create a server backup now?",
    backupBootPromptEstimate: (size: number) =>
        `Estimated backup size: ${(size / 1024 / 1024).toFixed(0)} MB`,
    backupBootPromptDisk: (free: number, total: number) =>
        `Disk free: ${(free / 1024 / 1024 / 1024).toFixed(1)} GB / total ${(total / 1024 / 1024 / 1024).toFixed(1)} GB`,
    backupBootPromptProceed: "Back up now",
    backupBootPromptSkip: "Skip",
    storageDiskUsageHighWarning: (pct: number) =>
        `Disk ${pct.toFixed(0)}% full — cleanup needed.`,
    backupServerInsufficient: "Insufficient disk space — cannot create a new backup.",
    updatePopupBackup: "Backup",

    backupServerPath: "Stored at",
    backupServerPathDefault: "Default location",
    backupServerPathChange: "Change",
    backupServerPathDialog: "Change backup location",
    backupServerPathDialogDesc: "Absolute path to the folder where new backups will be saved. Existing backup files remain at the old location — move them manually if needed.",
    backupServerPathInputLabel: "Absolute path",
    backupServerPathSuccess: "Backup location updated.",
    backupServerPathFailed: "Failed to update backup location",

    backupLocal: "Local backup",
    backupLocalDesc: "Download or restore a full backup containing characters, chats, assets, settings, and BardWiki data.",
    backupLocalDownload: "Download full backup",
    backupLocalDownloadDesc: "Generate a fresh backup from current data and download it directly to your device.",
    backupLocalRestoreDesc: "Restore from a backup file on your device.",

    backupSettingsOnly: "Export settings only",
    backupSettingsOnlyDesc: "Export settings without characters, chats or inlay images. Modules, plugins, prompt presets, personas, lorebooks, theme and API keys are all included. Use this to seed a new instance.",
    backupSettingsOnlyEstimating: "Calculating size...",
    backupSettingsOnlyConfirm: (size: string) =>
        `Build a settings backup to carry over to a new instance. About ${size}.\n\n• Included: settings, API keys, modules, plugins, presets, personas, lorebooks, theme\n• Left out: characters, chat history, inlay images\n\nRestoring overwrites the existing data on that device. Prefer a fresh instance over one that already has characters.`,
    backupSettingsOnlyBreakdown: (
        baseSize: string,
        moduleCount: number,
        assetCount: number,
        moduleSize: string,
    ) =>
        `Build a settings backup to carry over to a new instance. Characters, chat history and inlay images are left out.\n\n• Settings, API keys, modules, plugins, presets, personas, lorebooks, theme: ${baseSize}\n• Module assets (${moduleCount} module(s), ${assetCount.toLocaleString()} images): ${moduleSize}\n\nLeaving the assets out still carries the modules themselves. Their images will be blank until you re-download those modules on the new instance.`,
    backupSettingsOnlyWithModuleAssets: (size: string) => `Include module assets (${size})`,
    backupSettingsOnlyWithoutModuleAssets: (size: string) => `Settings only (${size})`,
    backupSettingsOnlyModuleAssetsSkipped: "Settings backup saved.\n\n**Module assets were not included.** The restored instance will show your modules and their settings, but their images will be blank. Re-download those modules there to fill them back in.",

    relatedGithub: "GitHub",
    relatedGithubDesc: "Star this project to show your support.",
    relatedFeedbackForm: "Feedback Form",
    relatedFeedbackFormDesc: "Submit issues or share suggestions.",
    relatedContactEmail: "GitHub Issues",
    relatedContactEmailDesc: "Report a problem or contact the developer on GitHub.",
    relatedArcaLive: "ArcaLive Channel",
    relatedArcaLiveDesc: "Discuss with other users in the AI chat channel.",

    selectBotHint: "Select a bot to start chatting",
    recentChatsTitle: "Recent Chats",
    noRecentChatsDesc: "No conversations yet",
    hideRecentChats: "Hide conversation list",
    moveInsteadOfCopyOnCMPConvert: "Move Instead of Copy on CMP Convert",

    showRequestStatus: "Show request status",
    risuBardMemoryWiki: "BARDWIKI - RisuBard Memory",
    risuBardMemoryWikiDescription: "Inspect current memory and stage explicit writer changes for this chat.",
    risuBardSettings: {
    common: {
      title: "Common settings",
      description: "Configure chat responses, BardWiki analysis, arc plotting and writing, saves, and external exports in one place.",
        },
    },
    risuBardGrimoirePrompt: {
        title: "Grimoire prompts",
        description: "Manage the instruction used by AI metadata analysis. The working default is protected; duplicate it to customize it.",
        activePreset: "Active Grimoire prompt",
        current: "Current",
        builtin: "Protected default",
        protectedDescription: "This default is maintained by RisuBard and cannot be edited or deleted.",
        content: "Analysis instruction",
        contentHelp: "Runtime language and character facet guidance is inserted into the placeholders below.",
        placeholderHelp: "Available placeholders: {{metadata_language_instruction}}, {{filter_facet_instruction}}",
        openPreset: "Instruction presets",
    },
    promptOverlay: {
        tab: "Prompt block injector",
        title: "Prompt block injector",
        description: "Extract blocks whose names contain a chosen string, store them independently, and inject them at exact positions in the current preset.",
        collapseSetup: "Collapse injector settings",
        expandSetup: "Expand injector settings",
        applicationPreset: "Block injection preset",
        noApplicationPreset: "No saved injection preset",
        applicationPresetName: "Injection preset name",
        applicationPresetNamePlaceholder: "e.g. Block layout for Nureongi",
        saveNewPreset: "Save new",
        overwritePreset: "Overwrite",
        renamePreset: "Rename",
        deletePreset: "Delete",
        extractTools: "Block extraction tools",
        extractSourcePreset: "Installed preset to extract",
        noExtractSource: "Choose a preset",
        extractionText: "Name contains",
        extractionTextPlaceholder: "e.g. 📙",
        extract: "Extract as new set",
        appendToProfile: "Add to current set",
        extractHint: "Only blocks whose names contain the chosen string are extracted. The result is stored independently from the source preset.",
        profile: "Extracted blocks",
        noProfile: "Not used",
        profileName: "Extracted set name",
        profileNamePlaceholder: "Extracted set name",
        renameProfile: "Rename",
        deleteProfile: "Delete extracted set",
        confirmDeleteProfile: "Delete this extracted block set? Saved injection presets will be kept.",
        untitledPreset: "Untitled preset",
        includeToggles: "Include referenced toggles",
        includeTogglesHint: "Add only source toggles used by injected blocks to the sidebar",
        includeTogglesHelp: "Adds only toggle definitions referenced by injected blocks. The current preset wins when a key conflicts; disabling this composes the blocks without adding their toggles.",
        sourceBlocks: "Block injection mapping",
        sourceBlocksHint: "Skip each extracted block or place it before, instead of, or after a target block.",
        searchBlocks: "Search extracted blocks...",
        action: "Placement",
        targetBlock: "Target base block",
        editBlockContent: "Edit block content",
        newBlock: "New block",
        duplicateBlock: "Duplicate block",
        deleteBlock: "Delete block",
        confirmDeleteBlock: "Delete this extracted block?",
        moveBlockUp: "Move block up",
        moveBlockDown: "Move block down",
        moveBlockUpFive: "Move block up 5 positions",
        moveBlockDownFive: "Move block down 5 positions",
        blockToolbar: "Selected block tools",
        selectBlock: "Select block",
        copySuffix: "copy",
        blockHasNoEditableContent: "This block type has no editable text.",
        skip: "Skip",
        before: "Insert before",
        replace: "Replace",
        after: "Insert after",
        resultMap: "Block injection preview + editor",
        resultMapHint: "Review the mapped result and edit the content of base and injected blocks directly.",
        saveComposedAsNew: "Save as new",
        saveComposedAsNewHelp: "Save the final blocks and referenced toggles as a new prompt preset.",
        newPresetNamePrompt: "Enter a name for the new prompt preset.",
        savedAsNew: "Saved {name} as a new prompt preset.",
        overwriteOriginal: "Overwrite original",
        overwriteOriginalHelp: "Overwrite the current prompt preset with the final blocks and referenced toggles.",
        overwriteOriginalConfirm: "Overwrite the current prompt preset ‘{name}’ with the final block order? Extracted sets and saved injection presets will be kept.",
        overwrittenOriginal: "Overwrote the {name} prompt preset.",
        baseBlock: "Base block",
        replaced: "Replaced",
        emptyBlockContent: "This block has no displayable text content.",
        missingTarget: "Target block not found",
        missingTargets: "Extracted blocks with missing targets",
        resizePanels: "Resize block injection mapping and final order panels",
        resizeTopPanels: "Resize block extraction and injection preset panels",
        chooseProfile: "Choose extracted blocks",
        chooseProfileHint: "Extract blocks from an installed preset by name string, then select the extracted set to use.",
        noMatchingBlocks: "No extracted blocks match this view.",
        noTargetBlocks: "The current preset has no base blocks.",
        missingBlock: "Missing extracted block",
        untitledBlock: "Untitled block",
    },
    risuBardWikiPrompt: {
        title: "Wiki prompt presets",
        description: "Manage BardWiki event analysis, canonical writing, and response guidance for retrieved memory. Core contracts and runtime injection anchors are read-only.",
        audience: "Audience",
        activePreset: "Active Wiki prompt preset",
        current: "Current",
        createPreset: "New preset",
        newPresetName: "New Wiki prompt",
        presetCreated: "Wiki prompt preset created",
        addBlock: "Add user block",
        addResponseBlock: "Add response guidance block",
        newBlock: "New Wiki Guide block",
        enabled: "Enabled",
        stageBoth: "Analysis + canonical writing",
        stageAnalysis: "Analysis",
        stageCanonicalRewrite: "Canonical writing",
        stageResponse: "Response",
        writingSection: "Wiki writing blocks",
        writingSectionDescription: "Used only while analyzing confirmed turns and writing event or canonical documents.",
        responseSection: "Response guidance blocks",
        responseSectionDescription: "Injected only into replies where BardWiki sources were actually retrieved. These blocks do not change memory-writing rules.",
        promptingHelp: "Prompting help",
        helpTitle: "BardWiki prompting reference",
        helpDescription: "A friendly reference for prompt stages and the structured memory fields produced by analysis.",
        helpStagesTitle: "When is each block applied?",
        helpAnalysis: "The first pass that extracts events, changes, knowledge boundaries, and unresolved clues from a confirmed turn. Use it to say what analysis must not overlook.",
        helpCanonical: "The pass that updates long-lived character, place, item, and other canonical documents from analysis. Use it for document organization and current-state presentation.",
        helpResponse: "Applied while generating a new chat reply after relevant BardWiki documents are retrieved. Use it to guide interpretation and natural use of memory without inventing facts.",
        helpFieldsTitle: "Main analysis fields",
        helpSchemaAndTitle: "schemaVersion is the format version required by the program and is currently always 1. title is a short plain-text label identifying one event or change and must not contain Markdown.",
        helpEstablishedEvents: "Events that actually happened in confirmed narrative text, ordered in time. They should read as a coherent story by themselves and should not contain state-management notes or future tasks.",
        helpStateChanges: "A subject moving from a previous state to a current state, represented as subject / before / after. Use null for before when the evidence does not establish it.",
        helpCharacterKnowledge: "Separates objective facts from what a particular character directly knows, or what they believe regardless of whether it is true.",
        helpPersistentFacts: "Current facts that must remain true in later scenes, such as possessions, injuries, sealed conditions, locations, or ongoing restrictions.",
        helpOpenContinuity: "Unresolved questions, promises, dangers, or puzzle blanks needed for later consistency. It is not a place to promote a guessed answer into fact.",
        helpCanonicalCandidates: "Proposals for important new durable changes worth reflecting in long-term canon. They are not automatic write commands and should not be created for mere appearances or one-off actions.",
        helpBoundaryTitle: "The most important evidence boundary",
        helpBoundary: "Confirmed assistant narrative is event evidence. User instructions, discarded text, plans, and model guesses are not facts. Event documents hold detailed past evidence while canonical pages are compressed current state, so never fill omitted targets, locations, or causation from imagination.",
        helpProgramOwnedFields: "targetDocumentId, document IDs and paths, revisions, hashes, timestamps, source IDs, evidence metadata, and YAML frontmatter are program-owned. Do not ask the AI to invent or change them. confidence is a review warning signal, not permission to bypass storage safety.",
        helpExampleTitle: "Puzzle example",
        helpExample: "‘Left: sun · fire · baby / right: moon · water · blank’ is an observation. ‘If the rows are opposites, the blank may be a skull’ is an inference. An analysis block should preserve the layout and blank exactly; a response block can request relationship checking while forbidding the inference from being stated as established fact.",
        responseGuideInjection: "Wiki Prompt · response guidance",
        moveUp: "Move up",
        moveDown: "Move down",
        remove: "Remove",
        blockPlaceholder: "Tell the wiki-writing AI what this block must track or organize.",
        lockedInjectionDescription: "The Wiki Guide for the current scope is injected here at runtime.",
        lockedCoreDescription: "Required block that preserves RisuBard's evidence, analysis, and output contracts.",
        injectionTitle: "Wiki Guide Injection",
        injectionDescription: "Character instructions are applied first, followed by the current chat instructions. They are not added to chat-generation prompts.",
        characterGuide: "Character Wiki Guide",
        chatGuide: "This chat's Wiki Guide",
        characterGuidePlaceholder: "Required wiki tracking for every chat with this character",
        chatGuidePlaceholder: "Additional tracking required only in this chat",
        blockNames: {
            "core-evidence-contract": "Core · Evidence and fact boundary",
            "core-analysis-contract": "Core · Event analysis contract",
            "main-wiki-guide": "Main Wiki Guide",
            "default-puzzle-clue-tracker": "Puzzle & clue tracker",
            "default-puzzle-response-reasoning": "Puzzle relationship reasoning",
            "character-wiki-guide": "Character Wiki Guide Injection",
            "chat-wiki-guide": "Chat Wiki Guide Injection",
            "core-output-contract": "Core · Structured output contract",
        },
    },
    risuBardRecentMessages: "Analysis turns",
    risuBardResponseRecentMessages: "Response turns",
    risuBardResponseExcludeUsers: "Response user messages",
    risuBardIgnoreOocTurns: "Ignore <!-- OOC_turn -->",
    risuBardHideOocTurns: "Hide OOC turns in chat",
    risuBardAnalysisExcludeUsers: "Analysis user messages",
    risuBardTurnCanon: "This turn's canon",
    risuBardTurnCanonNoChanges: "No canonical documents changed this turn.",
    risuBardUndoTurnCanon: "Undo entire turn",
    risuBardUndoDocumentCanon: "Undo",
    risuBardCanonCreated: "Created",
    risuBardCanonUpdated: "Updated",
    risuBardCanonUndone: "Undone",
    risuBardCanonPreserved: "Preserved",
    risuBardCanonUndoConflictChanged: "Preserved because it was edited later",
    risuBardCanonUndoConflictMissing: "Skipped because the current document is missing",
    risuBardAnalysisTokenLimit: "AI analysis token limit",
    risuBardInquiryTargetTokenBudget: "Wiki inquiry token target",
    risuBardBardChanEnabled: "바드쨩 (Bard-chan)",
    risuBardBardChanModelMode: "Bard-chan model",
    risuBardBardChanModelAuxiliary: "Auxiliary model",
    risuBardBardChanModelMain: "Main model",
    risuBardInquiryEventTokenBudget: "Event evidence token budget",
    risuBardInquirySourceTokenBudget: "Per-source inquiry token limit",
    risuBardInquiryMaximumTokenBudget: "Wiki inquiry absolute token limit",
    risuBardInquiryTimeoutMs: "Wiki inquiry timeout (ms)",
    risuBardHistoricalSourceMatchLimit: "Maximum historical excerpts",
    risuBardAdditionalSearchLimit: "Additional search limit when candidates are insufficient",
    risuBardCanonicalTargetLimit: "Automatic canonical targets per analysis",
    risuBardCanonicalWritingStyle: "Canonical writing style",
    risuBardWikiWritingLanguage: "Wiki writing language",
    risuBardWikiLanguageGlobal: "Use common setting",
    risuBardGrimoireSettings: "Grimoire options",
    risuBardGrimoireLanguage: "Metadata language",
    risuBardGrimoireLanguageDescription: "Controls the language used for aliases, tags, summaries, facets, atoms, and link descriptions created by Grimoire AI analysis.",
    risuBardGrimoireLanguageFollowWiki: "Follow BardWiki",
    risuBardGrimoireLanguageEnglish: "English",
    risuBardGrimoireLanguageKorean: "Korean",
    risuBardGrimoireLanguageBilingual: "English + Korean",
    risuBardGrimoireInstruction: "Active analysis instruction",
    risuBardGrimoireInstructionDescription: "Preview of the active Grimoire prompt. Edit a duplicated preset from the Grimoire prompts page; runtime slots are filled before source lore is appended.",
    risuBardCanonicalStyleStandard: "Standard",
    risuBardCanonicalStyleConcise: "Concise",
    risuBardCanonicalStyleUltraConcise: "Ultra concise",
    risuBardCanonicalStyleCustom: "Custom",
    risuBardCanonicalCustomStyle: "Custom canonical style instruction",
    risuBardMarkdownWriterTitle: "Wiki Workbench",
    risuBardMarkdownWriterDescription: "Draft one focused canonical-page change, then approve it explicitly.",
    risuBardMarkdownWriterTarget: "Canonical page",
    risuBardMarkdownWriterNew: "New page",
    risuBardMarkdownWriterType: "Page type",
    risuBardMarkdownWriterName: "Page title",
    risuBardMarkdownWriterEvidence: "Evidence document",
    risuBardMarkdownWriterPlaceholder: "Example: Update Lavian's current condition after this battle.",
    risuBardMarkdownWriterDraft: "Editable Markdown draft",
    risuBardMarkdownWriterApprovalHint: "Nothing is written until you approve this draft.",
    risuBardMarkdownWriterDraftFailed: "Could not draft the wiki page.",
    risuBardMarkdownWriterSaveFailed: "Could not save the wiki page.",
    risuBardMarkdownWriterSaved: "Canonical wiki page saved; the previous revision remains recoverable.",
    risuBardCurrentSnapshot: "Current snapshot",
    risuBardActiveFacts: "Active facts",
    risuBardEvents: "Events",
    risuBardInvalidatedFacts: "Invalidated facts",
    risuBardMemoryEmpty: "No RisuBard memory has been created for this chat yet.",
    risuBardMemoryLoadFailed: "Could not load this chat's memory.",
    risuBardMemoryRefresh: "Refresh",
    risuBardMemoryOpenManual: "Open BARDWIKI",
    risuBardAutoWiki: "Write BardWiki automatically after message generation",
    risuBardAutoWikiOn: "Automatic BardWiki writing on",
    risuBardAutoWikiOff: "Automatic BardWiki writing off",
    risuBardWikiCancel: "Cancel BardWiki task",
    risuBardMemoryForceUpdate: "Additional analysis",
    risuBardMemoryForceUpdating: "Analyzing unprocessed items...",
    risuBardMemoryForceUpdateDone: "Additional analysis completed, excluding canon already applied.",
    risuBardMemoryForceUpdateMeta: (turn: number, time: string) => `Analyzed through AI turn ${turn.toLocaleString()} · Updated: ${time}`,
    risuBardMemoryForceUpdateEmpty: "There is no latest AI response to analyze further.",
    risuBardMemoryForceUpdateFailed: "Additional analysis failed. Check the activity log.",
    risuBardWikiReboot: "Reboot wiki",
    risuBardWikiRebootDescription: "Rebuild BardWiki from a selected chat index through the present.",
    risuBardWikiRebootStop: "Stop reboot",
    risuBardWikiRebootStopping: "Stopping…",
    risuBardWikiRebootResume: "Resume reboot",
    risuBardWikiRebootFinalizing: "Replacing…",
    risuBardWikiRebootProgress: (completed: number, total: number, percent: number) => `${completed.toLocaleString()}/${total.toLocaleString()} turns · ${percent.toLocaleString()}%`,
    risuBardWikiRebootCancel: "Cancel reboot",
    risuBardWikiRebootCancelDescription: "Discard the staging wiki and keep the existing wiki.",
    risuBardWikiRebootWarning: "BardWiki will be rebuilt from the selected chat index. New responses are unavailable until it finishes, and the existing wiki remains in place until the final replacement. Continue?",
    risuBardWikiRebootCancelWarning: "Discard the staging wiki and cancel the reboot? The existing wiki will remain unchanged.",
    risuBardWikiRebootChooseTitle: "Choose reboot batch size",
    risuBardWikiRebootChooseDescription: "Choose how many conversation turns each analysis should include.",
    risuBardWikiRebootStartChatIndex: "Starting chat index",
    risuBardWikiRebootStartChatIndexHint: (lastIndex: number) => `Message index from 0 to ${lastIndex.toLocaleString()}. Choosing a user message starts with the following AI response.`,
    risuBardWikiRebootTokenBudget: (tokens: number) => `Current AI analysis token limit: ${tokens.toLocaleString()} tokens. Canonical update batches are automatically split by document when they are expected to exceed this limit.`,
    risuBardWikiRebootOneTurn: "1-turn updates",
    risuBardWikiRebootOneTurnSummary: "Better precision and failure isolation",
    risuBardWikiRebootOneTurnTooltip: "Pro: better per-turn precision and recovery. Con: more model calls and token usage.",
    risuBardWikiRebootTwoTurn: "2-turn updates",
    risuBardWikiRebootTwoTurnSummary: "Fewer calls and less repeated context",
    risuBardWikiRebootTwoTurnTooltip: "Pro: fewer semantic-analysis calls and repeated prompt tokens. Canonical updates may still use separate calls. Con: more content per analysis can slightly reduce detail precision.",
    risuBardWikiRebootChatLocked: "New responses are unavailable until the BardWiki reboot finishes or is canceled.",
    risuBardWikiGenerationChatLocked: "New responses are unavailable until the BardWiki update finishes.",
    risuBardGraphCurrent: "Current graph",
    risuBardGraphNodes: "nodes",
    risuBardGraphRelations: "relations",
    risuBardMemoryFallback: "Compatibility view",
    risuBardMemoryFallbackDescription: "The current graph cache is unavailable, so the safe v1 ledger is shown.",
    risuBardGraphSearch: "Search memory…",
    risuBardGraphSearchLabel: "Search narrative nodes",
    risuBardGraphKindLabel: "Node kind",
    risuBardGraphStatusLabel: "Node status",
    risuBardGraphAllKinds: "All kinds",
    risuBardGraphAllStatus: "All status",
    risuBardGraphCharacters: "Characters",
    risuBardGraphStates: "States",
    risuBardGraphClaims: "Claims",
    risuBardGraphThreads: "Threads",
    risuBardGraphActive: "Active",
    risuBardGraphResolved: "Resolved",
    risuBardGraphInvalidated: "Invalidated",
    risuBardGraphSuperseded: "Superseded",
    risuBardGraphBounded: "View bounded for clarity",
    risuBardGraphNoMatches: "No matching narrative nodes",
    risuBardGraphPerspective: "Perspective",
    risuBardGraphEpistemic: "Epistemic",
    risuBardGraphSalience: "Salience",
    risuBardGraphRevision: "Revision",
    risuBardGraphNoRelations: "No visible relations",
    risuBardGraphEvidence: "Evidence",
    risuBardGraphSelectNode: "Select a node to inspect its context.",
    risuBardGraphMapView: "Graph map",
    risuBardGraphWikiView: "Wiki index",
    risuBardGraphCenter: "Center canvas",
    risuBardGraphPanHint: "Drag empty space to move the canvas",
    risuBardGraphWikiIndex: "Memory index",
    risuBardWriterTitle: "Writer's Room",
    risuBardWriterDescription: "Promote an existing mention into a canonical character. Nothing is saved before approval.",
    risuBardWriterCollapse: "Collapse Writer's Room",
    risuBardWriterExpand: "Open Writer's Room",
    risuBardWriterSource: "Source mention",
    risuBardWriterInstruction: "Direction for the writing assistant",
    risuBardWriterInstructionPlaceholder: "Example: Name her Eliana, the princess of a fallen kingdom.",
    risuBardWriterDraft: "Draft with AI",
    risuBardWriterName: "Character name",
    risuBardWriterSummary: "Canonical summary",
    risuBardWriterSalience: "Narrative importance",
    risuBardWriterPreview: "Preview changes",
    risuBardWriterApply: "Approve and save",
    risuBardWriterProposal: "Staged change",
    risuBardWriterNoSources: "No active event or claim can be promoted yet.",
    risuBardWriterSaved: "Character promotion saved.",
    risuBardWriterDraftFailed: "Could not create the writer draft.",
    risuBardWriterApplyFailed: "Could not save the writer change.",
    requestStatus: {
        connecting: "Connecting…",
        thinking: "Thinking…",
        responding: "Responding…",
        retrying: "Retrying…",
        stalled: "Stalled…",
        background: "In background…",
        done: "Done",
        failed: "Failed",
        aborted: "Cancelled",
        kindMain: "Main",
        kindTranslate: "Translate",
        kindMemory: "Memory",
        kindEmotion: "Emotion",
        kindSub: "Sub",
        outputTokens: "out",
        thinkingTokensLabel: "think",
        tokensPerSec: "tok/s",
        cacheHit: "Cache hit · {n} tokens",
        close: "Close",
        injectedContext: "Injected context",
        totalInputTokens: "Total input",
        estimatedInputTokens: "Estimated input",
        tokenUnit: "tokens",
        injectionKinds: {
            systemPrompt: "System prompt",
            jailbreak: "Jailbreak prompt",
            globalNote: "Global note",
            authorNote: "Author's note",
            character: "Character details",
            persona: "Persona",
            lorebook: "Lorebook",
            grimoire: "Grimoire",
            grimoireRequired: "Grimoire (required)",
            wiki: "BardWiki",
            memory: "Memory",
            exampleDialogue: "Example dialogue",
            chatHistory: "Chat history",
            instruction: "Additional instruction",
            tool: "Tool result",
            other: "Other context",
        },
    },

} satisfies I18nTranslation;

type I18nTranslationFunction = (...args: any[]) => string;

type I18nTranslation = {
    [key: string]: string | I18nTranslation | string[] | I18nTranslationFunction
}
